export default [["en-us", {
  "account_linking": {
    "accept_terms": "PROCEED TO ADD LOANS",
    "account_information": "Confirm account information.",
    "add_a_student_loan_account": "Add A Student Loan Account",
    "add_account": "Add Account",
    "balance": "Balance",
    "continue_to_enrollment": "Continue to Enrollment",
    "default": "Account Added Confirmation",
    "heading": "Congratulations! Your student loan accounts have been added successfully with Tuition.io. You can add additional accounts at any time from the dashboard.",
    "linking_process": "Some information, like interest rate and minimum monthly payment, may take up to 24 hours to appear. So come visit us tomorrow!",
    "loan_name": "Loan Name",
    "loan_number": "Loan Number",
    "no_active_loans": "There are no active loans associated with this account",
    "service_provider": "Loan Servicer",
    "summary": "Summary"
  },
  "account_transaction": {
    "amount": "Amount",
    "transaction_date": "Date",
    "transaction_type": "Type",
    "transaction_types": {
      "ambiguous": "Ambiguous",
      "interest": "Interest",
      "payment": "Payment"
    }
  },
  "accounts": {
    "account_balance": "Account Balance",
    "account_details": "Account Details",
    "account_number": "Account Number",
    "address": "Address",
    "amount_of_debt": "Amount of debt",
    "balance": "Balance",
    "date_as_of": "Balance date",
    "enter_servicer": "Enter Servicer",
    "for_account": "Account: ",
    "historical_account_trend": "Historical Account trend",
    "historical_loan_trend": "Historical loan trend",
    "interest_due": "Interest Due",
    "interest_total": "Interest Total",
    "last_update": "Last Update",
    "last_updated": "Last Update Attempt",
    "loan_id": "Loan ID",
    "monthly_payment": "Monthly Payment",
    "my_accounts": "My Accounts",
    "my_documents": "My Documents",
    "number_of_loans": "Number of Loans",
    "original_amount": "Amount originally borrowed",
    "paid_in_full": "Paid in full",
    "paid_off_loans": "Paid off loans",
    "payment_details": "Payment Details",
    "plan_info": "Your Repayment Plan determines how much and for how long you have to pay back your loans. Federal loans offer different types of repayment plans such as the Standard 10 year repayment plan or Income-Driven plans like REPAYE, PAYE, IBR, and ICR. Use our Strategy Finder tool to find the best plan for you.\n",
    "principal": "Principal",
    "principal_and_interest": "Principal &amp; Interest",
    "principal_remaining": "Principal Remaining",
    "principal_total": "Principal Total",
    "rate_info": "Interest rate determines how much money you have to pay back in addition to the amount of money you borrowed. Higher interest rate loans are more expensive.\n",
    "repayment_plan": "Repayment Plan",
    "school": "School",
    "servicer": "Servicer",
    "status_info": "Status is the current payment state of your loan. Some examples include: In Repayment, Deferment, Forbearance, In-grace period, and Defaulted\n",
    "sub_total": "Sub-Total:",
    "total_balance": "Total Balance",
    "total_paid": "Total Paid",
    "type_info": "Federal loan types include names like Direct Stafford Subsidized, FFEL Stafford Unsubsidized, and Perkins. The type of federal loan you have depends on when you took out your loan and your particular situation. You can learn more about types of student loans in our ‘Questions You Have’ content.\n",
    "updated_date": "Updated Date"
  },
  "action_cannot_be_undone": "This action cannot be undone.",
  "and": "and",
  "application_page_title": "Tuition.io",
  "april": "April",
  "askjeni": {
    "about": {
      "ask_coaches_link_text": "Ask a student loan coach for help",
      "ask_our_coaches": "Ask our student loan coaches for help",
      "chat_link_text": "Chat with us",
      "coach_blog_link_text": "Check out the Student Loan Coach Blog",
      "coaches_info_1": "Our student loan coaches can answer your most pressing questions about student loan debt and repayment.",
      "coaches_info_2": "You can choose email a coach for the fastest reply time or schedule a phone call if you are able to wait until the next available appointment time that meets your schedule (typically within 5 days), whichever you prefer.",
      "get_support": "Get program support",
      "how_can_we_help_a": "We know that navigating student loans and repayment strategies can feel like an endless maze. We have a team of real student loan coaches ready to guide you through your different options, based on your goals and needs.",
      "how_can_we_help_q": "How can we help you?",
      "learn_about_coaches": "Learn about our coaches",
      "learn_coaches_info_1": "Our coaches are real people, with their own history of funding education and paying back student loans. We know the repayment process is confusing so we’re here to give you a little help finding the best strategy for your situation.",
      "learn_coaches_info_2": "Tuition.io coaches complete training specifically tailored to support student loan borrowers. The program was designed by Jeni Burckart, a recognized expert and author on student loan debt. Team members are trained on topics including how to choose a repayment plan, loan forgiveness options, pros and cons of refinancing, and a range of other topics commonly raised by student loan borrowers.",
      "learn_coaches_info_3": "We’re here to provide you the best information available so you can make the choice that’s right for you. Tuition.io coaches offer information and educational assistance but do not make specific financial recommendations.",
      "previous_questions": "See previously asked questions",
      "questions_info": "The Tuition.io Student Loan Coaching Team gets a lot of questions from real people who are curious about their options, or struggling with student loan debt. While we understand that each person and each family’s situation is unique, it can be helpful to read about student loans from different perspectives. Check out our blog on Tuition.io. (All submissions have been anonymized for privacy reasons.)",
      "support_info_pt1": "Curious about your company’s Tuition.io program? Want to confirm your eligibility? If you have questions about your Tuition.io program, you can contact us through",
      "support_info_pt2": "<span class=\"{class}\">email</span><span>, </span><span class=\"{class}\">phone</span><span>, or </span><span class=\"{class}\">live chat</span><span>.</span>",
      "support_info_pt3": "We are available Mondays through Friday, 5am-5pm PST. If it’s after hours, leave a message and we will get back to you the next business day.",
      "tab_title": "About"
    },
    "schedule_time": {
      "answer_questions": "Answer a few questions so our student loan coaches can give you the best options for your unique situation.",
      "be_detailed": "It helps to be as detailed as possible so our student loan coach can make the best use of your time.",
      "calendly_error": "There was an error loading the scheduling calendar",
      "can_you_afford": "Can you afford your monthly payments?",
      "current_plan": "What is your current payment plan?",
      "email": "Email - You don't need to schedule a time for email. We'll email you back within one business day.",
      "enter_email": "Enter your email address",
      "goal_choice_1": "Pay off my loans as quickly as possible",
      "goal_choice_2": "Have a lower payment, even if it takes longer to repay",
      "have_choice_1": "Federal student loans",
      "have_choice_2": "Private student loans",
      "have_choice_3": "A mix of federal and private loans",
      "have_choice_4": "I don't have any student loans",
      "kind_of_session": "What kind of session would you like to schedule with a student loan coach?",
      "no": "No",
      "phone": "Phone call",
      "speak_about": "What would you like to speak with a student loan coach about?",
      "submission_error": "There was an error submitting your scheduling request",
      "submission_success": "Request submitted successfully!",
      "tab_title": "Schedule Time",
      "what_goal": "What is your repayment goal?",
      "what_have_you": "What type of student loans do you have?",
      "yes": "Yes"
    },
    "student_loan_coaches": "Student Loan Coaches"
  },
  "attachments": "Attachments",
  "august": "August",
  "auth": {
    "failed": {
      "instructions": "An authentication error occurred. Please sign in again.",
      "sign_in_button": "Sign In",
      "title": "Authentication Failed"
    },
    "session_expiring": {
      "logout_button": "Log Out",
      "message": "For your security, this session will expire in {time}.",
      "renew_button": "Stay Signed In",
      "title": "Session Expiring"
    }
  },
  "back": "Back",
  "benefits": "Benefits",
  "cancel": "Cancel",
  "choose_file": "Choose File",
  "click_here": "Click Here",
  "click_here_lowercase": "click here",
  "click_here_to_view": "Click here to view",
  "close": "Close",
  "comment": "Comment",
  "common": {
    "accounts": {
      "account_and_loan_details": "Account & Loan Details",
      "active_accounts": "Active Accounts",
      "add_account": "Add Account",
      "change_modal": {
        "change_account": "This change will be applied to the first available contribution period (any contribution that is already in pending status or later cannot be changed).",
        "error": "There was an error updating the account receiving contributions",
        "success": "Successfully Updated Account Receiving Contributions",
        "title": "Account Receiving Contributions"
      },
      "default": "Accounts",
      "delete": "Delete Account",
      "delete_contributions_disclaimer": "This account is currently set to receive contributions. Once deleted, contributions will be directed to the next valid account. You can change this by clicking 'Update Contributions' at the top of the page.",
      "delete_modal_body": "Are you sure you want to delete this account?<br />This action is irreversible and should only be used for accounts that were added by mistake. Do not use it for accounts that are fully paid. Generally, this action is not recommended. If you are unsure, please contact support.",
      "inactive_accounts": "Inactive Accounts",
      "interest_due": "{interestPercentage}% ({interestDue} Due)",
      "mark_paid": "Mark Paid",
      "mark_paid_contributions_disclaimer": "This account is currently set to receive contributions. Once marked as paid, contributions will be directed to the next valid account. You can change this by clicking 'Update Contributions' at the top of the page.",
      "mark_paid_modal_body": "Are you sure you want to mark this account paid? <br /> This action cannot be undone.",
      "no_accounts": "No Accounts",
      "paid_accounts": "Paid Accounts",
      "receiving_contributions": "Receiving Contributions",
      "total_active_accounts": "Total Active Accounts",
      "total_active_loans": "Total Active Loans",
      "total_balance": "Total Balance",
      "update_contributions": "Update Contributions",
      "update_snapshot": "Update Snapshot",
      "weighted_interest_rate": "Weighted Interest Rate"
    },
    "action": "Action",
    "active": "Active",
    "add": "Add",
    "add_comment": "Add Comment",
    "add_note": "Add Note",
    "address": "Address",
    "agents": {
      "agencies": "Agencies",
      "email": "Email"
    },
    "also_viewing": "Also Viewing:",
    "annual": "Annual",
    "application": "Application",
    "approval": "Approval",
    "attachment_requirements": "Attachment Requirements",
    "back": "Back",
    "cancel": "Cancel",
    "certificate_status_message": {
      "to": {
        "TAS": {
          "ApplicationState": {
            "ABANDONED": "Closed By System",
            "ATTEND": "In Progress",
            "COURSES_APPROVED": "Application Approved",
            "COURSES_NOT_APPROVED": "Need Info",
            "COURSES_REJECTED": "Application Rejected",
            "CREATED": "Started",
            "DEFINE_COURSES": "In Draft",
            "EVIDENCE_APPROVED": "Evidence Approved",
            "EVIDENCE_NOT_APPROVED": "Needs Info",
            "EVIDENCE_REJECTED": "Evidence Rejected",
            "FULFILLED": "Complete",
            "PENDING_COURSES_APPROVAL": "Submitted for Approval",
            "PENDING_EVIDENCE_APPROVAL": "Submitted For Evidence Approval",
            "UPDATED_ON": "Updated"
          }
        }
      }
    },
    "change_plan": "Change Plan",
    "close": "Close",
    "comment": "Comment",
    "confirm": "Confirm",
    "continue": "Continue",
    "date": "Date",
    "default": "Default",
    "delete": "Delete",
    "description": "Description",
    "details": "Details",
    "download": "Download",
    "edit": "Edit",
    "eligibility_file_upload": {
      "preview": "Preview",
      "processed": "Processed",
      "status": {
        "ABORTED_AS_DUPLICATE": "Aborted as Duplicate",
        "ABORTED_BY_ADMIN": "Aborted by Admin",
        "ABORTED_BY_REVIEWER": "Aborted by Reviewer",
        "ABORTED_BY_USER": "Aborted by User",
        "ABORTED_FOR_STALENESS": "Aborted for Staleness",
        "ALL": "All",
        "COMPLETED": "Completed",
        "ERROR_REPORTED": "Error Reported",
        "EXECUTING_TASKS": "Processing",
        "FAILED_VALIDATION": "Failed Validation",
        "QUEUED": "Queued",
        "QUEUED_OFFHOURS": "Queued (Off Hours)",
        "REQUIRES_REVIEWER_APPROVAL": "Ready for Processing (Reviewer Approval)",
        "REQUIRES_USER_APPROVAL": "Ready for Processing (User Approval)",
        "STARTED": "Started",
        "VALIDATING_ELIGIBILITY_FILE": "Validating Eligibility File",
        "WAITING_FOR_UPLOAD": "Waiting for Upload"
      }
    },
    "email": "Email",
    "email_history": "Email History",
    "employee": {
      "created_on": "Created on",
      "deactivated": "Deactivated",
      "deactivated_on": "Deactivated on",
      "employee_email": "Employee Email",
      "enrolled_on": "Enrolled on",
      "participating": "Participating",
      "payroll_id": "Payroll ID",
      "pending": "Pending",
      "plan": "Plan"
    },
    "employee_details": "Employee Details",
    "employees": {
      "fields": {
        "contribution_amount": "Contribution Amount",
        "contribution_plan_key": "Contribution Plan Key",
        "employee_id": "Employee ID",
        "payroll_id": "Payroll ID",
        "revert_disclaimer": "Remove override and value will be reverted to eligibility file on the next refresh.",
        "revert_success": "Successfully reverted {field}",
        "update_error": "There was an error updating {field}",
        "update_override_disclaimer": "Editing fields will override any future eligibility file updates.",
        "update_success": "Successfully updated {field}"
      }
    },
    "employment_end_date": "Employment End Date",
    "employment_start_date": "Employment Start Date",
    "employment_status": "Employment Status",
    "forgiveness_estimator": {
      "afford_payments": "Are you able to afford your monthly payments currently?",
      "annual_income": "Annual Income ($)",
      "annual_income_tooltip": "For the most accurate results, refer to the line 11 on your federal tax return (1040) or enter the value from box 1 on your (and spouse's if filing jointly) W-2. For approximate results, enter your annual salary.",
      "before_2007": "Do you have student loans taken out before October 1, 2007?",
      "gradOnly": "Graduate",
      "grad_or_undergrad": "Were your loans used for an Undergraduate or Graduate Degree?",
      "see_results": "See Results",
      "undergradGrad": "Mix of both",
      "undergradOnly": "Undergraduate"
    },
    "frequently_asked_questions": "Frequently Asked Questions",
    "full_time": "Full Time",
    "goto_next_page": "Goto next page",
    "goto_previous_page": "Goto previous page",
    "history": "History",
    "id": "Id",
    "inactive": "Inactive",
    "institutions": "Institutions",
    "interest": "Interest",
    "key": "Key",
    "last": "Last",
    "learn_more": "Learn More",
    "loan": "Loan",
    "name": "Name",
    "next": "Next",
    "no": "No",
    "no_data": "No Data",
    "no_finder_sessions": "No strategy finder sessions",
    "no_notes_found": "No notes found",
    "no_records_found": "No records found",
    "none": "None",
    "not_applicable": "N/A",
    "not_provided": "Not provided",
    "note": "Note",
    "notifications": "Notifications",
    "object_diff": "Object Diff",
    "observability": {
      "document": {
        "summary": {
          "account": "Account: ",
          "balance": "Current Balance: ",
          "header": "Loan Account Information",
          "loans": {
            "balance": "Balance",
            "name": "Loan",
            "originated": "Originated"
          },
          "partially_applied": "Loan Account needs further review. Please allow 2-3 business days while we verify this information.",
          "servicer": "Loan Servicer: "
        }
      },
      "documents": {
        "headers": {
          "filename": "Document",
          "provider": "Type",
          "status": "Status",
          "submitted": "Submitted"
        },
        "title": "Loan Documents",
        "total": "{count, plural,\n  one { Document }\n  other { Documents }\n}"
      },
      "loan": "Loan",
      "rerun": "Rerun"
    },
    "observable_document": {
      "provider": "Provider"
    },
    "on": "On",
    "order": "Order",
    "override": "Override",
    "pagination_navigation": "Pagination Navigation",
    "part_time": "Part Time",
    "payment_state": "Payment State",
    "payment_transactions": "Payment Transactions",
    "people": "People",
    "plans": "Plans",
    "previous": "Previous",
    "print": "Print",
    "profile": {
      "role_delegation": {
        "add_delegation": "Add Delegation",
        "date_assigned": "Date Assigned",
        "date_expires": "Date Expires",
        "default": "Role Delegation",
        "delegate_name": "Delegate Name",
        "description": "Please note that selecting the employee here will take over approval work from the existing employee until the end date you select.",
        "none_delegated": "This employee has not delegated any roles to anyone.",
        "relationship_type": "Relationship Type",
        "status": "Status"
      }
    },
    "program_builder_review": "Program Builder Review",
    "program_review": "Program Review",
    "progress_tracker": {
      "action_requested": "Action Requested",
      "action_requested_by": "Action has been requested by your",
      "add_course_details": "Add Course Details",
      "application_approval": "Application Approval",
      "application_process": "Application Process",
      "application_rejected": "Application Rejected",
      "application_submitted": "Application Submitted",
      "attend_course": "Attend Course",
      "attend_program": "Attend Program",
      "attended_course": "Attended Course",
      "complete_education": "Complete Education",
      "completed": "Completed",
      "completion_evidence_approval": "Completion Evidence Approval",
      "completion_evidence_approved": "Completion Evidence Approved",
      "completion_evidence_rejected": "Completion Evidence Rejected",
      "course_evidence_approval": "Course Evidence Approval",
      "course_evidence_approved": "Course Evidence Approved",
      "course_evidence_rejected": "Course Evidence Rejected",
      "courses_approved": "Courses Approved",
      "created": "Created",
      "default": "Progress Tracker",
      "draft": "Draft",
      "enrolled": "Enrolled",
      "evidence_approval": "Evidence Approval",
      "final_reimbursement": "Final Reimbursement",
      "full_history": "Full History",
      "in_progress": "In Progress",
      "mark_program_complete": "Mark Program Complete",
      "no_details": "No details to show",
      "pending": "Pending",
      "program_application_submitted": "Program Application Submitted",
      "program_approval": "Program Approval",
      "program_attended": "Program Attended",
      "program_completed": "Program Completed",
      "program_in_progress": "Program In Progress",
      "program_initiated": "Program Initiated",
      "program_progress": "Program Progress",
      "program_withdrawn": "Program Withdrawn",
      "reimbursement": "Reimbursement",
      "start_application": "Start Application",
      "start_program": "Start Program",
      "submit_application": "Submit Application",
      "submit_completion_evidence": "Submit Completion Evidence",
      "submit_course_evidence": "Submit Course Evidence",
      "submit_education_information": "Submit Education Information",
      "submit_evidence": "Submit Evidence",
      "submit_for_approval": "Submit For Approval",
      "submit_grades": "Submit Grades",
      "submitted_completion_evidence": "Submitted Completion Evidence",
      "submitted_course_evidence": "Submitted Course Evidence",
      "submitted_withdrawal_request": "Submitted Withdrawal Request",
      "view_application": "View Application",
      "withdrawal_approved": "Withdrawal Approved",
      "withdrawal_rejected": "Withdrawal Rejected"
    },
    "prompt": "Prompt",
    "pslf": {
      "date_borrower_signed": "Date Borrower Signed",
      "date_employer_signed": "Date Employer Signed",
      "document_repo": {
        "classification": {
          "default": "Classification",
          "pslf_form": "PSLF Form",
          "pslf_letter": "Letter from the U.S. Department of Education",
          "pslf_loan": "Student loan statement",
          "pslf_or_ecf_form": "PSLF form (Previously ECF form)",
          "pslf_other": "Other"
        },
        "description": "Description",
        "no_documents_found": "No documents found",
        "uploaded_at": "Uploaded at"
      },
      "employment_dates": "Employment Dates",
      "form-type": {
        "currentEmployer": "Current Employer",
        "priorEmployer": "Prior Employer"
      },
      "forms": {
        "alternate_phone": "Alternate Phone",
        "approver": "Approver",
        "auto": "Auto",
        "borrower_header": "Borrower Fields",
        "borrower_sign_date": "Borrower Sign Date",
        "contact_name": "Contact Name",
        "contact_phone": "Contact Phone",
        "contact_title": "Contact Title",
        "date_of_birth": "Date of Birth",
        "date_of_signature": "Date of Signature",
        "doc_id": "Document ID",
        "employer": "Employer",
        "employer_closed": "Employer is closed or refuses to certify",
        "employer_email": "Employer Email",
        "employer_fein": "Employer FEIN",
        "employer_name": "Employer Name",
        "employer_sign_date": "Employer Sign Date",
        "employer_website": "Employer Website",
        "fax_id": "Fax ID",
        "fein": "FEIN",
        "form_summary": "Form Summary",
        "form_type": "Form Type",
        "group_id": "Group ID",
        "has_changed_info": "Has Changed Contact Info",
        "primary_phone": "Primary Phone",
        "reason_for_submitting": "Reason for submitting",
        "still_employed": "Still Employed",
        "submitted_at": "Submitted At",
        "verified": "Verified",
        "website": "Website",
        "weekly_hours": "Weekly Hours"
      },
      "go_to_form_profile": "Go to Form Profile",
      "no_forms_found": "No forms found",
      "qualifying_payments": {
        "date_provided": "This information has been provided by your loan servicer as of {date}.",
        "default": "Qualifying Payments",
        "footnote_potentially_qualifying_count": "Potentially qualifying payments are payments you made that have not been officially counted for PSLF because you have not certified qualifying employment or did not meet other program requirements.",
        "footnote_qualifying_count": "Your qualifying payment count reflects the official count of your progress towards PSLF. It won't be updated until you submit a new PSLF form."
      },
      "status": {
        "awaiting_submit": "Awaiting Submit",
        "borrower_signed": "Borrower Signed",
        "cancelled": "Cancelled",
        "created": "Created",
        "employer_signed": "Employer Signed",
        "expired": "Expired",
        "needs_review": "Needs Review",
        "needs_tio_review": "Needs TIO Review",
        "re_submit_errored": "Resubmit Error",
        "re_submit_pending": "Reprocessing Fax",
        "re_submitted": "Resubmitted",
        "rejected": "Rejected",
        "submit_errored": "Error",
        "submit_pending": "Processing Fax",
        "submitted": "Submitted"
      },
      "view_pslf_profile": "View PSLF Profile"
    },
    "reason": "Please enter a reason for this change",
    "recommendations": {
      "date": "Date",
      "default": "Recommendations",
      "no_results": "No recommendations",
      "results": "Results",
      "type": "Type"
    },
    "remove": "Remove",
    "repayment": "Repayment",
    "repayment_plans": {
      "extendedPlan": "Extended",
      "fivePercentUndergrad": "Undergrad 5% Income Driven Repayment Plan",
      "graduated": "Graduated",
      "ibr": "Income Based Repayment Plan",
      "icr": "Income Contingent Repayment Plan",
      "noRepaymentPlan": "I haven't started yet",
      "paye": "Pay As You Earn",
      "refinancing": "Refinancing",
      "repaye": "SAVE (formerly REPAYE)",
      "standard": "Standard",
      "tenYearsStandard": "10 Year Standard Repayment Plan"
    },
    "reporting": {
      "all_approvers": "All Approvers",
      "all_employee_fields": "All Employee Fields",
      "application_approved_amount": "Application Approved Amount",
      "application_created_at_end": "to {createdAtEnd}",
      "application_creation_date": "Application Creation Date : From {createdAtStart}",
      "application_id": "Application ID",
      "application_state": "Application State",
      "applications": "Applications",
      "approver": "Approver",
      "approver_id_filter": "Approver ID Filter",
      "course_begin_date": "Course Begin Date",
      "course_date_range": "Course Date Range: From {beginDate}",
      "course_end_date": "Course End Date",
      "course_name": "Course Name",
      "course_number": "Course Number",
      "course_requested_amount": "Course Requested Amount",
      "courses_begin_date": "Courses Begin Date",
      "created_at": "Created At",
      "custom_fields_to_include": "Custom Fields to Include",
      "custom_fields_to_include_all": "Custom Fields to Include: All",
      "custom_program_template_fields": "Custom Program Template Fields",
      "default": "Reporting",
      "description": "Click a report name below to review contents.<br /> Each report offers a pre-configured set of fields which are pulled from our systems in real time, and can be downloaded in .csv format.",
      "employee_fields": "Employee Fields",
      "employee_id_filter": "Employee ID Filter",
      "evidence_approved_on": "Evidence Approved On",
      "exclude_term_verified": "Exclude Term Verified",
      "exclude_term_verified_yes": "Exclude Term Verified: Yes",
      "filter_by_approver": "Approver",
      "filter_by_employee": "Employee",
      "filter_by_program": "Program",
      "in_collections": "In Collections",
      "include_course_details": "Include Course Details",
      "include_courses_in_report_no": "Include Courses in the Report: No",
      "include_courses_in_report_yes": "Include Courses in the Report: Yes",
      "include_invoice_dates": "Include Invoice Dates: Yes",
      "include_payment_details": "Include Payment Details",
      "include_payments_in_report": "Include Payments in the Report: No",
      "include_payments_in_report_yes": "Include Payments in the Report: Yes",
      "include_terminated_employees": "Include Terminated Employees: Yes",
      "invoice_date": "Invoice Date",
      "loading": "Loading",
      "name": "Name",
      "or_created_not_specified": "or \"CREATED\" if not specified",
      "payment_amount": "Payment Amount",
      "payment_date": "Payment Date",
      "payment_fiscal_year": "Payment by Fiscal Year",
      "payment_state": "Payment State",
      "payroll_id": "Payroll ID",
      "program_template": "Program Template",
      "program_template_filter": "Program Template Filter",
      "report_type_application": "Report Type: Applications",
      "school": "School",
      "searched_applications_no_results_found": "You have searched for applications reports with the following criteria and found no results",
      "tas": {
        "applications": {
          "description": "General application reporting",
          "title": "Applications"
        },
        "courses": {
          "description": "Applications with courses in progress",
          "title": "Courses in progress"
        },
        "description": "Description",
        "invoice_date": {
          "description": "Applications with invoice date for the previous 30-day period.",
          "title": "Invoice date"
        },
        "missing_documentation": {
          "description": "Applications without evidence post-7 days of course end date",
          "title": "Missing documentation"
        },
        "payables": {
          "application_id": "Application ID",
          "approved_amount": "Approved Amount",
          "description": "Applications pending payment",
          "name": "Name",
          "no_results_found": "No results found",
          "payroll_id": "Payroll ID",
          "pre_approved_amount": "Pre Approved Amount",
          "program_name": "Program Name",
          "ready_for_payment": "Ready for Payment",
          "requested_amount": "Requested Amount",
          "school": "School",
          "title": "Ready for payment"
        },
        "payments": {
          "description": "Payments made grouped by fiscal year.",
          "title": "Payments by fiscal year"
        },
        "programs": {
          "description": "General program reporting",
          "title": "Programs"
        },
        "report_name": "Report Name",
        "terminated_employee": {
          "description": "Employees who have been terminated by date",
          "title": "Terminated employees"
        },
        "vouchers": {
          "description": "Voucher programs in attend pending payment flag",
          "title": "Voucher direct pay report"
        }
      },
      "term_verified_date": "Term Verified Date",
      "terminated_employees": "Terminated Employees",
      "termination_date": "Termination Date",
      "to_courses_endDate": "to {endDate}"
    },
    "reports": {
      "all_reports_link": "All Reports",
      "default": "Reports",
      "no_reports": "No reports are currently available",
      "titles": {
        "agent": "Agent Portal",
        "graph_age_band": "Graph - Age Band",
        "graph_group": "Graph - Group",
        "main_contribution": "Contribution",
        "main_wellness": "Wellness",
        "monthly_stats": "Monthly Statistics",
        "summary_group": "Summary Group",
        "untitled": "Untitled Report",
        "user_engagement": "Customer Engagement History"
      }
    },
    "request": "Request",
    "required": "Required",
    "resource": "Resource",
    "revert": "Revert",
    "save": "Save",
    "save_for_later": "Save for Later",
    "showing_of_results": "Showing <strong>{start}</strong> to <strong>{end}</strong> of <strong>{total}</strong> results",
    "sidebar": {
      "close": "Close Sidebar",
      "tio": "T.io"
    },
    "status": "Status",
    "status_message": {
      "to": {
        "SYF": {
          "EnrollmentState": {
            "COMPLETE": "Enrollment Completed",
            "DRAFT": "Enrollment in Draft",
            "MISSING_INFORMATION": "Enrollment Completed - Missing Information",
            "NOT_STARTED": "Enrollment Not Started"
          }
        },
        "TAS": {
          "ApplicationPaymentState": {
            "NONE": "None",
            "PAID_IN_FULL": "Paid",
            "PAID_IN_PART": "Paid in part (partial pay)",
            "REFUND_REQUESTED": "In Repayment",
            "UNPAID": "Unpaid"
          },
          "ApplicationState": {
            "ABANDONED": "Closed By System",
            "ATTEND": "Courses In Progress",
            "COURSES_APPROVED": "Course Application Approved",
            "COURSES_NOT_APPROVED": "Need Info",
            "COURSES_REJECTED": "Course Application Rejected",
            "CREATED": "Started",
            "DEFINE_COURSES": "In Draft",
            "EVIDENCE_APPROVED": "Evidence Approved",
            "EVIDENCE_NOT_APPROVED": "Needs Info",
            "EVIDENCE_REJECTED": "Evidence Rejected",
            "FULFILLED": "Complete",
            "PENDING_COURSES_APPROVAL": "Submitted for Course Approval",
            "PENDING_EVIDENCE_APPROVAL": "Submitted For Evidence Approval",
            "REJECTED_PER_POLICY": "Rejected Per Policy",
            "UPDATED_ON": "Updated"
          },
          "ProgramInstanceState": {
            "ABANDONED": "Closed By System",
            "COMPLETED": "Completed",
            "COMPLETION_APPROVED": "Program Completion Approved",
            "COMPLETION_NOT_APPROVED": "Needs Info Before Completion",
            "COMPLETION_REJECTED": "Rejected",
            "CREATED": "Created",
            "DRAFT": "Draft",
            "PENDING_COMPLETION_APPROVAL": "Submitted For Completion",
            "PENDING_PROGRAM_APPROVAL": "Pending Approval",
            "PENDING_WITHDRAWAL_APPROVAL": "Withdrawal Submitted",
            "PRIMED": "Approved",
            "PROGRAM_APPROVED": "Program Application Approved",
            "PROGRAM_NOT_APPROVED": "Needs Info",
            "PROGRAM_REJECTED": "Rejected",
            "UPDATED_ON": "Updated",
            "WITHDRAWAL_APPROVED": "Program Withdrawal Approved",
            "WITHDRAWAL_NOT_APPROVED": "Needs Info Before Withdrawal",
            "WITHDRAWAL_REJECTED": "Rejected",
            "WITHDRAWN": "Withdrawn"
          }
        }
      }
    },
    "strategy_finder": {
      "after_oct_1_2007": "After October 1, 2007",
      "at_least_ten": "I plan on staying in public service for at least 10 years.",
      "before_oct_1_2007": "Before October 1, 2007",
      "before_proceeding": "Before proceeding to the Strategy Finder",
      "check_applicable_employment_types": "What is your employment type? Check all that apply.",
      "complete": "Completing the short questionnaire below will help us provide the best repayment option for you.",
      "continue_to_sf": "Continue to Strategy Finder",
      "currently_working_toward": "Are you currently working towards loan forgiveness?",
      "default": "Strategy Finder",
      "details_blurb": "Our monthly payments and total payoff may change due to your personal details.",
      "details_to_calculate_payments": "Please enter your details to calculate estimated payments.",
      "family_size": "Family Size",
      "family_size_tooltip": "Your family size includes you, your spouse (if applicable), and your total number of dependents (if applicable).",
      "forgiveness_eligibility": "Some loan forgiveness plans have employer eligibility requirements.",
      "gov_blurb": "The US Department of Education (ED) announced a one time account adjustment that will help borrowers get closer to public service loan forgiveness. Note: you must consolidate FFEL loans before us 12/31/23 to receive the one time account adjustment.",
      "gov_how_long": "How long do you plan on working for a government / tribal organization / non-profit organization?",
      "gov_how_many_months": "Since October 1, 2007, about how many months have you worked for a government/tribal/nonprofit organization while making student loan payments?",
      "gov_pub_tribal_nonp": "Government / Public School / Tribal Organization or Non-Profit",
      "how_many_payments": "About how many qualifying payments have you made?",
      "icrConsolidationIncomeDrivenLoanForgiveness": "ICR Consolidation Income Driven Loan Forgiveness",
      "icrConsolidationPublicServiceLoanForgiveness": "Consolidation Income Contingent Repayment Plan PSLF",
      "icrPublicServiceLoanForgiveness": "Income Contingent Repayment Plan PSLF",
      "idr": "Income driven loan forgiveness",
      "if_public_school": "If your school is a public school, ALSO select the 'government ... non-profit organization' option",
      "lower_monthly": "To have a lower monthly payment now, but longer repayment term",
      "lower_monthly_blurb": "We know it can be difficult to afford your monthly payment, and we may be able to find you a lower payment.",
      "months_of_qualifying_payments": "Months of qualifying payments",
      "not_interested": "No, and I’m not interested",
      "not_yet": "Not yet, but I would like to learn more about loan forgiveness",
      "other_or_private": "Other/Private Sector",
      "paye": "Paye",
      "payeConsolidationPublicServiceLoanForgiveness": "Consolidation Public Service Loan Forgiveness",
      "payeIncomeDrivenLoanForgiveness": "Paye Income Driven Loan Forgiveness",
      "payePublicServiceLoanForgiveness": "Public Service Loan Forgiveness (PSLF)",
      "payeTeacherLoanForgiveness": "Teacher Loan Forgiveness TLF",
      "payments_since_94": "Since July 1, 1994, approximately how many months have you made payments on your current student loans?",
      "payoff_goal_blurb": "We know your financial picture is more than just your student loan debt, so letting us know your goal helps us choose the best options for you.",
      "payoff_quickly": "To pay off as quickly as possible",
      "please_complete": "Please complete all required fields before submitting.",
      "pslf_requires": "PSLF requires you to stay in public service for 10 years.",
      "recommendation_history": "Recommendation History",
      "repayeConsolidationIncomeDrivenLoanForgiveness": "Consolidation Income Driven Loan Forgiveness",
      "repayeConsolidationPublicServiceLoanForgiveness": "Consolidation Public Service Loan Forgiveness",
      "repayeConsolidationTeacherLoanForgiveness": "SAVE (formerly Repaye) Consolidation Teacher Loan Forgiveness",
      "repayeIncomeDrivenLoanForgiveness": "Income Based Repayment Plan IDLF",
      "repayePublicServiceLoanForgiveness": "Revised Pay As You Earn Repayment Plan PSLF",
      "state_of_residence": "State of residence",
      "strategy_finder_results": "Strategy Finder Results",
      "teacher_five_years": "I plan on staying a teacher for at least five consecutive years",
      "teacher_five_years_unlikely": "I probably won't be a teacher for at least five consecutive years.",
      "teacher_forgiveness_rec": "Teacher loan forgiveness requires you to be a teacher for five consecutive years.",
      "teacher_how_long": "How long do you plan on being a teacher?",
      "teacher_low_income": "Teacher in a low income school",
      "teachers_loan_forgiveness": "Teacher Loan Forgiveness",
      "tenYearsStandard": "Ten Years Standard",
      "tenYearsStandardTeacherLoanForgiveness": "Ten Years Standard Teacher Loan Forgiveness",
      "ten_years_unlikely": "I probably won’t stay in public service for at least 10 years",
      "we_will_not_be_able": "We will not be able to provide accurate recommendations since you have not added your accounts. Please return to the dashboard and add accounts.",
      "when_first_loan": "When was the first time you took out a federal student loan?",
      "which_program": "Which loan forgiveness program are you working towards?",
      "your_payment_and_sf_input": "Your Monthly Payment and Strategy Finder Input",
      "your_payoff_goal": "What is your payoff goal?"
    },
    "submit": "Submit",
    "submit_for_review": "Submit for Review",
    "success": "Success!",
    "tas": {
      "approval": {
        "default": "Approval",
        "request_summary": {
          "action_taken_by": "Action Taken By",
          "additional_amount_paid_to": "Additional amount paid to employee beyond previous payments.",
          "affected_reimbursment": "If you delete this request, the user will no longer be required to repayment the amount. Their reimbursement status may be affected.",
          "amount": "Amount",
          "amount_to_request_repayment": "Amount to request for repayment in addition to all other repayment requests.",
          "approved_total": "Approved Total",
          "approved_total_updated": "Approved Total Updated",
          "cancel_repayment": "Cancel Repayment",
          "change_amount": "Change Amount",
          "date": "Date",
          "default": "Request Summary",
          "delete_request": "Are you sure you want to delete this request?",
          "event_type": "Event Type",
          "forgive": "Forgive",
          "forgive_label": "Forgive",
          "make_payment_changes": "Make Payment Changes",
          "mark_as_paid": "Mark as Paid",
          "pay_more_label": "Pay More",
          "place_employee_hold": "Place employee on hold",
          "request_change": "Request Change",
          "request_details": "Request Details",
          "request_refund_description": "Request Refund - only available if application is paid or partially paid. Pay More - only available if there are no existing repayment.",
          "select_action": "Select an action, enter the relevant amount, and specify the reason in the comment section.",
          "update_request_details": "Update Request Details"
        }
      }
    },
    "terms_and_conditions": "Terms and Conditions",
    "trial": "Trial",
    "tuition_assistance": {
      "add_dependent_button": "Add Dependent",
      "add_dependent_modal": {
        "birth_date": "Birth Date",
        "first_name": "First Name",
        "header": "Add Dependent",
        "last_name": "Last Name",
        "relationship": "Relationship"
      },
      "an_error_occurred": "An error occurred. Unable to save.",
      "application_details": {
        "approved_amount": "Approved Amount",
        "approved_date": "Approved Date",
        "employee_pause_info": "An employee 'on hold' cannot move any applications forward. Uncheck the box below if you do not want to place {name} on hold.",
        "paid_amount": "Paid Amount",
        "paid_date": "Paid Date",
        "policy_override_confirm": "Confirm Policy Override",
        "policy_override_description": "Are you sure you want to ignore all policies for this application?",
        "policy_override_popover": "Enabling this option will override all policies previously set for this application. This action cannot be undone.",
        "policy_override_prompt": "Override",
        "policy_override_warning": "This action cannot be undone.",
        "repayment_request_info": "Request repayment if {name} did not satisfy {company} requirements to keep the previously prepaid/approved amount. After requesting repayment, {name} will be required to pay back money to {company}."
      },
      "applications": {
        "application_submitted": "Application Submitted",
        "forgive_button": "Forgive",
        "forgive_dialog": {
          "balance": "Repayment Balance",
          "employee_page_link": "the employee profile page.",
          "header": "Forgive Payment",
          "held_warning": "This employee is currently held meaning they cannot progress with any of their applications. If you want to release the employee, please go to {goToEmployee}",
          "id": "Id",
          "payment": "Forgiveness Amount"
        },
        "history": {
          "header": "Application History"
        },
        "settlement_button": "Settle",
        "settlement_dialog": {
          "balance": "Repayment Balance",
          "header": "Settle Payment",
          "id": "Id",
          "payment": "Payment Settlement Amount"
        }
      },
      "approval_waiver_config": {
        "allow_approval_waiver": "Allow approver to elect to skip evidence approval?",
        "approval_workflow_waiver": "Approval Workflow Waiver",
        "checklist_for_approval_waiver": "Checklist for evidence approval waiver",
        "checklist_for_approval_waiver_description": "If all of these items are confirmed, in addition to confirmation for all items for attachment requirement waiver, then evidence approval will not be required after final submission.",
        "checklist_for_attachment_waiver": "Checklist for attachment requirement waiver",
        "checklist_for_attachment_waiver_description": "If all of these items are confirmed, then attachments will not be required to submit for evidence approval."
      },
      "approver_comments": "Approver Comments",
      "approver_invoice": "Invoice",
      "are_you_sure_you_want_to_delete": "Are you sure you want to delete this comment?",
      "claims_financials": {
        "applicable_grant": "Applicable Grant",
        "approval_calculations": "Approval Calculations",
        "approved_total": "Approved Total",
        "benefit_percent": "Benefit Percent",
        "benefit_percent_x_graded_tuition": "Benefit Percent x Graded Tuition Amount",
        "courses_pre_approval_calculation_message": "Since the employee has not submitted a grade at this point, we are defaulting the grade to ‘A’ for the course pre-approval process. Once the employee submits the actual grade, the approval calculations will be updated accordingly.",
        "default": "Claims Financials",
        "discount_amount": "Discount amount",
        "employee_pop_amount": "Employee POP amount",
        "fees": "Fees",
        "graded_tuition_amount": "Graded Tuition Amount",
        "graded_tuition_amount_minus_grant_distribution": "Graded Tuition Amount - Grant Distribution",
        "grant_distribution": "Grant Distribution",
        "grant_scholarship_amount": "Grant/Scholarship amount",
        "invoice_total": "Invoice total",
        "itemized_bill": "Itemized bill",
        "loan_amount": "Loan amount",
        "other_pop_amount": "Other POP amount",
        "percent_total_cost": "Percent Total Cost",
        "proof_of_payment": "Proof of payment",
        "total_after_discount": "Total after discount",
        "total_pop_amount": "Total POP amount",
        "total_tuition_charged": "Total tuition charged",
        "unpaid_balance": "Unpaid balance"
      },
      "comments_for_application_id": "Comments for Application ID:",
      "course_details": {
        "course_grade_pre_approval_hint": "Please enter your grade here if available"
      },
      "dashboard": {
        "manage_dependents_header": "Dependents",
        "manage_dependents_text": "No Dependents added",
        "program_header": "Programs"
      },
      "default": "Tuition Assistance",
      "dependent_age": "Age: ",
      "dependent_info": "Dependent Information",
      "dependent_programs": "Dependent Programs",
      "dependent_programs_button": "Dependent Programs",
      "dependent_programs_information_years": "years old",
      "dependent_select": "Select dependent you are applying for",
      "dependent_table": {
        "header_age": "Age",
        "header_name": "Name",
        "header_relationship": "Relationship",
        "table_title": "Dependents"
      },
      "edit_dependent_modal": {
        "cancel_button": "Cancel",
        "delete_button": "Delete",
        "header": "Edit Dependent",
        "save_button": "Save"
      },
      "employee": {
        "activate_eligibility_disclaimer": "Are you sure you want to add user to {program}?",
        "active": "Active",
        "auto_program_eligibility_warning": "Are you sure you want to update the program eligibility status to Auto? If yes, please be aware that the next eligibility file update will determine plan eligibility for the employee.",
        "created_on": "Created on",
        "deactivate_eligibility_disclaimer": "Are you sure you want to remove user from {program}?",
        "deactivated": "Deactivated",
        "deactivated_on": "Deactivated on",
        "eligibility_state": "Eligibility State",
        "employee_email": "Employee Email",
        "enrolled_on": "Enrolled on",
        "held": "Held",
        "manual_program_eligibility_warning": "Are you sure you want to update the program eligibility status to Manual? If yes, please be aware that the next eligibility file update will be ignored regarding plan eligibility for the employee.",
        "participating": "Participating",
        "participation_status": "Participation Status",
        "participation_status_warning": "Are you sure you want to update this employee's participation status?",
        "payroll_id_eligibility": "Payroll ID",
        "pending": "Pending",
        "plan_eligibility": "Plan",
        "program_code": "Program Code",
        "program_eligibility": "Program Eligibility",
        "program_name": "Program Name",
        "update_eligibility": "Update Eligibility"
      },
      "employee_eligibility": {
        "course_end_date": "Courses End Date",
        "course_start_date": "Courses Start Date",
        "default": "Employee Eligibility",
        "eligibility": "Eligibility",
        "fulfilled_date": "Final Approved Date",
        "locked_on": "Locked on",
        "on_courses_submission": "On Application Submission"
      },
      "employee_hold": "Employee Hold",
      "employee_hold_description": "Employee cannot submit new applications, submit applications for evidence approval, withdraw from programs, or mark programs complete.",
      "go_to_approver_page": "Go to Approver Page",
      "hold": "Place Hold",
      "hold_employee": "Hold Employee",
      "last_updated": "Last Updated:",
      "no_comments_found": "No comments found",
      "payments": {
        "attribute_label": {
          "created_by": "Created By",
          "download": "Download TA",
          "id": "Payment Run ID",
          "payment_date": "Payment Date",
          "status": "Status",
          "type": "Type"
        },
        "default": "Payments"
      },
      "program_details": {
        "applicant_info": "Program Applicant Information",
        "header": "Please select a dependent"
      },
      "program_template_review": {
        "accept_conditions": "Accept Conditions",
        "add_custom_field": "Add Custom Field",
        "add_option": "Add option",
        "add_options": "Add options",
        "allow_pre_approval_submission_beyond_limits": "Allow application pre-approval submission beyond limits",
        "allow_unaccredited_institutions": "Allow unaccredited institutions?",
        "application_review_schedule": "Application Review Schedule",
        "approval_workflow": {
          "default": "Approval Workflow",
          "program_approval": "Program Approval",
          "workflow_step_name": "Workflow Step Name"
        },
        "approver": "Approver",
        "approver_instructions_and_faqs": {
          "approver_instructions": "Approver Instructions",
          "default": "Approver Instructions & Frequently Asked Questions",
          "instruction": "Instruction"
        },
        "approver_role": "Approver Role",
        "calculate_reimbursement_by_claim_financials": "Calculate reimbursement by claim financials",
        "calculate_reimbursement_by_credit": "Calculate reimbursement by course credit",
        "calculate_reimbursement_by_gpa": "Calculate reimbursement by GPA",
        "calculate_reimbursement_by_percent": "Calculate reimbursement by percentage",
        "can_there_be_multiple_instances": "Can there be multiple instances of the same program?",
        "certification_tracking_enabled": "Certification/Others Tracking enabled",
        "courses_application_setup": "Courses Application Setup",
        "courses_information": "Courses Information",
        "courses_pre_approval": "Courses Pre-Approval",
        "custom_field": {
          "custom_fields_added": "Custom Fields Added",
          "freeform_text": "Freeform Text",
          "order_number": "Order"
        },
        "custom_fields_for_application": "Custom Fields For Application",
        "dependent_program": {
          "age_limit": "Age Limit",
          "dependent_age_limits": "Dependent Age Limits Added",
          "dependent_type": "Dependent Type",
          "label": "Will this be used as a program for dependents?",
          "no_age_limit": "No Age Limit",
          "no_age_limits_were_set": "No age limits were set"
        },
        "edit_options": "Edit options",
        "eligibility_waiting_period": "Eligibility Waiting Period",
        "employee_id": "Employee ID",
        "enable_certification_tracking": "Enable Certification/Others Tracking?",
        "exclusive_grades": "Exclusive grades for this program",
        "expense_type": "Expense Type",
        "field": "Field",
        "field_label": "Field Label",
        "field_value": "Field Value",
        "institution_list_is_exclusive": "Institution list is exclusive? (only allow provided institutions)",
        "is_this_single_application_program": "Is this a single application program?",
        "lead_time_for_submitting": "Lead time for submitting courses pre-approval",
        "lock_balance_multiplier": "Lock balance multiplier at start of fiscal year",
        "no_custom_fields": "No custom fields",
        "no_set_limit": "No Set Limit",
        "none_provided": "None provided",
        "overall": "Overall",
        "passing_grades": "Passing grades",
        "payment_review_and_final_approval": "Payment Review And Final Approval",
        "payment_submission_max_days": "Payment Submission Max Days Post Completion",
        "payroll_expectation": "Payroll Expectation",
        "post_course_end_date_evidence_submission": "Number of days post course end date to allow application for evidence submission",
        "program_application_setup": {
          "default": "Program Application Setup",
          "employee_info": "Employee Information",
          "program_info": "Program Information"
        },
        "program_created": "Program Created!",
        "program_limits": {
          "all_employment_types": "All Employment Types",
          "default": "Program Limits",
          "lifetime": "Lifetime"
        },
        "program_setup": "Program Setup",
        "program_tracking_only": "Program Tracking Only (no reimbursement for the employee)",
        "reimbursable_expense_limits": "Reimbursable Expense Limits",
        "reimbursement_per_course_credit": "Reimbursement Per Course Credit",
        "reimbursement_percentage": "Reimbursement Percentage",
        "reimbursement_percentage_claims_financials": "Benefit percentage for claims financials",
        "remove_process_description_steps": "Turn off the visibility of process description steps for employees",
        "response_template_for_approval": "Response template for approval",
        "response_template_for_rejection": "Response template for rejection",
        "response_template_for_revision": "Response template for requested change",
        "response_templates_for": "Response Templates for {workflow}",
        "role": "Role",
        "suspended_program": "Suspended Program Disclosure",
        "time_between_registration_and_pre_approval": "Number of days post course start date to allow initial application submission",
        "time_buffer": "Time buffer for approving courses pre-approval",
        "type": "Type",
        "use_balance_multiplier": "Use balance multiplier from eligibility file",
        "use_custom_field_options": "Use picklist for options",
        "visible_to_employees": "Visible to employees",
        "voucher_program": {
          "default": "Voucher Program",
          "label": "Will this be used as a voucher program?",
          "type": "PDF Type to Generate"
        },
        "what_happens_now": "What happens now? You can expect the following:",
        "withdraw_mark_complete": "Withdraw/Mark Complete Approval",
        "workflow_step_type": "Workflow Step Type",
        "you_can_review_your_program_and_applications": "You can review your program and applications submitted by your employees at any time from your dashboard.",
        "your_program_code": "Your program Code is:",
        "your_program_is_now_launched": "Your program is now launched and available to your employees",
        "your_program_name": "Your program name is:"
      },
      "remove": "Remove Hold",
      "remove_employee_hold": "Remove Employee Hold",
      "repayment_warning": {
        "amount_owed": "Amount Owed",
        "repayment_balance": "Repayment Balance",
        "warning": "Please refrain from approving new applications and payment submissions."
      },
      "this_action_cannot_be_undone": "This action cannot be undone."
    },
    "type": "Type",
    "unknown": "Unknown",
    "unknown_error_occurred": "An unknown error occurred",
    "value": "Value",
    "view": "View",
    "view_all": "View All",
    "view_all_plans": "View All Plans",
    "view_options": "View Options",
    "workspaces": {
      "agent_email": "Agent Email",
      "primary_agent": "Primary Agent"
    },
    "yes": "Yes",
    "yes_no": "Yes/No"
  },
  "consolidation": {
    "changes_to_private": "Changes your federal loans to a private loan",
    "combine_loans": "Combine multiple loans into one loan",
    "default": "Consolidation",
    "keeps_loans_eligible": "Keeps your loans eligible for loan forgiveness, federal repayment plans and borrower protections",
    "lowers_rate": "Lowers your overall interest rate"
  },
  "contact_us": {
    "call_us": "Call us",
    "call_us_times": "<span>Monday - Friday</span><br/><span>8am - 8pm ET</span>",
    "chat_with_us": "Chat with us",
    "default": "Contact Us",
    "email_us": "Email us",
    "live_chat_now": "Live chat now",
    "tio_support_email": "support@tuition.io",
    "tio_support_phone": "+1 (855)-353-9395"
  },
  "continue": "Continue",
  "contributions": {
    "applied_to_account": "Applied to Account",
    "contribution_date": "Contribution Date",
    "contribution_period": "Contribution Period",
    "date": "Date",
    "default": "Contribution Plan",
    "employer_contributions": "Employer Contributions",
    "future_contributions": "Future Contributions",
    "future_employer_contributions": "Future Employer Contributions",
    "my_employer_contributions": "My Employer Contributions Summary",
    "no_payments_found": "No payments yet",
    "past_contributions": "Past Contributions",
    "payment": "Amount",
    "payment_date": "Payment Date",
    "payments": "payments",
    "state": "State",
    "status": "Status",
    "total_by_account": "Total contributions by account",
    "total_to_date": "Contributions to Date",
    "upcoming_employer_contribution": "Upcoming Employer Contribution",
    "upcoming_employer_contribution_period": "Upcoming Employer Contribution Period"
  },
  "current_balance": "Current Balance",
  "dashboard": "Dashboard",
  "dashboard_banner": {
    "doe_message": "Currently, new enrollments & income-reverfications for income-driven repayment (IDR) plans are unavailable. The online IDR application and printable versions are not available through the Dept of Ed. If you're struggling to make payments or would like help pursuing loan forgiveness, we recommend reaching out to a student loan coach by navigating to the coaching tile. Here, you'll answer a few short questions and can send our experts an email or schedule a call or screenshare."
  },
  "dashboard_tiles": {
    "10_or_20_cancellation": "$10,000 or $20,000 Student Debt Cancellation",
    "401k_match": "401(k) Match",
    "529_plans": "529 Plans",
    "a_scholarship_is": "A scholarship is money awarded to students for academic or other achievements that can be used towards college or career school, and does not have to be repaid.",
    "add_loans": "Add loans",
    "add_student_loans": "Add Student Loans",
    "admin": "Admin",
    "agency_name": "Agency name",
    "agent_info_line": "Your representative can track your progress and review your Student Loan Account Information.",
    "amount": "Amount",
    "apply_for_assistance": "<p>Apply for Tuition Assistance <b>to further your training/education</b></p>",
    "benefit_available_on": "Benefit Available On: ",
    "click_to_apply": "Click here to apply for federal student loan debt relief",
    "college_financial_planner": "College Financial Planner",
    "common_questions": "Common Questions",
    "commonly_used_terms": "Commonly used terms",
    "consolidation_and_refinancing": "Consolidation & Refinancing",
    "continue_enrollment": "Continue Enrollment",
    "eligible_start_date": "eligible start date",
    "employer_contribution_period_last": "Last Employer Contribution Period",
    "employer_contribution_period_next": "Next Employer Contribution Period",
    "employer_contribution_sent": "Employer Contribution Sent",
    "employer_contribution_status": "Employer Contribution Status",
    "employer_contributions": "Employer Contributions",
    "employer_contributions_total": "Employer Contributions Total",
    "fed_loan_blurb": "The federal government offers financial aid to help pay for college. Federal student loans, Perkins loans, Pell grants, and work-study are all forms of federal student aid. To receive federal student aid, a borrower must complete the FAFSA.",
    "fed_repayment_plans": "Federal Loan Repayment Plans",
    "find_best_strategy": "Let's find the best loan repayment strategy for you",
    "forecasting_tools": "Financial forecasting tools",
    "forecasting_tools_missing_data": "We need a little bit more information about your student loans before you can utilize the financial forecasting tools. Provide the missing information by clicking this tile and filling in the blanks.",
    "get_answers_to": "Get answers to common questions people ask us",
    "glossary": "Student Loan Glossary",
    "glossary_blurb": "Student loan terminology can be confusing. Here are important terms with easy to understand definitions.",
    "helpful_info": "Helpful information on how to find scholarships and apply",
    "hm_agent_license": "License",
    "hm_agent_site": "Website",
    "idr_description": "<p>See if you could <b>lower your monthly payments</b> and receive <b>loan forgiveness</b></p>",
    "income_driven_repayment": "Income Driven Repayment",
    "invite_family_members": "Invite Family Members",
    "last_payment_made": "Last payment made:",
    "last_updated": "Last updated on",
    "learn_about_fed_forgiveness": "Learn more about all the federal loan forgiveness programs",
    "learn_about_reimbursement": "Learn about your student debt repayment options",
    "learn_about_repayment": "Learn about your student debt repayment options",
    "learn_fed_repayment": "Learn about your different Federal loan repayment plan options",
    "learn_how_federal_loans": "Learn how Federal loans are different",
    "learn_more_about_cancellation": "Learn more about how the cancellation announcement from 8/24/2022 might impact you and if you need to take action.",
    "lf_criteria": "You might qualify for forgiveness of your student loans if you meet specific eligibility criteria. Borrowers who might qualify are public service workers, teachers in low-income school districts, and borrowers with high debt relative to their income.",
    "link_accounts": "Add your student loan accounts to get full access to all Tuition.io's education assistance benefits.",
    "loan_account_issue": "Loan Account Issue",
    "loan_account_issue_body": "We are currently unable to process your employer's Student Loan Repayment benefit.",
    "loan_forgiveness": "Loan Forgiveness",
    "loan_projection_payoff": "Loan Projection Payoff",
    "loan_summary": "Loan Summary",
    "loan_summary_img_alt": "graph showing loans and balance",
    "look_up_terminology": "Look up common student loan terminology",
    "lrp_blurb": "Everyone with federal loans is on a repayment plan. There are 8 different repayment plans that you can choose from, depending on your eligibility and payoff goals. These plans are only for paying off your federal loans. For private loans, contact your lender.",
    "mentors_help": "Mentors help you understand the best options for your <b>education goals</b>",
    "next_amount": "Next Amount",
    "next_payment": "Next scheduled payment",
    "no_loan_accounts": "No Loan Accounts",
    "prep_for_costs": "Get prepared for your higher education financial costs",
    "projections_img_alt": "loan projection trajectory",
    "pslf_placeholder_img_alt": "graph showing one overdue task",
    "reimbursement": "Tuition Reimbursement",
    "save_now": "Save for your family's future now",
    "schedule_expert_call": "Speak with a student loan expert. Schedule time for a call.",
    "schedule_time_with_me": "Schedule time with me",
    "scholarship_info": "Scholarship Information",
    "secure_your_future": "<p>401(k) Match - <span class=\"font-semibold\">Enrollment {enrolled}</span><br> Enable your employer to <b>match qualifying student loan payments</b> into your <b>retirement savings account</b></p>",
    "secure_your_future_continue_enrollment": "<p class=\"mb-4\">401(k) Match - <span class=\"font-semibold\">Enrollment {enrolled}</span></p><div class=\"flex gap-1\"><span class=\"material-icons-outlined ml-4 text-error-400\">error_outline</span>It looks like you started the enrollment process but have not completed it. Enroll now to start receiving matching contributions from your employer to your 401(k) for every qualifying loan payment.</div>",
    "share_with_family": "Share Tuition.io with your family",
    "slr_employer_contributions": "Employer Contributions",
    "slr_in_progress_tip_body": "We are working with your employer to process the payment to your loan servicer for this billing cycle.",
    "slr_link_loans": "To start receiving benefit contributions, add a loan account with an",
    "slr_link_loans_btn_text": "Add Loan Account",
    "slr_next_payment": "Next Employer Contribution",
    "slr_payment_pending_tip_body": "Payment processing typically begins in the first week of the benefit cycle.",
    "slr_payment_sent_tip_body": "Payment sent to your loan servicer on {date}. Payments sent to your loan servicer are typically applied to your account within 15 days.",
    "slr_payment_tip_header": "Payment Status",
    "slr_start_date_tip_body": "Your eligibility for Student Loan Repayment from your employer begins",
    "slr_start_date_tip_header": "Eligible Start Date",
    "slr_total_future_payments": "On track for a total of <span class=\"text-xl font-semibold\">{total}</span> in contributions this year!",
    "starbucks_scap": "Starbucks College Achievement Plan",
    "starbucks_scap_blurb_1": "<a class=\"underline text-ocean-600\" target=\"_blank\" href=\"https://www.starbucksbenefits.com/en/home-ca-en/education/\">Click here</a> to learn more about SCAP.",
    "starbucks_scap_blurb_2": "Add additional accounts, then use the Strategy Finder tool to see what repayment plan is best for you.",
    "starbucks_scap_description": "All eligible U.S. partners receive 100% tuition coverage for a first-time bachelor's degree through Arizona State University's online program. Partners can choose from over 140+ diverse undergraduate degree programs, and have our support every step of the way.",
    "starbucks_scap_title_1": "Do you want to become a SCAP Scholar?",
    "starbucks_scap_title_2": "Are you already an SCAP Scholar, but have previous loans?",
    "student_loan_coaches": "Student Loan Coaches",
    "student_loan_repayment": "Student Loan Repayment",
    "tasks_by_priority": "Tasks by priority",
    "tio_payment_ops": "Tio Payment Ops",
    "to_do_now": "To Do Now",
    "total_payments": "Total payments made to date:",
    "tuition_assistance": "Tuition Assistance",
    "tuition_assistance_admin": "Review and approve Tuition Assistance applications",
    "tuition_assistance_applications": "Tuition Assistance Applications",
    "tuition_assistance_mentoring": "Tuition Assistance Mentoring",
    "types_of_student_loans": "Types of Student Loans",
    "view_contributions": "<p>View <b>past</b> and <b>future</b> employer contributions to your Student Loans</p>",
    "view_details": "View Details",
    "what_are_lrps": "What are Loan Repayment Plans?",
    "what_is_a_fed_loan": "What is a Federal Loan?",
    "what_is_lf": "What is loan forgiveness?",
    "what_is_scholarship": "What is a Scholarship?",
    "your_agent": "Your Agent",
    "your_hm_rep": "Your Horace Mann Representative"
  },
  "days": "Days",
  "december": "December",
  "default_loan": {
    "button": "Schedule time with a loan coach",
    "text": "Please schedule a time to speak with a loan coach. Looks like you may need to rehabilitate or consolidate your loans. A loan coach will be able to help you walk through that process."
  },
  "delete": "Delete",
  "dialog": {
    "document_asset": {
      "last_updated": "Last Updated {date}"
    }
  },
  "disable": "Disable",
  "doe_pslf_processing_pause": {
    "header": "Department of Education PSLF Processing Pause",
    "how_does_pausing_help": "How does pausing PSLF form submission reduce work for employees and administrators?",
    "how_does_pausing_help_a": "The Department of Education (DOE) has provided limited guidance on the submission of outdated PSLF forms to MOHELA. In the past, many PSLF forms were lost and processing was significantly delayed during transitions from one servicer to another. In light of the freeze on PSLF form processing through July, submission of the latest form directly to the DOE will provide the best experience without risk of loss or having to duplicate PSLF form completion work.",
    "how_will_tio_help": "How will Tuition.io help employees pursuing PSLF while form submission is paused?",
    "how_will_tio_help_a": "The TIO student loan coaching team is available to answer any employee questions. The PSLF form is only one part of the PSLF process, it is also critical that employees are on the right repayment plan and have the right type of federal student loans. Our software and services related to both of these required actions will be running as usual. We encourage any employees with questions to reach out to our student loan coaching team for guidance.",
    "recently_submitted": "What if I recently submitted the outdated PSLF form to MOHELA?",
    "recently_submitted_a": "Tuition.io will follow up as appropriate once the updated form is available on our site. Currently, the Department of Education (DOE) does not recommend submitting duplicate PSLF forms. We will keep you informed as we receive updated guidance from the DOE.",
    "what_should_happen": "What should happen with any PSLF forms that are pending employer signature?",
    "what_should_happen_a": "Any forms that are currently awaiting employer signature and processing should be signed and submitted as usual. We are still waiting for more clarification from the Department of Education (DOE) about how they plan to transition old forms. If we subsequently learn that the DOE requires all new PSLF forms after 5/1/24 to be submitted using the revised form then we will notify any affected employees and request that they resubmit their forms via the Tuition.io platform after 6/12/24, although we do not currently expect this will be necessary.",
    "will_tio_remind": "Will Tuition.io remind employees to come back and submit the form once it is available?",
    "will_tio_remind_a": "Yes. When the new PSLF form is available on Tuition.io, we will send an email reminder to any employee who logged in during the PSLF form pause letting them know the new PSLF form is available."
  },
  "dollar": "$",
  "done": "Done",
  "download": "Download",
  "edit": "Edit",
  "eligibility": "Eligibility",
  "eligibility_check": "Eligibility Check",
  "eligibility_files": {
    "abort": "Abort",
    "aborted": "Aborted",
    "aborted_by": "Aborted By",
    "auto_process_disabled": "Auto-Process Disabled",
    "automatic": "Auto",
    "changed_employees": "Changed",
    "deactivated_employees": "Deactivated",
    "default": "Eligibility Files",
    "download": "Download",
    "eligibility_file_upload": "eligibility_file_upload",
    "external": "External Service",
    "file_id": "File ID",
    "file_name": "File Name",
    "file_upload_error": "There has been an error with this upload - Please cancel and try again",
    "filter_by_date": "Filter by Start Date",
    "filter_by_status": "Filter by Status",
    "forced": "Forced",
    "header": "Upload Eligibility File",
    "manual": "Manual",
    "new_employees": "New",
    "partner": "Partner",
    "preview_changes": "Preview Changes",
    "preview_count": "Preview",
    "process_count": "Processed",
    "process_details": "Process Details",
    "process_eligibility_file": "Process",
    "process_id": "Process ID",
    "reactivated_employees": "Reactivated",
    "reprocess_eligibility_file": "Reprocess",
    "run_time": "Run Time",
    "schedule_eligibility_file": "Schedule",
    "select_file": "Select File",
    "start_time": "Start Time",
    "started_on": "Started On",
    "status": "Status:",
    "strategy": "Strategy",
    "time_aborted": "Time Aborted",
    "time_completed": "Time Completed",
    "total_processed": "Total Processed:",
    "unchanged_employees": "Unchanged",
    "upload_type": "Upload Type",
    "upload_warning": "Exiting the page now will abort the upload process.",
    "uploaded_by": "Uploaded By",
    "uploading": "Uploading File",
    "warning": {
      "data": "Data",
      "default": "Warnings",
      "description": "Description",
      "field": "Field",
      "type": "Type"
    },
    "warning_message": "Clicking Next allows you to preview before processing the eligibility file"
  },
  "employees": "employees",
  "enroll": {
    "confirm_name": {
      "body": "The name you entered ({inputName}) doesn't match the name associated with your invitation. This invitiation will be connected directly to {employeeFullName}'s employment record and should only be registered by them.",
      "header": "Are you {name}?",
      "register_as": "Register as {name}",
      "yes_im": "Yes, I'm {name}"
    }
  },
  "enums": {
    "TAS": {
      "ApplicationAssistanceTrigger": {
        "DIRECT_PAY_ON_FULFILLED": "Direct Pay Reimbursement",
        "ON_ATTEND": "Prepaid",
        "ON_FULFILLED": "Reimbursement"
      }
    }
  },
  "error_occurred": "An unknown error occurred",
  "fax_to": "Fax to: ",
  "february": "February",
  "file_upload": {
    "drop_to_upload": "Drop to upload",
    "files": "files",
    "images": "images",
    "or_drag_and_drop": "or drag and drop here to upload",
    "select_a_file": "Select a file",
    "uploading": "Uploading"
  },
  "forgiveness_estimator": {
    "GradOnly": "Graduate",
    "afford_payments": "Are you able to afford your monthly payments currently?",
    "annual_income": "Annual Income ($)",
    "annual_income_tooltip": "For the most accurate results, refer to the line 11 on your federal tax return (1040) or enter the value from box 1 on your (and spouse's if filing jointly) W-2. For approximate results, enter your annual salary.",
    "before_2007": "Do you have student loans taken out before October 1, 2007?",
    "continue_to_estimator": "Continue to estimator",
    "est_projection": "Estimated Forgiveness Projection",
    "estimate_update": "As you adjust answers on the left, your estimate below will get updated.",
    "family_size": "Family Size",
    "grad_or_undergrad": "Were your loans used for an Undergraduate or Graduate Degree?",
    "graduate": "Graduate",
    "how_many_years": "Approximately how many years have you been making minimum monthly payments towards your federal student loan?",
    "how_many_years_tooltip": "Please count only the years that you are making minimum monthly payments while working for a 501(C)3 non-profit, government, or tribal employer.",
    "mix": "Mix of both",
    "results": {
      "gross_income": "Gross Income",
      "ideal_idr_option": "Ideal IDR Option",
      "ideal_option": "Ideal Option",
      "loans_before_2007": "Do you have loans taken out before October 1st 2007",
      "number_of_years": "Number of Qualifying Years",
      "your_monthly_payment": "Your Monthly Payment And Forgiveness Estimator Input"
    },
    "see_results": "See Results",
    "undergradGrad": "Mix of both",
    "undergradOnly": "Undergraduate",
    "undergraduate": "Undergraduate"
  },
  "form": {
    "email": "Email",
    "password": "Password"
  },
  "header": {
    "banner": {
      "default_program_name": "education assistance benefits",
      "tagline": "{programTitle} powered by <span class=\"{brandClass}\"><a href=\"https://tuition.io\" target=\"_blank\" rel=\"noopener noreferrer\">Tuition.io</a></span>"
    },
    "user_menu": {
      "help": "Help",
      "keep_alive": "Keep Alive",
      "logout": "Logout",
      "profile": "My Profile",
      "switch_account": "Switch Account",
      "title": "Hello {name}"
    }
  },
  "here": "here",
  "id": "ID",
  "idr": {
    "abbreviated": "IDR",
    "accounts": {
      "accounts_linked": "Accounts Added",
      "add_more_accounts": "Add More Accounts",
      "default": "Accounts",
      "linked_below": "Below are the active student loan accounts you have added:",
      "view_details": "View Details"
    },
    "default": "Income-Driven Repayment",
    "estimator": {
      "afford_monthly_payments": "Are you able to afford your monthly payments currently?",
      "amount": "Amount",
      "annual_income": "Annual Income ($)",
      "approx_years": "Approximately how many years have you been making minimum monthly payments towards your federal student loans?",
      "before_2007": "Do you have student loans take out before October 1, 2007?",
      "complete": "Completing the short questionnaire below will help us provide the best income-driven repayment (IDR) option for you.",
      "default": "Monthly Payment And Forgiveness Estimator",
      "family_size": "Family Size",
      "gross_income": "Gross Income",
      "idr_explanation": "Income-driven repayment plans offered by the Department of Education can lower the monthly payments and result in loan forgiveness for borrowers. Get your results in less that 2 minutes!",
      "idr_explanations": "Income-driven repayment plans offered by the Department of Education can <span class=\"{color}\">lower the monthly payments</span> and result in <span class=\"{color}\">loan forgiveness</span> for borrowers. Get your results in <span class=\"{color}\">less that 2 minutes!</span>",
      "see_results": "See Results",
      "start": "Start"
    },
    "income_driven": "Income-Driven Repayment Dashboard",
    "results": {
      "date": "Date",
      "default": "Results",
      "description": "Based on your most <b><i>recent</i></b> answers from the Monthly Payment & Forgiveness Estimator, below is the most ideal income-driven repayment plan.",
      "estimated_loan_forgiveness": "Estimated Loan Forgiveness is:",
      "estimated_monthly_payment": "Estimated Monthly Payment is:",
      "financial_circumstances": "If your financial circumstances change, revisit the estimator to get the most up-to-date loan forgiveness and monthly payment.",
      "next_steps": "Monthly Payment And Forgiveness Estimator Next Steps",
      "payment_button": "Payment & Forgiveness Estimator",
      "recertify": "Recertify your income every year (we will send you a reminder).",
      "recommendation_history": "IDR Recommendation History",
      "view_all": "View All",
      "what_happens_next": "What happens next?"
    }
  },
  "january": "January",
  "july": "July",
  "june": "June",
  "logged_out": {
    "sign_in_button": "Sign In",
    "success": "You have successfully logged out.",
    "thank_you": "Thank you for visiting"
  },
  "login": {
    "action_required": "Action Required: Email Verification",
    "agree": "I have read and agree to Tuition.io's <a href=\"/terms-of-service\" class=\"text-ocean-600 underline\">terms of service</a> and <a href=\"/privacy-policy\" class=\"text-ocean-600 underline\">privacy policy</a>.",
    "agree_text": "Agree",
    "already_have_account": "Already have an account?",
    "back_to_login": "Back to login",
    "click_login": "Click the login button below and we will redirect you to your SSO login to complete the login process.",
    "confirm_new_password": "Confirm New Password",
    "create_password": "Create Password",
    "default": "Login",
    "email": "Email",
    "email_hint": "You'll use this email as your username and to receive email notifications. We highly recommed you use your personal email address.",
    "email_hint_self_registration": "You'll use this email as your username and to receive email notifications. You must use your work provided email address.",
    "email_not_found": "Email not found",
    "email_redirect": "We will send you an email or redirect you to your SSO login to complete registration.",
    "email_username": "Email/Username",
    "enroll": "Enroll",
    "enroll_in_tuition_to_access": "Enroll in Tuition.io to access your education assistance benefits.",
    "enter_email_and_pw": "Please enter your email address and password to sign in.",
    "first_name": "First Name",
    "forgot_password_body": "Please enter the email address you used to create your account. Once you do, we'll send instructions to reset your password.",
    "forgot_password_confirmation_body": "We sent you an email with instructions to reset your password if an account with the email address you submitted exists in our system.",
    "forgot_password_confirmation_title": "Password Reset Request Submitted",
    "forgot_password_page_title": "Forgot password",
    "forgot_password_question": "Forgot password?",
    "form": {
      "email": "Email",
      "password": "Password",
      "submit": "Login"
    },
    "get_started": "Get Started",
    "have_user_and_password": "Have a user name and password? ",
    "hello_and_welcome": "Hello and welcome!",
    "i_have_read_and_agree_to_tuitions": "I have read and agree to Tuition.io's",
    "i_have_read_terms_aria_label": "I have read and agree to Tuition.io's terms of service and privacy policy.",
    "in_progress": "Logging in...",
    "invite_error": "There was an error with the invite link. Please check your email for a new invite to complete your registration.",
    "invite_expired": "This invite link has expired. Please check your email for a new invite to complete your registration.",
    "last_name": "Last Name",
    "loading": "Loading...",
    "loading_messages": {
      "connecting_to_loan_servicer": "Connecting to loan servicer...",
      "establishing_secure_connection": "Establishing secure connection...",
      "fetch_company_data": "Fetching company data...",
      "gather_account_details": "Gathering account details...",
      "loading_servicer_dashboard": "Loading servicer login dashboard...",
      "optimizing_servicer_link": "Optimizing servicer link...",
      "thank_you_for_your_patience": "Thank you for your patience...",
      "verify_credentials": "Verifying credentials. This may take a few seconds...",
      "wait_for_system_warmup": "Waiting for systems to warm up..."
    },
    "log_in": "Log in",
    "log_in_here": "Log in here",
    "login_here": "Login here",
    "minimum_characters": "Minimum of {min} characters long",
    "mobile": "Mobile Phone Number",
    "mobile_hint": "By providing your mobile number, you agree to receive text messages from us.",
    "need_to_register": "Do you need to register?",
    "new_password": "New Password",
    "new_to_tuition": "New to Tuition.io?",
    "not_launched": "Hello there. {companyName} has partnered with Tuition.io to help with your student loan debt. We are launching on {date}, so please come back in {days}!",
    "page_title": "Login",
    "password": "Password",
    "please_accept_the_terms": "Welcome to Tuition.io! Please accept the following terms and conditions.",
    "please_use_email_for_notifications": "Please enter the best email address for email notifications. We highly recommend you use your personal email address.",
    "privacy_policy": "privacy policy",
    "reenter_password": "Re-enter Password",
    "register": "Register",
    "register_new_account": "Register New Account",
    "register_page_default": "Hello and welcome! What is your {companyName} email address?  We will send you an email or redirect you to your SSO login to complete registration.",
    "register_welcome_sso": "Hello and welcome to Tuition.io! To get started, sign in with the button below.",
    "required": "Required",
    "reset_password": "Reset password",
    "reset_password_body": "Enter a new password not previously used with Tuition.io",
    "reset_password_confirmation_body": "Your password has been successfully reset. Please sign in with your new password.",
    "reset_password_confirmation_title": "Password Successfully Reset",
    "reset_password_error": "Reset Password Error",
    "reset_password_error_body": "Password reset link is invalid or expired",
    "reset_password_title": "Reset your password",
    "self_registration_success": "Thank you for providing your information. We have sent an email to the address provided. The email will have information on next steps. Please check your inbox, spam or junk folder. Please contact our support team for assistance if needed.",
    "sign_in_with": "Sign in with {idProvider}",
    "sign_up": "Sign Up",
    "sso_redirect": "Redirecting to SSO login...",
    "submit": "Submit",
    "terms_of_service": "terms of service",
    "terms_of_service_heading": "Terms of Service",
    "tio_company": "Tuition.io Company",
    "unregistered_email": "Unregistered Email",
    "unregistered_email_body": "Please check your email for an invite to complete your registration.",
    "use_sso": "Want to use SSO to log in? ",
    "use_tuition": "You'll use Tuition.io to keep track of all your education assistance benefits.",
    "user_already_enrolled": "The user associated with this invite link is already registered. Please sign in with your email and password.",
    "what_email": "What is your email address?",
    "which_account": "Which account do you want to log into?",
    "will_send_email": "We will send you an email with a link to complete your registration.",
    "work_email": "Work Email"
  },
  "logout": {
    "in_progress": "Logging out..."
  },
  "mail_to": "Mail to: ",
  "march": "March",
  "may": "May",
  "name": "Name",
  "need_help": "Need Help?",
  "next": "Next",
  "nice_work": "Nice Work!",
  "no": "No",
  "no_chart_data": "No chart data",
  "no_linked_accounts_alert": {
    "add_loans_btn": "Add your accounts",
    "dont_want_add": "I don't want to add accounts",
    "empty": "There are no loans here?",
    "enter_reason": "Enter a reason",
    "heading": "You haven't added any account(s)",
    "not_adding_loans": "If you are not adding accounts, please tell us why:",
    "please_link_loans": "Please add your student loan accounts to take advantage of the {program} estimation.",
    "reason_placeholder": "Select reason",
    "select_reason": "Please select the reason you are not adding an account.",
    "unable_add": "I am unable to add accounts",
    "warning": "You haven't added your student loan accounts to your Tuition.io account. In order to take\nadvantage of the student loan projection payoff calculator you must add your loan accounts.\nThis will ensure that the correct loan data is reflected in your Tuition.io account. Please\ntake a moment to add your loans to your Tuition.io account to ensure your information is up to\ndate."
  },
  "not_done": "Not Done",
  "november": "November",
  "number_five": "5",
  "number_four": "4",
  "number_one": "1",
  "number_six": "6",
  "number_three": "3",
  "number_two": "2",
  "number_zero": "0",
  "observability": {
    "balance": "Balance",
    "confirmation": {
      "amend": "If the information above does not look accurate, {clickHere} to let us know.",
      "continue": "{source, select, other {Continue} syf {Continue to Enrollment}}",
      "failed_subtitle": "We recognized your {documentType}, but we were unable to fully validate its contents.",
      "failed_title": "There was a problem with your {documentType}.",
      "header": "{provider, select,\n  statement {Student Loan Accounts Added}\n  nslds {Student Loan Accounts Added}\n  transaction_history {Payments Added}\n  other {Document Processed}\n}",
      "manual_prompt": "You can still manually submit your loan payments  {manualPaymentsLink} for review.",
      "subtitle": "Should we require additional student loan details to enable your employer's benefits, we will let you know.\nEmail reminders, and all communications, will be sent to {email}. You can change email options in your Tuition.io account settings.",
      "title": "{provider, select,\n  statement {Congratulations! You have successfully added your student loan accounts.}\n  nslds {Congratulations! You have successfully added your student loan accounts.}\n  transaction_history {Congratulations! You have successfully added your student loan payments.}\n  other {Congratulations! Your document was successfully processed.}\n}"
    },
    "default_document": "document",
    "dispute": {
      "confirmed": {
        "header": "Loan Account Information In Review",
        "message": "Thank you for letting us know that the loan account information is incorrect. Please allow 2-3 business days while we investigate this matter."
      },
      "document": {
        "uploaded": "Submitted via {via} {date} at {time}"
      },
      "form": {
        "note": {
          "label": "Note",
          "placeholder": "A description of any issues with the information above"
        },
        "prompt": "Please provide a note and let us know what information about your loan account is not correct."
      },
      "header": "Review Loan Account Information",
      "review_alert": "Once this loan account information is submitted for review, it will not be reflected in your acount until the review is complete."
    },
    "document": {
      "summary": {
        "account": "Account: ",
        "balance": "Current Balance: ",
        "header": "Loan Account Information",
        "loans": {
          "balance": "Balance",
          "name": "Loan",
          "originated": "Originated"
        },
        "partially_applied": "This document needs further review. Please allow 2-3 business days for us to verify its contents.",
        "servicer": "Loan Servicer: "
      }
    },
    "documents": {
      "index": {
        "headers": {
          "filename": "Document",
          "provider": "Type",
          "status": "Status",
          "submitted": "Submitted"
        },
        "title": "Loan Documents",
        "total": "{count, plural,\n  one { Document }\n  other { Documents }\n}"
      },
      "show": {
        "unsuccessful": "Something is wrong with the document and we couldn't process it. Please check that this is the correct document and try uploading again."
      }
    },
    "email": "Email",
    "loan": "Loan",
    "my_student_data": "MyStudentData file",
    "nslds": "NSLDS file",
    "statement": "student loan statement",
    "transaction_history": "transaction history document",
    "transactions_summary": {
      "header": "Loan Payments Information"
    },
    "upload": "Upload",
    "uploads": {
      "best_prefix": "Best:",
      "financial_institution": {
        "help": "For instructions on how to download your {documentType}, please select your loan servicer.\n",
        "label": "Select Student Loan Servicer"
      },
      "form": {
        "document": {
          "input": "Upload a loan document",
          "label": "Select Document To Upload",
          "selected": "Selected Document"
        },
        "submit": "Upload Document"
      },
      "form_section_title": "{source, select,\n  syf_payments { Upload Transaction History Document }\n  other { Upload Student Loan Document }\n}",
      "instructions_section_title": "Recommended {providers, plural, one {Document} other {Documents}}",
      "nslds": {
        "cta": "You can find a copy of your MyStudentData file at the Federal Student Aid website. {openInstructions} for instructions on how to find and download it.\n",
        "instructions": "<h1>How to Download Your Latest MyStudentData File:</h1>\n<ol>\n  <li>Log into your <a href=\"https://studentaid.gov/\" target=\"_blank\">studentaid.gov</a> account</li>\n  <li>Go to My Aid under your account dropdown menu</li>\n  <li>Click “Download my aid data” and select “continue” on the pop up screen to download</li>\n  <li>Upload the .txt document to your Tuition.io account</li>\n</ol>\n<p>If you don't have a studentaid.gov account or haven't logged into your account since 2016, <a href=\\\"https://studentaid.gov/\\\" target=\\\"_blank\\\">click here</a> to create an account:</p>\n<ol>\n  <li>You'll need your Social Security number, full name, and date of birth</li>\n  <li>It can take 2-3 business days for studentaid.gov to verify your SSN# and identity</li>\n  <li>Once your account is created, your federal student loan information will be populated</li>\n</ol>\n<p>A .txt document is required, screenshots will not be accepted.</p>",
        "justification": "Upload your NSLDS document to identify your ideal repayment strategy and estimate your potential loan forgiveness. The NSLDS document also provides Tuition.io coaches the history of your student loans.\n",
        "prompt": "MyStudentData File"
      },
      "optional_prefix": "Other Option:",
      "placeholder_servicer": "General Instructions",
      "progress": {
        "failure": {
          "body": "This file is not a valid {providers}. Please review the instructions that describe where to find your documents and try again.",
          "header": "Document Processing Failed"
        },
        "header": "Document Upload",
        "processing": {
          "header": "Processing Document"
        },
        "status": "{state, select,\n  DISPATCHED { Processing Document }\n  PROCESSING { Processing Document }\n  FAILED { Processing Failed }\n  INVALID { Document Invalid }\n  PROCESSED { Processing Complete }\n  other { Uploading Document }\n}",
        "success": {
          "header": "Document Processing Complete"
        },
        "timeout": {
          "body": "We are working on processing your document. Stay here to confirm your loan account information when we're done. If you leave the page, we'll send you an email when processing is complete.",
          "header": "Document Processing In Progress"
        }
      },
      "retry": "Upload another document",
      "statement": {
        "cta": "You can find a copy of your loan statement at your loan servicer's website. {openInstructions} for instructions on how to find and download it.\n",
        "instructions": "{servicer, select,\n  aidvantage {\n    <h1>How to Download Your Latest Loan Statement:</h1>\n    <figure>\n      <legend>Aidvantage</legend>\n      <ol>\n        <li>Log into your account <a href=\"https://aidvantage.studentaid.gov/\" target=\"_blank\">here</a></li>\n        <li>Click on the \"Inbox\" tab</li>\n        <li>Download your latest statement</li>\n        <li>Upload the PDF document to your Tuition.io account</li>\n      </ol>\n    </figure>\n    <p>A PDF is required, screenshots will not be accepted.</p>\n  }\n  americaned {\n    <h1>How to Download Your Latest Loan Statement:</h1>\n    <figure>\n      <legend>American Education Services</legend>\n      <ol>\n        <li>Log into your account <a href=\"https://access.aessuccess.org/sign-in\" target=\"_blank\">here</a></li>\n        <li>Click on the \"Inbox\" tab and select \"Billing Statements\"</li>\n        <li>Download your latest statement</li>\n        <li>Upload the PDF document to your Tuition.io account</li>\n      </ol>\n    </figure>\n    <p>A PDF is required, screenshots will not be accepted.</p>\n  }\n  edfinancial {\n    <h1>How to Download Your Latest Loan Statement:</h1>\n    <figure>\n      <legend>EdFinancial Services - Federal Direct Loan Program (FDLP)</legend>\n      <ol>\n        <li>Log into your account <a href=\"https://edfinancial.studentaid.gov/welcome\" target=\"_blank\">here</a></li>\n        <li>Navigate to the “Inbox/Upload” section of your online account (you'll also be able to retreive statements through <a href=\"https://edfinancial.studentaid.gov/help-center/your-online-account/e-correspondence\" target=\"_blank\">e-correspondence</a>)</li>\n        <li>Download your latest statement</li>\n        <li>Upload the PDF document to your Tuition.io account</li>\n      </ol>\n    </figure>\n    <p>A PDF is required, screenshots will not be accepted.</p>\n  }\n  mohela {\n    <h1>How to Download Your Latest Loan Statement:</h1>\n    <figure>\n      <legend>Mohela - Education Loan Finance</legend>\n      <ol>\n        <li>Log into your account <a href=\"https://mohela.studentaid.gov/\"\" target=\"_blank\">here</a></li>\n        <li>Click on the \"Inbox\" tab</li>\n        <li>On the \"Inbox\" page, click on the \"Documents we sent to you\" tab</li>\n        <li>Download your latest statement</li>\n        <li>Upload the PDF document to your Tuition.io account</li>\n      </ol>\n    </figure>\n    <p>A PDF is required, screenshots will not be accepted.</p>\n  }\n  nelnet {\n    <h1>How to Download Your Latest Loan Statement:</h1>\n    <figure>\n      <legend>Nelnet - Education Financing</legend>\n      <ol>\n        <li>Log into your account <a href=\"https://nelnet.studentaid.gov/account/login\"target=\"_blank\">here</a></li>\n        <li>Click on the \"Documents\" tab and select \"Statements\"</li>\n        <li>Download your latest statement</li>\n        <li>Upload the PDF document to your Tuition.io account</li>\n      </ol>\n    </figure>\n    <p>A PDF is required, screenshots will not be accepted.</p>\n  }\n  other {\n    <hgroup>\n      <h1>How to Download Your Latest Loan Statement:</h1>\n      <p>\n        If your servicer isn't listed in this dropdown, below are General Instructions\n        on where to find your statement:\n      </p>\n    </hgroup>\n    <ol>\n      <li>Log into your servicer account</li>\n      <li>\n        Loan Statements are generally found in areas on the website such as “Inbox”,\n        “Messages”, or “Statements & Documents”\n      </li>\n      <li>Download your latest statement</li>\n      <li>Upload the PDF document to your Tuition.io account</li>\n    </ol>\n    <p>A PDF is required, screenshots will not be accepted.</p>\n    <p>\n      If you cannot locate your statement, please contact your loan servicer by phone and\n      ask them to email you a copy of your monthly statement in a PDF format that shows\n      your:\n    </p>\n    <ul>\n      <li>Account Number</li>\n      <li>Loan Balance</li>\n      <li>Monthly Payment Amount</li>\n      <li>Interest rate</li>\n      <li>The name of the loan holder for this loan</li>\n    </ul>\n  }\n}",
        "justification": "Uploading a statement will allow your Tuition.io portal to reflect your aggregated loan information across all servicers and provide helpful insights about interest and payments.\n",
        "prompt": "Student Loan Statement"
      },
      "subtitle": "{source, select,\n  syf_payments {\n    Add your student loan payments for your Secure Your Future benefit by uploading your\n    Transaction History document.\n  }\n  other {\n    Add your student loans to access your employer's Education Assistance benefits. Going\n    forward, we will remind you to update your loan data on a regular basis.\n  }\n}",
      "support": {
        "email": "Email us: <a href=\"mailto:{email}\" class=\"{linkClass}\">{email}</a>",
        "phone": "Call us: +1 (855)-353-9395",
        "prompt": "If this is the correct document, please contact support:"
      },
      "title": "{source, select,\n  syf_payments { Add Payments }\n  other { Add Student Loan Accounts }\n}",
      "transaction_history": {
        "cta": "You can find a copy of your {documentType} at your loan servicer's website. {openInstructions} for instructions on how to find and download it.\n",
        "instructions": "{servicer, select,\n  aidvantage {\n    <h1>How to Download Your Transaction History Document:</h1>\n    <figure>\n      <legend>Aidvantage</legend>\n      <ol>\n        <li>Log into your account <a href=\"https://aidvantage.studentaid.gov/\" target=\"_blank\">here</a> (it will be easier to get the documents required from a desktop/laptop rather than a mobile device)</li>\n        <li>On the \"Account Summary\" page, in the \"Recent Payments\" section, click on the \"View all Account History\" link</li>\n        <li>In the \"Display\" dropdown, select \"By Transaction\"</li>\n        <li>In the \"Date Range\" dropdown, select the date range of the payments you would like to add</li>\n        <li>To download the document as a PDF, click on the \"Print\" button and save as a PDF (do not click on the \"Download\" button because that will download a csv document, which will not be accepted)</li>\n        <li>Upload the PDF document to your Tuition.io account</li>\n      </ol>\n    </figure>\n    <p>A PDF is required, screenshots and csv/excel documents will not be accepted.</p>\n  }\n  americaned {\n    <h1>How to Download Your Transaction History Document:</h1>\n    <figure>\n      <legend>American Education Services</legend>\n      <ol>\n        <li>Log into your account <a href=\"https://access.aessuccess.org/sign-in\" target=\"_blank\">here</a> (it will be easier to get the documents required from a desktop/laptop rather than a mobile device)</li>\n        <li>In the menu on the left side of the page, expand the \"Payments & Billing\" option and and click on \"Payment History\"</li>\n        <li>\n          Apply the following filters and then click \"Apply Filters\" button:\n          <ol type=\"a\">\n            <li>In the \"Loan Type\" dropdown, select \"All Loans\"</li>\n            <li>In the \"Timeframe\" dropdown, select the date range of the payments you would like to add</li>\n            <li>In the \"Transaction Type\" dropdown, select \"Transactions and Payments\"</li>\n          </ol>\n        </li>\n        <li>To download the document, go to your browser's \"File\" menu and click on \"Print\" to save your document as a PDF (do not click on the \"Export Transactions\" button because that will download a csv document, which will not be accepted)</li>\n        <li> Upload the PDF document to your Tuition.io account</li>\n      </ol>\n    </figure>\n    <p>A PDF is required, screenshots and csv/excel documents will not be accepted.</p>\n  }\n  edfinancial {\n    <h1>How to Download Your Transaction History Document:</h1>\n    <figure>\n      <legend>EdFinancial Services - Federal Direct Loan Program (FDLP)</legend>\n      <ol>\n        <li>Log into your account <a href=\"https://edfinancial.studentaid.gov/welcome\" target=\"_blank\">here</a> (it will be easier to get the documents required from a desktop/laptop rather than a mobile device)</li>\n        <li>Under the \"Payment and Billing\" menu, click \"Account History\"</li>\n        <li>In the \"Display\" dropdown, select \"By Transaction\" </li>\n        <li>In the \"Date Range\" dropdown, select the date range of the payments you would like to add</li>\n        <li>To download the document as a PDF, click on the \"Print\" button and save as a PDF (do not click on the \"Download\" button because that will download a csv document, which will not be accepted)</li>\n        <li>Upload the PDF document to your Tuition.io account</li>\n      </ol>\n    </figure>\n    <p>A PDF is required, screenshots and csv/excel documents will not be accepted.</p>\n  }\n  mohela {\n    <h1>How to Download Your Transaction History Document:</h1>\n    <figure>\n      <legend>Mohela Federal Student Loan</legend>\n      <ol>\n        <li>Log into your account <a href=\"https://mohela.studentaid.gov/\" target=\"_blank\">here</a> (it will be easier to get the documents required from a desktop/laptop rather than a mobile device)</li>\n        <li>Under the \"Payments & Billing\" menu, click on \"Account History\"</li>\n        <li>In the \"Display\" dropdown, select \"By Transaction\" </li>\n        <li>In the \"Date Range\" dropdown, select the date range of the payments you would like to add</li>\n        <li>To download the document as a PDF, click on the \"Print\" button and save as a PDF (do not click on the \"Download\" button because that will download a csv document, which will not be accepted)</li>\n        <li>Upload the PDF document to your Tuition.io account</li>\n      </ol>\n    </figure>\n    <p>A PDF is required, screenshots and csv/excel documents will not be accepted.</p>\n  }\n  nelnet {\n    <h1>How to Download Your Transaction History Document:</h1>\n    <figure>\n      <legend>Nelnet - Education Financing</legend>\n      <ol>\n        <li>Log into your account <a href=\"https://nelnet.studentaid.gov/account/login\" target=\"_blank\">here</a> (it will be easier to get the documents required from a desktop/laptop rather than a mobile device)</li>\n        <li>Under the \"Payments\" menu, click on \"Payment Activity\"</li>\n        <li>In the \"Show\" dropdown, select the date range of the payments you would like to add</li>\n        <li>To download the document, go to your browser's \"File\" menu and click on \"Print\" to save your document as a PDF</li>\n      </ol>\n    </figure>\n    <p>A PDF is required, screenshots and csv/excel documents will not be accepted.</p>\n  }\n  other {\n    <h1>How to Download Your Transaction History Document:</h1>\n    <figure>\n      <legend>If your servicer isn't listed in this menu, refer to the following generic instructions:</legend>\n      <ol class=\"decimal\">\n        <li>Log into your servicer account (it will be easier to get the documents required from a desktop/laptop rather than a mobile device)</li>\n        <li>Transaction Histories are generally found in areas on the website such as “Account History”, “Payment History”, or “Payment Activity”</li>\n        <li>Select the date range of the payments you would like to add</li>\n        <li>\n          There are a few ways you can potentially download your document:\n          <ol type=\"a\">\n            <li>Click on a \"Print\" button on the page and save as a PDF</li>\n            <li>If there is no \"Print\" button on the page, go to your browser's \"File\" menu and click on \"Print\" to save your document as a PDF</li>\n            <li>We can only accept PDF documents, some servicers provide a way to download transactions in a csv format but this will not be accepted</li>\n          </ol>\n        </li>\n        <li>Upload the PDF document to your Tuition.io account</li>\n      </ol>\n      <p>A PDF is required, screenshots and csv/excel documents will not be accepted.</p>\n    </figure>\n    <p>If you cannot locate your Transaction History, please contact your loan servicer by phone and ask them to email you a copy in PDF format.</p>\n  }\n}",
        "prompt": "Transaction History"
      }
    }
  },
  "observable_document": {
    "provider": "{provider, select,\n  ACCOUNT_STATEMENT { Account Statement }\n  NSLDS { NSLDS File }\n  ACCOUNT_TXN_HISTORY { Transaction History }\n  AMBIGUOUS { Unknown }\n  other {}\n}",
    "status": "{state, select,\n  PROCESSING { Processing }\n  INVALID { Invalid }\n  FAILED { Failed }\n  PROCESSED { Accepted }\n\n  APPLIED { Accepted }\n  PARTIALLY_APPLIED { In Review }\n  NOT_APPLIED { Failed }\n\n  IN_DISPUTE { In Review }\n  other {}\n}"
  },
  "october": "October",
  "of": "of",
  "ok": "OK",
  "or": "or",
  "partner": {
    "company": "Company",
    "eligibility_files": {
      "auto_process": "Auto Process",
      "eligibility_files": "Eligibility Files",
      "file_name": "File Name",
      "filter_by_date": "Start Date",
      "filter_by_status": "Status",
      "run_by": "Run By",
      "started_on": "Started On",
      "status": "Status",
      "strategy": "Strategy",
      "upload_eligibility_file": "Upload File"
    },
    "employee": {
      "accounts": "Accounts",
      "activation_date": "Activation",
      "address": "Address",
      "address_line1": "Address Line 1",
      "address_line2": "Address Line 2",
      "alert_info": "Manual updates to employee profile data <span class=\"font-semibold\">will be overridden</span> by the eligibility file if an eligibility file is also submitted.",
      "birth_year": "Birth Year",
      "cancel": "Cancel",
      "cancel_create": "Cancel Creation",
      "cards": "Cards",
      "change_plan": "Change Plan",
      "change_plans": "Change Plan",
      "chart": "Chart",
      "city": "City",
      "confirm": "Confirm",
      "contribution_amount": "Contribution Amount",
      "cost_center": "Cost Center",
      "country": "Country",
      "create_employee": "Add Employee",
      "create_employee_then_add_another": "Save and Add Another",
      "create_employee_then_dashboard": "Save and Return To Dashboard",
      "created_at": "Created on",
      "created_on": "Created on",
      "currency": "Currency",
      "current": "Current",
      "custom_partner_data": "Custom Partner Data",
      "deactivate": "Deactivate Employee",
      "deactivate_text": "Are you sure you want to deactivate this employee?",
      "deactivated": "Deactivated",
      "deactivated_on": "Deactivated on",
      "department": "Department",
      "eligibility_end_date": "Eligibility End",
      "eligibility_start_date": "Eligibility Start",
      "email": "E-Mail",
      "employee_details": "Employee Details",
      "employee_id": "Employee \"TIO\" ID",
      "employee_profile": "Employee Profile",
      "employee_status": "Employee Status",
      "employment_type": "Employee Type",
      "enrolled_on": "Enrolled on",
      "first_name": "First Name",
      "last_name": "Last Name",
      "loans": "Loans",
      "member_since": "Member since",
      "none": "There is no data to display",
      "participating": "Participating",
      "participation_status": "Participation Status",
      "payment_transactions": "Payment Transactions",
      "payroll_id": "Payroll ID",
      "pending": "Pending",
      "phone_number": "Phone Number",
      "plan": "Plan",
      "plan_details": "Plan Details",
      "postal_code": "Postal Code",
      "rate_period": "Rate Period",
      "reactivate": "Reactivate Employee",
      "reactivate_text": "Are you sure you want to reactivate this employee?",
      "reason": "Please enter a reason for this change",
      "role": "Role",
      "salary": "Salary",
      "search": "Search for Employees",
      "state": "State",
      "status": "Status",
      "table": "Table",
      "title": "Title",
      "total_accounts": "Total Accounts",
      "total_loans": "Total Loans"
    },
    "employees": "Employees",
    "partner": "Partner"
  },
  "phone_number": "Phone Number",
  "plan_details": {
    "cons": "Cons",
    "examples": {
      "con_1": "This is a bad thing though...",
      "con_2": "And this, too, is bad!",
      "description": "It's optional though. Without it there would be no description and the title would default to 'Plan Details'.",
      "details": {
        "description_1": "Absolutely yes.",
        "description_2": "Just like this.",
        "description_3": "Indeed.",
        "description_4": "No problem.",
        "title_1": "Do we want details?",
        "title_2": "How should they be formatted?",
        "title_3": "Will the component space them automicatically?",
        "title_4": "What if we add another?"
      },
      "pro_1": "This is a good thing.",
      "section_1": {
        "description": "with title and descriptions",
        "title": "Both Plan Deatails components can have addition sections"
      },
      "section_2": {
        "description": "and this is section 2's description!",
        "title": "Here is Section 2's Title"
      },
      "title": "You can add a title and decription to both Plan Detail components"
    },
    "pros": "Pros",
    "read_less": "Read Less",
    "read_more": "Read More",
    "title": "Plan Details"
  },
  "plan_tiers": "Plan Tiers",
  "planning_for_college": {
    "five_two_nine": {
      "529_vs_tax": "529 vs. Taxable Investment Account",
      "any_plan_text": "You can invest in any state’s plan and send your child to nearly any college they want, but there may be tax advantages to investing in your home state. Each plan carries with it it’s own fees and investment options.",
      "any_plan_title": "Any Plan, Any School",
      "benefits": "BENEFITS",
      "control_text": "The account owner retains control of the account. The named beneficiary has no rights to the funds, even after they turn 18. Account owners decide when withdrawals are taken and to whom.",
      "control_title": "Control",
      "disclaimer_text": "Past performance is no guarantee of future results. Any historical returns, expected returns, or probability projections may not reflect actual future performance. Investors should read carefully and consider the investment objectives, risks, fees, and expenses contained in the Program Disclosure Statement (issuer’s official statement) before investing in any 529 plan. Before investing, you should consider whether your or the beneficiary’s home state offers a 529 plan that provides state tax or other benefits that are only available for investments in the home state’s 529 plan. You should consult with a tax advisor about state and local taxes.",
      "disclaimer_title": "Legal Disclaimer:",
      "faq_0_a": "Although your home state might afford you additional benefits for investing in its plan, you can invest in ANY state’s 529 plan.",
      "faq_0_q": "Do I have to invest in my home-state’s 529 plan?",
      "faq_1_a": "No. No matter where you invest, your child is free to go to school at nearly any college in the country as well as hundreds overseas.",
      "faq_1_q": "Does my child have to go to a school in the state where I invest?",
      "faq_2_a": "529 savings are not limited to a traditional four-year college experience. Funds can be withdrawn tax-free if used toward the costs of any eligible institution, including technical, trade and other specialized schools. Beneficiaries of a 529 Plan can be changed to any qualified family member with no tax implications. Non-qualified withdrawals will subject your investment gains to normal income taxes and a 10% penalty.",
      "faq_2_q": "What if my child decides not to attend college?",
      "faq_3_a": "529 plan savings are considered in determining financial aid, but receive favorable treatment. Assets in a 529 account, if owned by a parent, are assessed at a maximum rate of 5.64%. That means the student’s eligibility for financial aid will decrease by no more than 5.64% of the account value. This treatment is considerably more favorable than a student’s other assets, which are assessed at 20%.",
      "faq_3_q": "Do savings in a 529 Plan affect financial aid?",
      "faq_4_a": "If the scholarship only covers tuition, you can still withdraw the funds in your 529 account tax-free if they are used toward things like room and board, books, equipment and other purchases required to attend the college. You can also remove an amount up to the scholarship, penalty-free, meaning your gains will only be subject to normal income taxes.",
      "faq_4_q": "What happens to the money in my 529 account if my child gets a scholarship?",
      "faq_5_a": "To take advantage of the tax benefits offered by a 529 plan, withdrawals must be spent on qualified higher education expenses, or up to $10,000 of private K-12 tuition. This could include tuition for any eligible postsecondary education institution, room and board, books, supplies, equipment and other purchases required for enrollment or attendance.",
      "faq_5_q": "What can I pay for from a 529 Plan?",
      "faqs": "FAQS",
      "fed_tax_benefits_text": "Contributions are made with after-tax dollars. However, your investment withdrawals are completely tax-free when used to pay for college expenses and up to $10,000 of private K-12 tuition.",
      "fed_tax_benefits_title": "Federal Tax Benefits",
      "flexibility_text": "Easily change account owners, beneficiary, plans, investment options, etc.",
      "flexibility_title": "Flexibility",
      "graph_assumptions_text": "$2,500 initial investment with subsequent monthly investment of $100 for a period of 18 years; annual rate of return on investment of 8% and no funds withdrawn during the time period specified; taxpayer is in the 30% federal income tax bracket for all options at the time of contributions and distribution. This hypothetical is for illustrative purposes only. it does not reflect an actual investment in any particular 529 plan or any taxes payable upon distribution.",
      "graph_assumptions_title": "Assumptions:",
      "high_contribution_text": "Gifts of $15,000 are allowed per year per beneficiary without any gift tax consequences. You can also elect to contribute 5 years worth of gifts at once ($75,000). Plans also have substantial contribution ceilings with the majority over $350,000.",
      "high_contribution_title": "High Contribution Limits",
      "little_savings_text": "A little savings each month can add up over time.",
      "minimal_financial_text": "Assets with a 529 plan are only assessed at a maximum of 5.64% (if owned by a parent).",
      "minimal_financial_title": "Minimal Financial Aid Effect",
      "monthly_deposit_charts": "Monthly Deposit Charts",
      "no_income_restrictions_text": "529 plans do not have income phase-outs like other savings vehicles. Anyone can open and contribute to a plan.",
      "no_income_restrictions_title": "No Income Restrictions",
      "online_courses": "Online Courses",
      "over_18_years": "Over 18 years",
      "piggy_bank": "piggy bank",
      "save_more_disclaimer_text": "This hypothetical example illustrates the future values of differing regular monthly contributions with an initial investment of $5,000 and a 6% return on investment. It is for illustrative purposes only. Past performance is no indication of future results in any 529 plan. Illustration does not account for any potential state tax benefits that may apply.",
      "save_more_title": "Save More. Start Early.",
      "saving_for_college": "Tuition.io has partnered with savingforcollege.com, an unbiased and independent resource that can help you learn about the highest-rated 529 plans.  Go to <a href=\"https://www.savingforcollege.com\" class=\"tio-copy\" target=\"_blank\">savingforcollege.com</a> to find your 529 plan today.",
      "saving_for_college_alt": "savingforcollege.com",
      "savings": "SAVINGS OVER TIME",
      "state_tax_benefits_text": "Your state may afford you a tax incentive for your contributions to a 529 plan in addition to the federal tax treatment.",
      "state_tax_benefits_title": "State Tax Benefits",
      "table_investments": "Table Investments",
      "tax_assumptions": "Assumptions: 20% capital gains rate. $5,000 initial deposit. No state tax deduction/credit",
      "tax_disclaimer_text": "Gradvisor provided Tuition.io with this information. Gradvisor is an SEC registered investment advisor. Past performance is no guarantee of future results. Any historical returns, expected returns, or probability projections may not reflect actual future performance. Investors should read carefully and consider the investment objectives, risks, fees, and expenses contained in the Program Disclosure Statement (issuer’s official statement) before investing in any 529 plan. Before investing, you should consider whether your or the beneficiary’s home state offers a 529 plan that provides state tax or other benefits that are only available for investments in the home state’s 529 plan. You should consult with a tax advisor about state and local taxes.",
      "tax_free_withdrawals": "Tax Free Withdrawals",
      "title": "529 Plans",
      "what_is_529_text": "A 529 Plan is an education savings plan operated by a state or educational institution designed to help families set aside funds for future college costs and private K-12 tuition.",
      "what_is_529_title": "What is a 529 Plan?",
      "withdrawal_power_text": "Tax advantages can make your dollars work harder. Year after year, the unique tax advantages of 529 plans can help you save more for your child’s college education.",
      "withdrawal_power_title": "The Power of Tax-Free Withdrawals"
    },
    "scholarship": {
      "apply": "<span class=\"text-ocean-600\">Apply</span>, apply, apply!",
      "apply_li_1": "There are over 1.5 million scholarships available. The more scholarships you apply for, the more potential awards you will receive.",
      "apply_li_2": "Read each application thoroughly to ensure you send in all the required paperwork by the due date.",
      "con_1": "Applying for scholarships can be a time consuming process. Use our scholarship search tool below to make it a little easier.",
      "cons_scholarship": "Cons of a Scholarship",
      "hero_detail": "A scholarship is money awarded to students for academic or other achievements that can be used towards college or career school, and does not have to be repaid.",
      "hero_title": "What is a scholarship?",
      "how_to_apply": "How to Apply",
      "keep_up": "<span class=\"text-ocean-600\">Keep Up</span> the Good Work",
      "keep_up_detail": "Be sure to keep up your grades and extracurricular activities. Most scholarship awards have requirements such as maintaining your GPA and keeping a full-time student status.",
      "learn_about": "Learn about the different options to decide the best path for you and your family. <a href=\"https://www.lendkey.com/scholarship-search/?sk=AFF-Tuitionio&utm_source=AFF-Tuitionio&utm_medium=referral&utm_campaign=AFF\" class=\"text-ocean-600 underline\">Search for Scholarships <span class=\"material-icons-round text-sm\">launch</span></a>  using our partner Lendkey's search tool on their website.",
      "pro_1": "The more you apply for, the better. Even the smaller scholarships are well worth the long application process. A $500 scholarship you receive today, is $500 + interest you won't have to pay back in the future.",
      "pro_2": "While financial aid is usually based on financial need, there are many different scholarships with a wide range of qualifiers. Awards are available for students with academic, artistic, or athletic talent, as well as for particular fields of study and underrepresented groups.",
      "pros_scholarship": "Pros of a Scholarship",
      "search": "<span class=\"text-ocean-600\">Search</span> for Scholarships",
      "search_button": "Search for Scholarships <span class=\"material-icons-round ml-4\">launch</span>"
    }
  },
  "plans": {
    "contribution_frequency": "Contribution Frequency",
    "contribution_plan": "Contribution Plan",
    "contribution_plan_details": "Contribution Plan Details",
    "contribution_plans": "Contribution Plans",
    "contribution_total_to_date": "Contribution Total To Date",
    "description": "Description",
    "edit_plan": "Edit Plan",
    "eligibility_date": "Eligibility Date",
    "eligibility_waiting_period": "Eligibility Waiting Period",
    "employee_eligibility_waiting_period": "Employee Eligibility Waiting Period",
    "employee_plan_summary": "My Plan Summary",
    "employees_enrolled": "Employees Enrolled",
    "from_cycle": "From Cycle",
    "lifetime_max": "Lifetime Benefit Maximum",
    "no_plan_attached": "No Plan Attached",
    "plan_description": "Plan Description",
    "plan_key": "Plan Key",
    "plan_name": "Plan Name",
    "plan_start_date": "Plan Start Date",
    "plans": "Plans",
    "view_all": "View All",
    "wellness_plan": "Wellness Plan"
  },
  "print": "Print",
  "prior_attachments": "Prior Attachments",
  "profile": {
    "add_family_member": "Add another family member",
    "child": "Child",
    "contact_info": "Contact Info",
    "copy_invite": "Copy invite",
    "default": "Profile",
    "email_invitation": "Email invitation",
    "email_use": "You will use this email to receive Communications",
    "employer_allows_blurb": "{employer} lets you invite family members to create their own Tuition.io account. Each family member can connect their own student loan accounts and access Tuition.io tools and resources.",
    "enter_family_info": "Enter your family member's information",
    "family_invitations": "Family invitations",
    "family_member_contact_info": "Family Member Contact Information",
    "family_member_invite": "Family Member Invitation",
    "grandchild": "Grandchild",
    "invite_link": "Invitation link",
    "invites": "Invites",
    "mobile_phone": "Mobile Phone",
    "my_family": "My Family",
    "my_profile": "My profile",
    "new_invite_blurb": "{firstName} can now register for a Tuition.io account using the link below. We can email the invitation link direction to {email} or you can copy the invitation link to send it yourself.",
    "no_email": "Add your primary email address",
    "no_phone": "Add your primary phone number",
    "parent": "Parent",
    "personal_info": "Personal Info",
    "phone_use": "We will use your phone number to send you SMS relevant plan related information",
    "relationship": "Relationship",
    "resend_invitation": "Resend invitation",
    "security_settings": "Security Settings",
    "sibling": "Sibling",
    "spouse": "Spouse/Partner",
    "to_edit_contact_support": "To edit contact tech support",
    "username": "Username",
    "username_login": "Username/Login",
    "what_is_family_relationship": "What is this family member's relationship to you?"
  },
  "program_builder": {
    "approval_workflow": {
      "roles": {
        "ADMIN_APPROVER": "Admin Approver",
        "APPROVER": "Approver",
        "CUSTOM_APPROVER": "Custom Approver",
        "CUSTOM_INDIVIDUAL_APPROVER": "Custom Individual Approver",
        "DEPARTMENT_HEAD": "Department Head",
        "FALLBACK": "Temporary Approver",
        "FINANCE_APPROVER": "Finance Approver",
        "HYPERVISOR": "Supervisor's Supervisor",
        "PPP_FINANCE_APPROVER": "PPP Finance Approver",
        "SUPERVISOR": "Supervisor",
        "TAP_FINANCE_APPROVER": "TAP Finance Approver",
        "TIO_APPROVER": "Tuition.io Approver"
      }
    },
    "notifications": {
      "estimated_days_to_payment": "Estimated Days to Payment",
      "payment_submission_min_days_before_year_end": "Payment Submission Min Days Before Fiscal Year End"
    }
  },
  "pslf": {
    "approver_email_landing_page": {
      "directive": "Please confirm {borrowerName}’s prior employment with {companyName} by completing the form. Press the ‘View PSLF form’ button below to see additional identifying information about {borrowerName}.",
      "explanation": "The US Department of Education requires all eligible Public Service Loan Forgiveness applicants to submit a PSLF Employment Certification Form for each qualifying employer. This form is being submitted to you {employerSignDate} by Tuition.io on behalf of {borrowerName} who provided the information on the form.",
      "if_in_error": "If you believe this form was sent to you by mistake, please contact Tuition.io directly by emailing us at <a href=\"mailto:support@tuition.io\" class=\"text-ocean-600\">support@tuition.io</a> or calling us at <span class=\"text-ocean-600\">+1 (855) 353-9395</span>",
      "sent_to_by": "Sent to {email} on {dateSent} by {borrowerName}",
      "view_form": "View PSLF Form",
      "what_is_org_name": "What is this organization's name?",
      "what_is_org_site": "What is this organization's website?"
    },
    "chart": {
      "lifetime": "Lifetime",
      "today": "24 Hours",
      "week": "This Week"
    },
    "company_settings": {
      "enabled_on": "Enabled On:",
      "general": "General",
      "is_enabled": "Is Enabled:",
      "is_enabled_prior": "Is Enabled Prior Employer Workflow:",
      "is_non_partner_approver": "Is Non-Partner Approver:"
    },
    "complete_pslf": {
      "already_signed": "This form has already been signed.",
      "default": "Complete PSLF Form",
      "done": "Thank you for signing your form. Your form will be properly submitted. Please press Done to exit this process.",
      "done_employer": "Tuition.io will send this completed PSLF form to the US Department of Education for approval. If you have questions about the status of the form please contact Tuition.io for assistance. If you need a copy of the form for your records please reach out directly to this user.",
      "done_employer_subheader": "You completed {name}'s PSLF form on {date}",
      "note": "Please review your completed PSLF form below and sign on page two. When done, select ‘Finish’ from the ‘More Actions’ menu in the upper-right of the document.",
      "title": "Please Sign Your Form",
      "title_success": "Thank you for completing!"
    },
    "dashboard": {
      "alert_borrower_signed": "You have completed your portion of the PSLF form. We have sent this to your employer so they can complete sections 3 and 4. You will be able to track the status of your PSLF Form here on your PSLF Dashboard",
      "alert_created": "Complete your portion of the PSLF form. The US Department of Education requires all eligible PSLF applicants to submit a PSLF Form for each qualifying employer. We recommend submitting the PSLF form at least once every year, and any time you change employers.",
      "alert_upload_docs": "Upload any documentation you’ve received from the Department of Education showing the number of qualifying payments you’ve made.",
      "tabs": {
        "start_new_form": "Start a new PSLF form",
        "strategy_finder_history": "strategy finder history",
        "take_strategy_finder": "strategy finder",
        "uploaded_documents": "My forms & documents",
        "your_dashboard": "My pslf dashboard"
      },
      "widgets": {
        "add_loans_message": "*Having trouble adding your loans? {link}",
        "approval": "Review and approve PSLF forms for your employees",
        "are_you_interested_in_pslf": "Are you interested in pursuing Public Service Loan Forgiveness?",
        "link_text": "Upload a student loan statement",
        "stay_on_track": "You are working toward Public Service Loan Forgiveness and it is really important you stay on track.",
        "strategy_finder_btn": "start strategy finder",
        "strategy_finder_subtitle": "Next steps to a better repayment plan"
      }
    },
    "default": "PSLF",
    "default_approval": "PSLF Approval",
    "default_full": "Public Service Loan Forgiveness",
    "document_repo": {
      "approver_info": "Approver Info",
      "change_approver": "Change Approver",
      "classification": {
        "default": "Classification",
        "pslf_form": "PSLF Form",
        "pslf_letter": "Letter from the U.S. Department of Education",
        "pslf_loan": "Student loan statement",
        "pslf_or_ecf_form": "PSLF form (Previously ECF form)",
        "pslf_other": "Other"
      },
      "confirm_delete_prompt": "Are you sure you want to delete this document?",
      "confirm_disable_prompt_1": "This will prevent any further completion of your form.",
      "confirm_disable_prompt_2": "It will not be submitted to the Department of Education.",
      "confirm_disable_title": "You are about to disable your PSLF Form.",
      "date_employer_signed": "Date Employer Signed",
      "date_you_signed": "Date You Signed",
      "default": "My PSLF Forms & Documents",
      "dept_ed_fax_no": "540-212-2415",
      "dept_ed_mailing_address": "U.S. Department of Education <br>P.O. Box 300010 <br>Greenville, TX 75403",
      "description": "Description",
      "disclaimer_header": "Please read carefully and check the boxes below to continue:",
      "docs_and_statements": "Documents & Statements",
      "document_type": "Document type",
      "form_type_and_employer": "Form Type & Employer",
      "must_mail": "You MUST mail or fax your PSLF form to the Department of Education yourself.",
      "my_pslf_forms": "My PSLF Forms",
      "no_documents_found": "No documents found",
      "no_forms_found": "No forms found",
      "not_dept_ed": "Uploading your PSLF form does NOT submit this document to the Department of Education.",
      "print_and_mail": "Print & mail",
      "pslf_form_type_disclaimer": "Uploading your PSLF form does NOT submit this document to the Department of Education. You MUST mail or fax your PSLF form to the Department of Education yourself.",
      "pslf_recs": "PSLF Recommendations",
      "required": "*Required",
      "resend": "Resend",
      "resend_email_error": "An error occurred while attempting to email {email}",
      "resend_email_success": "A reminder has been sent to {email}",
      "send_us_your_doc": "Send Us Your Document",
      "start_new_pslf_form": "Start a New PSLF Form",
      "text_area_label": "Optional description (For example, \"Approved PSLF form\")",
      "tio_does_not_submit": "Tuition.io does not send uploaded documents to your employer for completion. If this upload requires an employer signature you will need to complete the form using our digital PSLF tool.",
      "uploaded_at": "Uploaded At",
      "what_type_of_doc": "What type of document is this?",
      "why_upload_docs": "Keeping documents on your portal will help you stay on track and ensure that you have the right paperwork when it's time to submit your final PSLF Form for loan forgiveness."
    },
    "employer_sign_page_title": "Sign PSLF Form",
    "employer_workflow": {
      "average_hours_per_week": "Average Hours / Week",
      "current_employee": "Current Employee",
      "edit_info": "No, Edit Information",
      "employee_information": "Employee Information",
      "employer_info_correct": "Employer Information Correct",
      "employer_information": "Employer Information",
      "employer_name_blurb": "This should be the official name. The name should match what is listed on the organization's website or in official documents.",
      "employment_status_current": "What is {name}'s employment status?",
      "employment_type": "Employment Type",
      "fein_header": "Federal Employer Identification Number (FEIN)",
      "full_time_means": "Full-time means working for one or more qualifying employers for the greater of: (1) an annual average of at least 30 hours per week or, for a contractual or employment period of at least 8 months, an average of 30 hours per week; or (2) unless the qualifying employment is with two or more employers, the number of hours the employer considers full time.",
      "government_org": "Government organization",
      "hours_sub": "Include vacation, leave time, or any leave taken under the Family Medical Leave act of 1993. </br> Do not include any hours spent on religious instruction, worship services, or proselytizing.",
      "how_many_hours_current": "About how many hours per week does {name} work?",
      "if_incorrect": "If any of the information above appears to be wrong, please contact Tuition.io Partner Support at +1 (855) 353-9395 or {email} to correct it.",
      "is_info_correct": "Is this information correct?",
      "last_chance": "This is your last chance to make changes. Verify that all the information below is correct.",
      "org_type": "Organizational Type",
      "partner_approver_page_header": "PSLF Partner Approver Flow",
      "please_review": "Please review this information before proceeding.",
      "political_org": "Partisan political organization or a labor union",
      "prior_employee": "Prior Employee",
      "private_nonprofit": "Non-profit that is NOT a 501(c)(3)",
      "proceed_with_info": "Yes, Information Correct",
      "public_nonprofit": "501(c)(3) non-profit organization",
      "review_employer_info": "Review {name}'s Employer Information:",
      "verify_employer_info": "Verify Information",
      "warning": "After this step, <b>changes cannot be made</b> to the PSLF form.",
      "what_is_this_orgs_ein": "What is this organization's Federal Employer Identification Number (FEIN)?",
      "what_was_start_date": "What was {name}'s employment start date and end date?"
    },
    "form-type": {
      "currentEmployer": "Current Employer",
      "priorEmployer": "Prior Employer"
    },
    "form_no_longer_awaiting_approval": "This form is no longer awaiting approval. You're good to go!",
    "forms": {
      "address": "Address:",
      "approver": "Approver",
      "borrower_header": "Borrower Fields",
      "common_name": "Common Name:",
      "created_by": "Created by",
      "current_employer": "Current employer",
      "doc_id": "Document ID:",
      "email": "Email:",
      "email_is_group_inbox": "Email is group inbox:",
      "employer_header": "Employer Fields",
      "fax_sent_error": "An error occurred. Unable to initialize fax.",
      "fax_sent_success": "Fax has been initialized and is in progress.",
      "fein": "FEIN:",
      "form_id_header": "PSLF Form Detail",
      "group_details": "Group Details",
      "group_id": "Group ID:",
      "index_forms_p": "T.io PSLF Forms",
      "index_page_title": "PSLF Forms",
      "is_501c3": "Is tax exempt 501(c)(3) organization:",
      "is_govt": "isGovernment:",
      "is_govt_org": "Is government organization:",
      "is_political": "isPolitical:",
      "is_political_org": "Is political organization:",
      "is_tax_exempt": "isTaxExempt:",
      "legal_name": "Legal Name:",
      "name": "Name:",
      "non_profit_not_501c3": "Is non-profit that is NOT a 501(c)(3):",
      "not_for_profit": "isNotForProfit:",
      "payroll_id": "Employee Payroll ID:",
      "phone_number": "Phone Number:",
      "prior_employer": "Prior employer",
      "pslf_form": "PSLF Form",
      "raw_values": "Raw Values",
      "refresh": "Refresh",
      "search_forms": "Search forms",
      "send_fax": "Send Fax",
      "services": "Services:",
      "title": "Title:",
      "view_pdf": "View PDF",
      "view_profile": "View PSLF Profile",
      "view_user_profile": "View User Profile",
      "website": "Website:"
    },
    "no_employee_record": "No employee record",
    "phone": {
      "approver": "You are listed as the assigned PSLF Form approver by {company}. Please complete sections 3 & 4 of the PSLF Form submitted {formSubmittedDate} by {borrowerName}.",
      "default": "Phone"
    },
    "profiles": {
      "company_prefix": "Employee at",
      "interested_bool": "Is interested in PSLF?",
      "profile_header": "PSLF Profile:",
      "qualifying_payments": {
        "expected_forgiveness_date": "Expected Forgiveness Date",
        "loan_id": "Aggregation Loan ID",
        "loan_name": "Loan Name",
        "no_observations": "No loan forgiveness observations",
        "potential_payments": "Potential Payments",
        "provider": "Provider",
        "qualifying_payments": "Qualifying Payments",
        "unknown": "Unknown"
      },
      "ssn": "SSN (last four)",
      "uploads": "PSLF Uploads"
    },
    "questions": {
      "am_i_eligible": "Am I eligible?",
      "income_driven": {
        "borrower_eligibility": {
          "description": "If you had an original loan balance of $12,000 or less, you could receive forgiveness of any balance remaining after 10 years of income-driven payments. If you had an original loan balance >$12,000, you could receive forgiveness of any balance remaining after 20 to 25 years of income driven payments.",
          "title": "Borrower Eligibility"
        },
        "idlf": {
          "description": "Forgives the remaining loan balance after 10 or 20-25 years depending on the specific amount of your original loans, the type of loan, and when you took out the loan.",
          "item_1": "Don’t refinance (refinanced loans are private and ineligible for income-driven loan forgiveness)",
          "item_2": "Any borrower with FFEL loans should consolidate their FFEL loan(s) to a Direct Consolidation loan to take advantage of new benefits related to cancellation and income-driven repayment plans.",
          "title": "Income-Driven Loan Forgiveness"
        },
        "loan_types": {
          "description": "Varies by plan. Direct loans made to students are eligible under all plans.",
          "title": "Eligible loan types"
        },
        "make_the_switch": {
          "item_1": "Make sure your income information is up today. <a class=\"text-ocean-600 font-semibold\" href=\"https://studentaid.gov/idr/\">Apply for an income-driven plan or update your income information.</a>",
          "title": "Ready to make the switch?"
        },
        "plan": {
          "cons": {
            "item_1": "Forgiven amount is taxed as income, that can mean a significant tax bill",
            "item_2": "It takes a long time to earn income-driven loan forgiveness, 20-25 years.",
            "title": "Cons"
          },
          "forgiven_after": {
            "description": "10 years if your loan balance is $12,000 or less; or 20-25 years if your original loan balance is greater than $12,000.",
            "title": "Forgiven after"
          },
          "max_forgiveness": {
            "description": "No max amount",
            "title": "Max forgiveness"
          },
          "pros": {
            "item_1": "This is a loan forgiveness option available for all borrowers of federal student loans regardless of their type of employment. If a borrower has eligible loans, they can qualify.",
            "title": "Pros"
          },
          "tax_info": {
            "description": "Forgiven amount is not taxed as income through the end of 2025.",
            "title": "Tax information"
          }
        },
        "tab_title": "Income-Driven"
      },
      "loan_forgiveness_programs": "Loan Forgiveness Programs",
      "need_more_help": {
        "description": "If you need more help picking the right plan for you, check out the <a class=\"text-ocean-600 font-semibold\" href=\"/repaying-student-debt/repayment-strategy-finder\">Tuition.io Strategy Finder</a>",
        "title": "Need more help?"
      },
      "next_steps": "Next Steps",
      "plan_details": "Plan Details",
      "public_service": {
        "borrower_eligibility": {
          "description": "The specific job you do doesn’t determine your eligibility. Eligibility is determined by your employer. If you work for a government organization (federal, state, local, or tribal) your employer qualifies. If you work for a not-for-profit company that’s tax exempt under 501(c)(3) of the IRS code you qualify. Other types of non-profits that provide certain qualifying public services are also eligible. Check out <a class=\"text-ocean-600 font-semibold\" href=\"https://studentaid.gov/pslf/employer-search\">this link</a> for more information about qualifying employers.",
          "title": "Borrower Eligibility"
        },
        "direct_loans": {
          "item_1": "Consolidating Direct Loans isn't necessary to access one time account adjustment benefits but can help some borrowers maximize their payment credit.",
          "item_2": "If you consolidate Direct Loans <b>before 6/30/2024</b>, you will be credited with the maximum number of payments on the new consolidation loan.",
          "title": "Direct Loans"
        },
        "do_not_refinance": "Do not refinance (refinanced loans are private and ineligible for PSLF)",
        "ffel_or_perkins": {
          "item_1": "You <span class=\"font-semibold\">must consolidate</span> these loans to a <a class=\"text-ocean-600 font-semibold\" href=\"https://studentaid.gov/app/launchConsolidation.action\">Direct Consolidation Loan</a> before 6/30/2024",
          "item_2": "Once you have consolidated, complete & submit the PSLF form.",
          "item_3": "All past payments will be counted as qualifying payments toward the required 120.",
          "title": "FFEL or Perkins Loans"
        },
        "important_info": "Important Information About the One Time Account Adjustments that Helps You Get Closer to PSLF",
        "info_description": "PSLF forgives the remaining balance on your Direct Loans after you have made 120 qualifying monthly payments under a qualifying repayment plan while working full-time for a qualifying employer.",
        "loan_types": {
          "item_1": "Federal Direct Loans",
          "item_2": "Direct Consolidation Loans (your 120 payments will start from the time of consolidation)",
          "title": "Eligible loan types"
        },
        "make_the_switch": {
          "item_1": "Make sure you have eligible Federal Direct loans.",
          "item_2": "Make sure you're on an eligible income-driven repayment plan. You can <a class=\"text-ocean-600 font-semibold\" href=\"https://studentaid.gov/app/ibrInstructions.action\">apply for an income-driven plan</a> on the Department of Education website. It's free and easy and takes < 10 minutes.",
          "item_3": "Submit <a class=\"text-ocean-600 font-semibold\" href=\"https://studentaid.gov/sites/default/files/public-service-application-for-forgiveness.pdf\">the PSLF form</a> to make sure you're in eligible employment and to track your progress toward the required 120 payments.",
          "item_4": "Continue to make on time monthly payments.",
          "title": "Ready to make the switch?"
        },
        "plan": {
          "cons": {
            "item_1": "Requires employment by eligible employer for 10 years",
            "item_2": "The process can be arduous and complex. Borrowers will need to recertify income annually to remain on their income driven repayment plan and it’s a very good idea to verify each new employer to ensure they qualify, and track progress toward forgiveness annually to identify any problems early.",
            "title": "Cons"
          },
          "forgiven_after": {
            "description": "120 eligible monthly payments (10 years minimum)",
            "title": "Forgiven after"
          },
          "max_forgiveness": {
            "description": "No max amount",
            "title": "Max forgiveness"
          },
          "pros": {
            "item_1": "No cap on the loan amount forgiven",
            "item_2": "Forgiven loan amount is not taxed as income",
            "title": "Pros"
          },
          "tax_info": {
            "description": "Forgiven loan amount is not taxed",
            "title": "Tax information"
          }
        },
        "pslf_description": "PSLF forgives the remaining balance on your Direct Loans after you have made 120 qualifying monthly payments under a qualifying repayment plan while working full-time for a qualifying employer.",
        "pslf_title": "Public Service Loan Forgiveness",
        "questions": {
          "item_1": "Review guidance from the Department of Education here: <a class=\"text-ocean-600 font-semibold\" href=\"https://studentaid.gov/announcements-events/pslf-limited-waiver\">Federal Student Aid</a>",
          "item_2": "<a class=\"text-ocean-600 font-semibold\" href=\"/repaying-student-debt/askjeni\">Ask a student loan coach</a>",
          "title": "Questions about the One Time Account Adjustment?"
        },
        "repayment_plan_eligibility": {
          "item_1": "Past payments under any repayment plan will be counted as qualifying payments",
          "item_2": "Past ineligible loan payments can be recounted toward 120 total payments",
          "item_3": "Past partial loan payments or late loan payments will be counted as qualifying payments",
          "title": "Repayment Plan Eligibility"
        },
        "stay_on_track": {
          "item_1": "Every year, submit your income documentation and <a class=\"text-ocean-600 font-semibold\" href=\"https://studentaid.gov/sites/default/files/public-service-application-for-forgiveness.pdf\">renew your income driven repayment plan</a>.",
          "item_2": "Every year, submit <a class=\"text-ocean-600 font-semibold\" href=\"https://studentaid.gov/sites/default/files/public-service-application-for-forgiveness.pdf\">the PSLF form</a> to keep track of your employment history and update your eligible payment count.",
          "item_3": "Contact your student loan servicer right away if you notice any problems with your eligible payment count. Resolving problems early prevents delays in loan forgiveness.",
          "title": "What do I need to do to stay on track?"
        },
        "tab_title": "Public Service",
        "unconsolidated_plus": {
          "item_1": "Unconsolidated Parent PLUS loans <span class=\"font-semibold\">are eligible to have past payments counted</span> under the one time account adjustments.",
          "item_2": "To make future qualifying payments toward the required 120 for PSLF, these loans must be consolidated to a Direct Consolidation Loan and repaid under the income-contingent repayment plan.",
          "title": "Unconsolidated Parent PLUS Loans"
        },
        "which_repayment": {
          "item_1": "Income-Based Repayment",
          "item_2": "Income-Contingent Repayment",
          "item_3": "PAYE",
          "item_4": "SAVE",
          "title": "Which repayment do I have to be on?"
        }
      },
      "teacher": {
        "borrower_eligibility": {
          "description": "You must have been employed as a full-time teacher for five complete and consecutive academic years, and at least one of those years must have been after the 1997–98 academic year, in an elementary or secondary school that serves low-income students.",
          "title": "Borrower Eligibility"
        },
        "loan_types": {
          "description": "Direct & FFEL subsidized and unsubsidized loans. Parent PLUS and Graduate PLUS loans are not eligible.",
          "title": "Eligible loan types"
        },
        "make_the_switch": {
          "item_1": "Check the <a class=\"text-ocean-600 font-semibold\" href=\"https://studentaid.gov/tcli/\">directory of eligible schools</a> to make sure yours qualifies.",
          "item_2": "Continue making payments on time to keep your loans in good standing.",
          "item_3": "Submit the <a class=\"text-ocean-600 font-semibold\" href=\"https://studentaid.gov/app/downloadForm.action?searchType=library&shortName=teachfrgv&localeCode=en-us\">teacher loan forgiveness application</a> after 5 years of eligible teaching.",
          "title": "Ready to make the switch?"
        },
        "plan": {
          "cons": {
            "item_1": "Only forgive $5,000 or $17,500",
            "item_2": "Very specific criteria to qualify",
            "item_3": "Borrower may be better off using PSLF if they work for an eligible employer",
            "title": "Cons"
          },
          "forgiven_after": {
            "description": "5 years",
            "title": "Forgiven after"
          },
          "max_forgiveness": {
            "description": "$5,000 or $17,500",
            "title": "Max forgiveness"
          },
          "pros": {
            "item_1": "Fast way to get loans forgiven, only takes 5 years",
            "item_2": "Forgiven amount is tax free",
            "title": "Pros"
          },
          "tax_info": {
            "description": "Forgiven amount is not taxed as income",
            "title": "Tax information"
          }
        },
        "tab_title": "Teacher",
        "tlf": {
          "description": "If you teach full-time for five complete and consecutive academic years in certain elementary and secondary schools and educational service agencies that serve low-income families, and meet other qualifications, you may be eligible for forgiveness of up to $5,000 or $17,500 of your undergraduate federal student loans.",
          "how_to_choose": {
            "description": "Figure out how much you will pay if you use teacher loan forgiveness and repay the remaining balance of your student loans and compare that to the amount you will pay if you make 120 payments toward PSLF and then have the balance forgiven. Choose the option that saves you the most money.",
            "title": "How to choose TLF v PSLF?"
          },
          "item_1": "Don’t refinance (refinanced loans are private and ineligible for teacher loan forgiveness)",
          "item_2": "If you’re planning to teach for at least 10 years at a public school system and have a large enough student loan amount you could save more money using PSLF so may not want to use teacher loan forgiveness. You can’t overlap these programs so would have to pay on your student loans for 15 years (5 for teacher loan forgiveness and 10 for PSLF) instead of only 10 years if you went straight to PSLF",
          "title": "Teacher Loan Forgiveness"
        }
      },
      "what_is_loan_forgiveness_a": "You might qualify for forgiveness of your student loans if you meet specific eligibility criteria. Borrowers who might qualify are public service workers, teachers in low-income school districts, and borrowers with high debt relative to their income.",
      "what_is_loan_forgiveness_q": "What is loan forgiveness?",
      "whats_the_catch": {
        "catch_1": "Under some loan forgiveness options the amount of student loans forgiven is taxable as income. Some borrowers may be able to repay their debt more quickly with another repayment strategy.",
        "catch_2": "Only certain types of borrowers are eligible for some forgiveness plans, like those who work for the government or a non-profit.",
        "catch_3": "If you refinance your federal loans, you will no longer be eligible for loan forgiveness.",
        "title": "This sounds great! But what’s the catch?"
      }
    },
    "start_new": {
      "bullet_1": "Complete your portion of the PSLF form",
      "bullet_2": "Your employer approves the PSLF form",
      "bullet_3": "Tuition.io will electronically deliver your completed form to the Department of Education",
      "bullet_4": "Within 90 days after your submission, the Department of Education will review your form and send you a letter with results.",
      "continue_my_form": "Continue my PSLF form",
      "current": "My current employer",
      "current_reason": "Please start with completing a PSLF form for your current employer once a year, and any time you change employers.",
      "former": "My former employer",
      "former_reason": "Please fill out a form for a former employer if you have worked for a non-profit. The time you spent working for the non-profit employer will count towards PSLF.",
      "if_already_submitted": "What if I already submitted my PSLF form?",
      "if_already_submitted_answer": "If you're still working toward PSLF, we recommend submitting the PSLF form at least once every year and any time you change employers. Tuition.io makes submitting the PSLF form easy.",
      "is_form_new": "Is this a new form?",
      "is_form_new_answer": "Yes. There was formerly an Employment Certification Form, PSLF Application Form, and Temporary Expanded PSLF Application Form. All of these forms are now streamlined into the PSLF Form.",
      "pslf_form_header": "Public Service Loan Forgiveness (PSLF) form",
      "pslf_form_preamble": "We'll just need to confirm & collect a few details about you and your employer.",
      "pslf_preamble": "This will only take a minute. The US Department of Education requires the following information from you. Once you have completed the form below, we will submit it to the US Department of Education.",
      "questions_about_form": "Questions about Public Service Loan Forgiveness (PSLF)",
      "select_employer": "Select below which employer you will send your PSLF form to",
      "start_my_form": "Start my PSLF form",
      "start_new_form": "Start new form",
      "what_happens_on_submit": "What happens when I submit my Public Service Loan Forgiveness form?",
      "what_happens_on_submit_answer": "Tuition.io will send the form to your employer to complete their portion. Then we will send it to the Department of Education for approval. Once you get an approved form, upload it to your Tuition.io account so we can help you keep track of your progress towards PSLF.",
      "what_happens_to_loans": "What will happen to my loans?",
      "what_happens_to_loans_answer": "If this is the first time completing a PSLF form, your Federal student loans may transfer to another servicer who administers the PSLF program. Be sure to keep an eye on your student loans for changes, and update your information on your Tuition.io portal if needed.",
      "why_submit_form": "Why do I need to submit a PSLF form?",
      "why_submit_form_answer": "You will want to submit the PSLF form to track your eligible payments and eligible employment. It serves as a record and helps you catch any counting errors early.\n\nYou will need to submit the PSLF Form if you believe you have already made 120 qualifying payments and would like to apply for PSLF or TEPSLF.\n\nYou will need to submit the PSLF Form if you have already made 120 qualifying payments, are applying for PSLF/TLF, and would like to place your loans in forbearance while you wait for the Department of Education to evaluate your eligibility for Loan Forgiveness.\n"
    },
    "status": {
      "click_here_to_start": "Click here to start the approval process"
    },
    "status_tippy": {
      "canceled": "This form will not be sent to the Dept of Education",
      "cancelled": "This form will not be sent to the Dept of Education",
      "submitted": "Contact the <a class=\"text-ocean-600 font-semibold\" href=\"https://www.studentaid.gov/\">Department of Education</a> for the most up-to-date status"
    },
    "table": {
      "approver_email": "Approver Email",
      "borrower_email": "Borrower Email",
      "borrower_name": "Borrower Name",
      "borrower_signed_date": "Borrower Signed Date",
      "date_borrower_signed": "Date borrower signed",
      "employer_signed_date": "Employer Signed Date",
      "form_type": "Form Type",
      "not_applicable": "N/A",
      "pending": "Pending",
      "print_and_mail": "Sent by mail",
      "prior_employer_closed": "Employer closed"
    },
    "view_pslf_profile": "View PSLF Profile",
    "what_next": {
      "check_your_email": "Check your email",
      "current_body_description": "{companyName} might communicate with you directly by email if they have questions about your PSLF form and need clarification.",
      "current_body_heading": "We are sending your form to your employer",
      "current_bullet_msg": "What to expect:",
      "current_bulletpoint_1": "We will let you know once {companyName} has completed their portion",
      "current_bulletpoint_2": "We will then send your PSLF form to the U.S. Department of Education for final approval",
      "current_bulletpoint_3": "We will send you an annual reminder to resubmit your PSLF to keep you on track.",
      "current_description": "Nice work! We are sending your signed PSLF form to {companyName}. Be sure to come back to your Tuition.io portal regularly to check for updates to your form’s status.",
      "print_mail": "PRINT AND MAIL PAPER COPY",
      "prior_certify_body_description": "Your former employer might communicate with you directly by email if they have questions about your PSLF form and need clarification.",
      "prior_certify_body_heading": "We are sending your form to your former employer {companyName}",
      "prior_certify_bullet_msg": "What to expect:",
      "prior_certify_bulletpoint_1": "We will let you know once your former employer has completed their portion",
      "prior_certify_bulletpoint_2": "We will then send your PSLF form to the U.S. Department of Education for final approval",
      "prior_certify_bulletpoint_3": "We will send you an annual reminder to resubmit your PSLF to keep you on track.",
      "prior_certify_description": "Nice work! We are sending your signed PSLF form to {companyName}. Be sure to come back to your Tuition.io portal regularly to check for updates to your form’s status.",
      "prior_closed_body_description": "They should contact you in the next 1 to 3 months.",
      "prior_closed_body_heading": "You should hear back from the U.S Department of Education directly.",
      "prior_closed_bullet_desc_1": "Domestic: 855-265-4038.",
      "prior_closed_bullet_desc_2": "International: 717-720-1985.",
      "prior_closed_bullet_desc_3": "TTY: dial 711, then enter 800-699-2908.",
      "prior_closed_bullet_msg": "You have the following options for sending your PSLF form:",
      "prior_closed_bulletpoint_1": "Try calling for assistance:",
      "prior_closed_bulletpoint_2": "Or schedule time with a {link}",
      "prior_closed_bulletpoint_link_text": "Tuition.io student loan coach",
      "prior_closed_description": "Since you told us your prior employer has either closed or has refused to certify your employment, we will send your form directly to the U.S. Department of Education so they can assist you.",
      "prior_closed_footer": "SUBJECT: The U.S. Department of Education requires you to review sections 3 & 4 of Alex Doe’s PSLF form",
      "prior_closed_icon_text": "WAIT TO BE CONTACTED",
      "send_body_heading": "Send your PSLF form to {companyName}",
      "send_bullet_msg": "You have the following options for sending your PSLF form:",
      "send_bulletpoint_1_current": "You can print and mail a paper copy to your employer’s postal address",
      "send_bulletpoint_1_prior": "You can print and mail a paper copy to your former employer’s postal address",
      "send_bulletpoint_2": "You can download and email a PDF attachment",
      "send_bulletpoint_3": "You can copy and paste the message below into the email you send with your attached form",
      "send_button_2": "COPY EMAIL TEXT",
      "send_description": "Now that you have signed your portion of your form, it is time to send it to {companyName} so they can complete sections 3 & 4. Once they have completed their portion they will return your PSLF form to back to you.",
      "send_footer": "SUBJECT: The U.S. Department of Education requires you to review sections 3 & 4 of Alex Doe’s PSLF form",
      "send_icon_text": "Send your PSLF form",
      "send_text_input_current": "Hi {contactName},\\n \\nI work at {companyName} and need to certify my employment for the purpose of Public Service Loan Forgiveness. \\n\\nCan you please complete sections 3 & 4 of the attached form? \\n \\nAlternatively, you can complete the form manually and send it back to me.\\n \\nThank you for your help,\\n{borrowerName}",
      "send_text_input_prior": "Hi {contactName},\\n \\nI previously worked at {companyName} from {startDate} until {endDate} and need to certify my employment for the purpose of Public Service Loan Forgiveness. \\n\\nCan you please complete sections 3 & 4 of the attached form? \\n \\nAlternatively, you can complete the form manually and send it back to me.\\n \\nThank you for your help,\\n{borrowerName}",
      "what_next": "What happens next?"
    },
    "workflow": {
      "about_you": "About you: ",
      "about_your_employer": "About your employer: ",
      "address": {
        "address_correct": "This address is correct",
        "apt": "Apartment number or suite",
        "city": "City",
        "deliverable": "This street address is deliverable",
        "enter_or_confirm": "Please enter or confirm your details:",
        "not_deliverable": "This street address is not deliverable",
        "please_double_check": "Please double check your entry",
        "state": "State",
        "street_address": "Street Address",
        "valid": "Valid Address",
        "verify": "Verify",
        "what_address": "What is your address?",
        "where_you_live": "Where do you currently live and file your taxes",
        "whoops": "Whoops, this doesn't look like a valid address",
        "zip": "Zip Code"
      },
      "average_hours_per_week": "About how many hours per week did you work?",
      "birthday": {
        "day": "Day",
        "month": "Month",
        "what_birthday": "What is your birthday?",
        "year": "Year"
      },
      "borrower_employer_ein_label": "What is this organization’s Federal Employer Identification Number (EIN)?",
      "confirm_employment_info": "Confirm Employment Information",
      "contact_name": "Contact’s name (if available)",
      "contact_name_hint": "Optional - Not required to submit electronically.",
      "contact_phone": "Contact’s phone number",
      "contact_title": "Contact’s Title (if available)",
      "correct_email": "Are you sure the email address is correct?",
      "correct_email_alert": "Tuition.io will email the address provided so that my employer can review and sign my application for PSLF. If you don’t know your employer’s email, you can alternatively print and mail a paper copy using their postal address.",
      "correct_email_hint": "This could be someone in Benefits or Human Resources, or your manager. It’s important to confirm this is the correct email so we can ensure your PSLF form gets submitted correctly. <br /> <br /> Please confirm your employer’s email address:",
      "emails_must_match": "Emails must match",
      "employer_email": "Employer email",
      "employer_email_2": "Re-enter employer email",
      "employer_email_2_hint": "It’s important to confirm this is a valid email so we can make sure your PSLF form gets submitted correctly.",
      "employer_email_hint": "*Required - If you don’t know your employer’s email, you can alternatively print and mail a paper copy using their postal address.",
      "employer_name": "Employer Name",
      "employer_website": "Employer website (if any)",
      "end_date": "End Date",
      "full_time_employee": "Full-Time Employee",
      "if_work": "If you’ve worked for this employer during different time periods, you should fill out a new PSLF certification form for each period.",
      "info_changed": {
        "n_a": "I've never submitted a PSLF form before",
        "no": "No, my information is all the same",
        "question": "Has your identifying information changed since you last submitted a PSLF form?",
        "yes": "Yes, my information has changed since I last submitted a PSLF form"
      },
      "info_is_from_borrower": "The information you see below was provided by the borrower. If you see anything incorrect, please edit.",
      "is_employer_info_correct": "Is the Employer information correct?",
      "match_name": "The name should match what is listed on the employer website or in official documents.",
      "multi_employer_full_time": "Did you work for two or more 501(c)(3) non-profit and/or government employers that added up to at least 30 hours of work per week?",
      "no_employer_email": "No, I'll need to print and mail the form myself",
      "part_time": "Part Time",
      "part_time_employee": "Part-Time Employee",
      "phone_email": {
        "alternate": "Alternate Phone Number",
        "email": "Email Address",
        "opt": "Optional",
        "primary": "Primary Phone Number",
        "req": "*Required",
        "req_personal": "*Required - We recommend using your personal email",
        "verify": "Verify Phone Number",
        "what_number_email": "What is your number and email?"
      },
      "please_provide": "Please provide the contact information for your employer. This could be someone in Operations or Human Resources, or your manager.",
      "print_and_mail_alert": "Please complete the next questions to the best of your ability. <b>You will need to print and mail your PSLF form to the Department of Education.</b> When they receive it, they will follow up to assist you in getting documentation of your employment.",
      "reason_submitting": {
        "forbearance": {
          "checkbox": "I believe I qualify for forgiveness now, and I want a forebearance while my application is being processed. <b>I understand that periods of forbearance do not count towards forgiveness.</b>",
          "tooltip": "Check the box below if you want your loans to go into forebearance (temporarily stop making payments) while you wait to hear back from the Department of Education."
        },
        "have_you_made": "Have you made 120 months of qualifying payments to loan forgiveness?",
        "have_you_made_pt1": "Have you made 120 months of &nbsp;",
        "have_you_made_pt2": "&nbsp; payments to loan forgiveness?",
        "qualifying": "qualifying",
        "tooltip": "Qualifying Payment Definition: <br /> Payments made on Direct Loan(s) while enrolled in an income-driven repayment plan and working full time for a qualifying 501(c)3 non-profit, government, or tribal organization"
      },
      "refused_certify": "Has your former employer closed or have they refused to certify your employment?",
      "start_date": "Start Date",
      "weekly_hours_note": "Include vacation, leave time, or any leave taken under the Family Medical Leave Act of 1993. Do not include any hours spent on religious instruction, worship services, or proselytizing.",
      "what_name": "What is your employer’s name?",
      "when_work": "When did you work for this employer?",
      "yes_employer_email": "Yes, I have my employer's email address"
    },
    "workflow_prior_employer": {
      "contact_name": "Contact’s name (if available)",
      "contact_phone": "Contact’s phone number",
      "contact_title": "Contact’s Title (if available)",
      "correct_email_alert": "Tuition.io will email the address provided so that my employer can review and sign my application for PSLF. If you don’t know your employer’s email, you can alternatively print and mail a paper copy using their postal address.",
      "employer_email": "Employer email",
      "employer_email_hint": "*Required - If you don’t know your employer’s email, you can alternatively print and mail a paper copy using their postal address.",
      "i_dont_have_email": "No, I would like to print and mail the form myself",
      "i_have_email": "Yes, I have my employer's email address",
      "optional": "Optional",
      "optional_not_required": "Optional - Not required to submit electronically",
      "please_provide": "Please provide the contact information for your employer.",
      "please_provide_hint": "This could be someone in Operations or Human Resources, or your manager. It’s important to confirm this is a valid email so we can make sure your PSLF form gets submitted correctly.",
      "send_electronically": "Are you able to send the PSLF form electronically?",
      "send_your_document": "Send your document",
      "submit_for_approval": "Submit for Approval"
    }
  },
  "pslf_dashboard": {
    "about_security": "Read more about our security",
    "actions": {
      "account_linking_status": "Account Status",
      "accounts_linked": "Accounts Added",
      "add_accounts": "Add Accounts",
      "default": "Actions",
      "dialog": {
        "before_proceeding": "Before Proceeding To The Forgiveness Estimator",
        "current_balance": "Current Balance",
        "graduated_plan": "Strategy Finder recommendations for those currently on a Graduated Repayment Plan will be available soon.",
        "interest_rate": "Interest Rate",
        "loan_name": "Loan Name",
        "loan_type": "Loan Type",
        "need_more_info": "Need more info",
        "please_provide_info": "Please provide information for the fields where you see a red icon. Upon filling in the fields you will be taken to the loan forgiveness estimator.",
        "repayment_plan": "Repayment Plan",
        "we_need_your_help": "we need your help filling out missing information on some of your loans",
        "we_will_not_be_able": "We will not be able to provide accurate forgiveness estimations since you have not added your accounts. Please return to the dashboard and add accounts."
      },
      "forgiveness_estimator": "Forgiveness Estimator",
      "forgiveness_estimator_status": "Forgiveness Estimator Status",
      "forms_i_have_signed": "Forms I Have Signed:",
      "forms_submitted_dept_of_ed": "Forms Submitted:",
      "if_you_have_a_prior_employer": "If you have a prior employer that you want to submit for PSLF, please complete another form.",
      "let_us_estimate_forgive": "Let us estimate the forgiveness amount and when you may receive it.",
      "projection": "Estimated Forgiveness Projection",
      "pslf_form_status": "PSLF Form Status",
      "start_another_form": "Start another form",
      "start_new_form": "Start form",
      "view_details": "View Details"
    },
    "learn_more": "Learn more",
    "my_dash": "My PSLF Dashboard",
    "pause_banner": "Due to a pause of processing by DOE, submission of new forms is currently unavailable.",
    "pause_info_dialog": "On 5/1/2024, the Department of Education (DOE) paused processing of PSLF forms through July 2024 and published a new form for future PSLF submissions. <a href=\"https://www.tuition.io/\" class=\"text-ocean-600 underline\">TUITION.IO<a> is updating our PSLF form experience to conform to the new DOE guidelines, and submission of new forms is currently unavailable. We expect to have the new PSLF form experience live on our platform by June 12, 2024.  Please come back to submit your PSLF form through Tuition.io after June 12th, 2024. This will ensure your PSLF form submission meets all new requirements of the DOE.  This will be several weeks before the DOE expects to begin processing forms again and should not cause any delays in your PSLF form processing by the DOE. We'll send you a reminder email when the new PSLF form is available so you can come back and submit the form. If you have any additional questions you can review our <a href=\"/pslf/dashboard/start-new\" class=\"text-ocean-600 underline\">FAQ</a> or navigate to <a href=\"/repaying-student-debt/askjeni/schedule\" class=\"text-ocean-600 underline\">student loan coaching</a> to email or schedule a call with a student loan coach.",
    "results": {
      "default": "Previous Results",
      "description": "The results are based on your most recent answers from the forgiveness estimator.",
      "error": "Oops, looks like something went wrong. Please resubmit responses in the",
      "estimated_loan_forgiveness_amount_is": "Estimated loan forgiveness amount is:",
      "estimated_loan_forgiveness_date_is": "Estimated loan forgiveness date is:",
      "estimated_monthly_payment_is": "Estimated monthly payment is:",
      "thank_you": "Thank you."
    }
  },
  "questions_you_have": {
    "default": "Questions You Have",
    "glossary": {
      "529_savings": {
        "description": "A savings plan operated by a state or educational institute designed to help families set aside money for the future costs of college.",
        "link_text": "LEARN ABOUT 529 PLANS",
        "title": "529 College Savings Plan"
      },
      "avalanche": {
        "description": "A debt-reduction strategy that involves paying off the highest interest loans most aggressively while making the minimum payments on lower-interest loans. The goal of the avalanche method is to pay the least amount of interest.",
        "title": "Avalanche Method"
      },
      "default": {
        "description": "Failure to make a payment on your federal student loan for more than 270 days. Defaulted loans show up on your credit score and carry consequences such as losing access to federal student aid.",
        "title": "Default"
      },
      "deferment": {
        "description": "A period where loan payments are temporarily postponed and interest does not accrue on Perkins loans or the subsidized portions of other federal loans.",
        "title": "Deferment"
      },
      "delinquent": {
        "description": "A loan is delinquent when a borrower does not make a payment on time.",
        "title": "Delinquent"
      },
      "employer_repayment": {
        "description": "An employee benefit where an employer contributes money to assist in the repayment of student loan debt.",
        "title": "Employer Sponsored Repayment - Student Loan Repayment Assistance"
      },
      "entrance_counseling": {
        "description": "Definition: A mandatory information session for borrowers that highlights their responsibilities and rights before they take out student loans. Example: After completing her FAFSA and accepting her award package Seon completed her entrance counseling so she could get her loans for her first semester of college.",
        "title": "Entrance Counseling"
      },
      "exit_counseling": {
        "description": "A mandatory information session for borrowers that highlights their responsibilities in repayment and when repayment begins. This takes place before graduation or when you drop below half time enrollment.",
        "title": "Exit Counseling"
      },
      "federal_loans": {
        "description": "A loan funded by the government to help a borrower pay for their education.",
        "title": "Federal Loans"
      },
      "federal_student_aid": {
        "description": "Financial aid from the federal government to pay for college. Student loans, grants, and work-study are all forms of federal student aid.",
        "link_text": "LEARN ABOUT FEDERAL AID",
        "title": "Federal Student Aid"
      },
      "fees": {
        "description": "The amount of money charged for administration of classes and college attendance. (Specifically in reference to college.)",
        "title": "Fees"
      },
      "financial_aid": {
        "description": "All types of monetary aid a student is offered, includes both federal and non-federal loans. Includes loans, grants, scholarships, and work study.",
        "link_text": "LEARN ABOUT PAYING FOR COLLEGE",
        "title": "Financial Aid"
      },
      "fixed_interest_rates": {
        "description": "An interest rate that remains the same over the entire loan term and does not fluctuate based on market rates.",
        "title": "Fixed Interest Rates"
      },
      "forbearance": {
        "description": "A period of time where payments on principal are paused but interest continues to accumulate.",
        "title": "Forbearance"
      },
      "glossary": "Glossary",
      "glossary_subtitle": "Student loan terminology can be confusing. Here are important terms with easy to understand definitions.",
      "good_standing": {
        "description": "A loan that is up-to date on payments.",
        "title": "Good Standing"
      },
      "grace_period": {
        "description": "A period of time for federal student loans where a borrower is not required to make payments.",
        "title": "Grace Period"
      },
      "grad_plus_loans": {
        "description": "A federal loan available to students attending graduate or professional school.",
        "title": "Grad PLUS Loans"
      },
      "hard_check": {
        "description": "A credit inquiry made by a lender or credit card company that shows up on your credit report for two years.",
        "title": "Hard Credit Check"
      },
      "ibr": {
        "description": "An income-driven repayment plan that generally sets your monthly payments at 10% of discretionary income if you borrowed for the first time after July 2014 or 15% if you borrowed before July 2014. Payments are never more than the 10 year standard repayment plan plan.",
        "title": "Income Based Repayment (IBR)"
      },
      "icr": {
        "description": "An income-driven repayment plan that generally sets your monthly payments at 20% of discretionary income or what you would pay on a 12 year fixed repayment plan, whichever is less.",
        "title": "Income Contingent Repayment (ICR)"
      },
      "income_repayment": {
        "description": "A federal repayment option that uses your discretionary income to calculate a monthly payment.",
        "title": "Income-Driven Repayment Plan"
      },
      "loan_consolidation": {
        "description": "The process of consolidating multiple loans into one single loan.",
        "title": "Loan Consolidation"
      },
      "loan_forgiveness": {
        "description": "The process by which loan amounts are forgiven and the borrower is not responsible for repaying the forgiven portion of their loan.",
        "title": "Loan Forgiveness"
      },
      "loan_rehabilitation": {
        "description": "A process that enables a borrower to remove the default notation from their credit score by bringing their loan out of default.",
        "title": "Loan Rehabilitation"
      },
      "loan_term": {
        "description": "The period of time over which a borrower makes monthly payments on their loan.",
        "title": "Loan Term"
      },
      "monthly_payment": {
        "description": "The dollar amount owed by a borrower towards their loan each month.",
        "title": "Monthly Payment"
      },
      "negative_amortization": {
        "description": "An increase in the principal balance of a loan because a borrower fails to make payments that cover interest.",
        "title": "Negative Amortization"
      },
      "no_results": "Your search has no results...",
      "nslds": {
        "description": "An online system that compiles data for all federal loans made to a borrower. The NSLDS provides borrowers with information about all their federal loan balances but information can take up to 120 days to update.",
        "title": "National Student Loan Data System (NSLDS)"
      },
      "nslds_pin": {
        "description": "Definition: A borrower’s numerical identification number that allows them to access their federal loan information in the NSLDS. Borrowers can obtain their PIN by going to the NSLDS website.",
        "title": "NSLDS PIN"
      },
      "parent_plus_loans": {
        "description": "A federal loan available to parents of dependent undergraduate students. The loan is held by the parent, and they are responsible for repaying the balance.",
        "title": "Parent PLUS Loans"
      },
      "paye": {
        "description": "An income-driven repayment plan that generally sets your monthly payments at 10% of discretionary income but never more than the standard 10 year repayment plan. PAYE can be a better option than SAVE (formerly Repaye) if you’re concerned 10% of discretionary income may exceed the 10 year standard repayment plan monthly payment.",
        "title": "PAYE - Pay As You Earn"
      },
      "pell_grant": {
        "description": "A federal grant for undergraduate students who demonstrate financial need. Grants do not need to be repaid.",
        "title": "Pell Grant"
      },
      "perkins_loans": {
        "description": "A federal loan made by a borrower’s college based on demonstration of financial need. Not all colleges offer Perkins Loans.",
        "title": "Perkins Loans"
      },
      "private_loans": {
        "description": "A loan made by an institution such as a bank, credit union, or college rather than the federal government. The average interest rate of private student loans are over 9% and don’t carry the same financial protections for borrowers as federal loans.",
        "link_text": "LEARN ABOUT PRIVATE LOANS",
        "title": "Private Loans"
      },
      "promissory_note": {
        "description": "A binding legal document that must be signed to obtain a federal loan. It contains the terms and conditions under which you agree to repay your loan.",
        "title": "Promissory Note"
      },
      "pslf": {
        "description": "A loan forgiveness program that will forgive the remaining loan balance tax free for borrowers in qualifying employment who have made 120 monthly payments.",
        "title": "Public Service Loan Forgiveness (PSLF)"
      },
      "refinancing": {
        "description": "Renegotiating the terms of your loan with the same or a different lender, typically to obtain a better interest rate. High income borrowers with excellent credit scores and stable employment should consider refinancing their student loans for better interest rates.",
        "link_text": "LEARN ABOUT REFINANCING",
        "title": "Refinancing"
      },
      "repayment_plan": {
        "description": "A plan that sets forth your monthly loan payments. Federal loans offer the most flexibility when it comes to choosing a repayment plan.",
        "title": "Repayment Plan"
      },
      "room_board": {
        "description": "The cost of housing and food while attending college.",
        "title": "Room & Board"
      },
      "save": {
        "description": "An income-driven repayment plan that generally sets your monthly payments at 10% of discretionary income. The SAVE plan helps borrowers afford their monthly payment but it will take longer to repay student loan debt under this plan.",
        "title": "SAVE (formerly REPAYE)"
      },
      "scholarship": {
        "description": "Money awarded to students for academic or other achievements that generally does not have to be repaid.",
        "link_text": "LEARN ABOUT SCHOLARSHIPS",
        "title": "Scholarship"
      },
      "search": "Search...",
      "snowball_method": {
        "description": "A debt-reduction strategy that involves paying off the smallest debts most aggressively while making the minimum payments on larger debts. The goal of the snowball method is to provide motivation and small milestone achievements as the number of debts decreases, but a borrower may be better served financially by paying off larger higher interest loans first.",
        "title": "Snowball Method"
      },
      "soft_credit_check": {
        "description": "A credit inquiry made when a company or individual checks your credit score. Checking your monthly credit score or getting a student loan refinancing rate estimate are examples of a soft credit check.",
        "title": "Soft Credit Check"
      },
      "student_loan_discharge": {
        "description": "The cancellation of student loan debt due to a borrower’s inability to pay the debt (death or permanent disability) or fraudulent lending (identity theft). An important difference between refinanced and federal loans is that in the event of borrower death, federal loans would be eligible for student loan discharge so their family would not be responsible for repaying that debt.",
        "title": "Student Loan Discharge"
      },
      "subsidized_loans": {
        "description": "A federal loan in which the borrower is not responsible for paying interest on the loan while enrolled in school.",
        "title": "Subsidized Loans (or Direct Subsidized Loans)"
      },
      "teacher_forgiveness": {
        "description": "A loan forgiveness program that gives eligibility for loan forgiveness of up to $17,500 if a borrower teaches in specific schools that serve low-income families and meet other qualifications.",
        "title": "Teacher Loan Forgiveness"
      },
      "til": {
        "description": "A document that discloses cost information about your loan such as your interest rate.",
        "title": "Truth in Lending Document (TIL)"
      },
      "try_new_search": "Please try a different search.",
      "tuition": {
        "description": "The amount of money charged by a college or university for classes or instruction. Tuition is often calculated annually or by semester.",
        "title": "Tuition"
      },
      "unsubsidized_loans": {
        "description": "A federal loan in which the borrower is responsible for paying interest on the loan regardless of enrollment status.",
        "title": "Unsubsidized Loans"
      },
      "variable_rates": {
        "description": "An interest rate that changes over the term of the loan based on a market benchmark rate (such as the LIBOR index).",
        "title": "Variable Interest Rates"
      }
    },
    "how_to_apply": {
      "accept_fa_package": {
        "default": "Accept <span class=\"text-ocean-600\">Your Financial Aid Package</span>",
        "point_1": "Your award letter will tell you how to accept their financial aid offer.",
        "point_2": "Usually you will need to sign a promissory note, a legal document in which you promise to pay back all the money you borrow for your education, plus accrued interest and fees.",
        "point_3": "Ask your school's financial aid office if there are any additional requirements."
      },
      "call_fa_office": {
        "default": "<span class=\"text-ocean-600\">Call</span> the Financial Aid Office",
        "point_1": "Every college has different requirements for applying for a PLUS loan, so check with your child's financial aid office to determine eligibility and requirements."
      },
      "check_application_requirements": {
        "default": "Check Your College <span class=\"text-ocean-600\">Application Requirements</span>",
        "point_1": "Each school has its own requirements for awarding financial aid, and may require you to submit more than just your FAFSA.",
        "point_2": "Check with each school's financial aid office to learn how to apply for their financial aid."
      },
      "check_requirements_private": {
        "header": "Each private student loan application has its own requirements and process, so ask the lender for all additional requirements.",
        "point_1": "Letter from your financial aid office certifying you will need a private student loan to cover costs",
        "point_2": "Tax documents",
        "point_3": "Income and bank statements",
        "point_4": "FAFSA award package",
        "point_5": "Identity verification"
      },
      "decide_if_cosigner": {
        "default": "Decide If You Need a <span class=\"text-ocean-600\">Cosigner</span>",
        "point_1": "If you don't have a credit history, or if your credit score is low, you might need to have a cosigner, like your parents.",
        "point_2": "Look for a company that offers cosigner release after a period of on time payments."
      },
      "default": "How to Apply",
      "entrance_counseling": {
        "default": "Go to Entrance <span class=\"text-ocean-600\">Counseling</span>",
        "point_1": "Before you can receive your first student loan disbursement, you must go through financial education to take out the loan. Check with your school's financial aid office for entrance counseling requirements."
      },
      "pplus_ask_yourself": {
        "default": "<span class=\"text-ocean-600\">Ask Yourself:</span><span> \"Is This the Right Choice for Our Family?\"</span>",
        "point_1": "Only you and your family can decide if this is the right option.",
        "point_2": "Some questions to ask yourselves are:",
        "point_3": "Can we afford this debt? Take into consideration your other financial obligations such as your mortgage, if you still have your own student loan debt, and what your other long term financial goals are.",
        "point_4": "Can we continue this trend if we have more than one child?",
        "point_5": "Why is the cost of this education higher than the available financial aid? Is public school a more realistic option for our family?"
      },
      "receive_award_letter": {
        "default": "Receive Your <span class=\"text-ocean-600\">Award Letter</span>",
        "point_1": "Each school will send you a financial aid award letter that will tell you how much aid you will receive and how much you will be expected to pay.",
        "point_2": "Look through (especially w/ help of a financial aid counselor) to make sure you understand the offer and that all the information is correct.",
        "point_3": "Each school has its own timing for sending out financial aid award letters, so contact your school's financial aid office to find out when you can expect it to arrive."
      },
      "receive_your_SAR": {
        "default": "Receive your <span class=\"text-ocean-600\">Student Aid Report (SAR)</span>",
        "point_1": "Once you submit FAFSA, you'll receive your SAR within 7-10 business days.",
        "point_2": "Check to make sure your information on your SAR is complete and accurate. If something isn't correct, you need to complete or correct your FAFSA ASAP.",
        "point_3": "Your SAR also lets you know what your Expected Family Contribution (EFC) is. This lets you know much you and your family are expected to pay each year for you to attend school.",
        "point_4": "Your SAR will be sent to all the schools you listed on your FAFSA. Each school will use your SAR to determine your eligibility for federal and nonfederal student aid."
      },
      "submit_your_fafsa": {
        "default": "Submit your <a href=\"https://studentaid.gov/h/apply-for-aid/fafsa\" class=\"text-ocean-600\">FAFSA</a>",
        "point_1": "529 plans are available from multiple sources and target different goals. The National Association of State Treasurers created the College Savings Plan Network, which provides links to most 529 plan websites. <br/> <p>Tuition.io recommends exploring 529 plans with a financial advisor to choose one that's best for your family.</p>",
        "point_2": "You have to submit a FAFSA annually.",
        "point_3": "To see if you qualify for federal student aid, check out this list here.",
        "point_4": "You can list up to 10 institutions (if undecided where you will be a ending school)",
        "point_5": "Parental tax return - submit the prior year's taxes"
      }
    },
    "paying_for_college": {
      "what_is_federal_loan_a": "The federal government offers financial aid to help pay for college. Federal student loans, Perkins loans, Pell grants, and work-study are all forms of federal student aid. To receive federal student aid, a borrower must complete the FAFSA.",
      "what_is_federal_loan_q": "What is a Federal Loan?"
    },
    "repayment_plans": {
      "eligibility_should_be_considered_description": "Only some repayment plans also allow you to apply for a loan forgiveness plan, so keep that in mind when choosing the best repayment plan. We can help you find the best plans for you <a class=\"text-ocean-600\" href=\"/questions-you-have/repayment-strategy-finder\">here</a>.",
      "eligibility_should_be_considered_title": "Loan forgiveness eligibility should be considered as well.",
      "eligible_loan_types": "Eligible loan types",
      "extended": {
        "extended_plan": {
          "description": "If you have over $30,000 in debt, don't qualify for loan forgiveness, and need more than 10 years to payoff your loans - this is the plan for you.",
          "plan_details": {
            "cons": {
              "con_1": "Will pay more interest than 10 year standard repayment plan",
              "con_2": "No loan forgiveness"
            },
            "eligible_loan_types": "All Federal loans",
            "keep_in_mind": "Stretching out your repayment term drastically increases the amount of interest you will pay over time.",
            "loan_forgiveness": "No",
            "monthly_payment": "Fixed monthly payment, or graduated payments that increase over time",
            "pros": {
              "pro_1": "Longer period of time to repay loan balances over $30,000",
              "pro_2": "Best for people who need a lower monthly payment but don’t qualify for income-driven plans"
            },
            "years_to_repay": "Up to 25 years"
          },
          "title": "Extended Plan"
        },
        "tab_title": "Extended"
      },
      "graduated": {
        "graduated_plan": {
          "description": "This plan could be good for borrowers who have a low income at graduation, but feel confident that it will increase substantially over the next 10 years.",
          "plan_details": {
            "cons": {
              "con_1": "Will pay more interest than 10 year standard repayment plan",
              "con_2": "No loan forgiveness",
              "con_3": "Future income isn’t always guaranteed to be higher over 10 years, and your monthly payment could be too costly towards the end of the repayment period",
              "con_4": "Early payments don't reduce the principal loan balance and only cover the interest"
            },
            "eligible_loan_types": "All Federal loans",
            "keep_in_mind": "You could be eligible for loan forgiveness if you choose a different repayment plan, but it will take a lot longer to pay off since loan forgiveness takes between 20-25 years of repayment.",
            "loan_forgiveness": "No",
            "monthly_payment": "Increases every 2 years",
            "pros": {
              "pro_1": "Payments start low and increase over time",
              "pro_2": "Repay in 10 years, or up to 30 years for consolidated loans",
              "pro_3": "Best for people who may have a lower income now, but expect their monthly income to increase over time and don’t qualify for an income-driven repayment plan."
            },
            "years_to_repay": "10, 10-30 for consolidated loans"
          },
          "title": "Graduated Plan"
        },
        "tab_title": "Graduated"
      },
      "income_driven": {
        "based": {
          "con_1": "Will pay more interest than any plan with a shorter repayment term",
          "con_2": "Monthly payment may be more than PAYE",
          "description": "This plan is great for borrowers who have FFEL loans, are not seeking loan forgiveness, and cannot afford the Standard monthly payment. If you are considering loan forgiveness, consolidating your loans may be necessary; in that case PAYE or SAVE (formerly Repaye) may be better for you.",
          "eligible_loan_types": "FFEL loans, All Direct Loans",
          "loan_forgiveness": "Yes",
          "monthly_payment": "10-15% of discretionary income; changes with income",
          "pro_1": "Payments are based on income & capped",
          "pro_2": "Payment plan option for PSLF",
          "title": "Income-Based Repayment Plan",
          "years_to_repay": "25"
        },
        "contingent": {
          "con_1": "The highest monthly payment of income-driven plans",
          "con_2": "Will pay more interest than any plan with a shorter repayment term",
          "description": "If you have a consolidated Parent PLUS loan and are seeking loan forgiveness, this is the only repayment plan that will work for you.",
          "eligible_loan_types": "FFEL loans, Consolidated Parent PLUS loans",
          "loan_forgiveness": "Yes",
          "monthly_payment": "The lesser of 20% of discretionary income or what you’d pay on a 12-year fixed payment plan; changes with income",
          "pro_1": "Payments based on income",
          "pro_2": "Consolidated parent PLUS loan eligible fr PSLF under this plan",
          "pro_3": "Monthly payment is capped at no more than the payment uder a 12 year term",
          "title": "Income-Contingent Repayment Plan",
          "years_to_repay": "25"
        },
        "keep_in_mind": "This plan is one of four repayment plans that will allow you to get loan forgiveness - so make sure you are on one of them - Income-Based, PAYE, REPAYE, and ICR. Check out this <a href=\"https://studentloans.gov/myDirectLoan/repaymentEstimator.action\" class=\"text-ocean-600\">Repayment Estimator</a> to help you compare the estimated monthly payment for each plan.",
        "paye": {
          "con_1": "Will pay more interest than any plan with a shorter repayment term",
          "description": "If you borrowed your Direct Federal Loans after October 1, 2007, and cannot afford the Standard monthly payment or are considering PSLF or income-driven loan forgiveness, this is the best income-driven plan for you.",
          "eligible_loan_types": "Direct Loans from after Oct 1, 2007; must also have a partial financial hardship",
          "loan_forgiveness": "Yes",
          "monthly_payment": "10% of discretionary income; changes with income",
          "pro_1": "Payments are based on income & capped",
          "pro_2": "Good payment plan for PSLF",
          "title": "Pay As You Earn (PAYE) Plan",
          "years_to_repay": "20"
        },
        "repaye": {
          "con_1": "Will pay more interest than any plan with a shorter repayment term",
          "con_2": "Monthly payment isn't capped, so it can become higher than the 10 year standard repayment plan payment",
          "description": "If you borrowed your first Direct Federal Loan before October 1, 2007, and cannot afford the Standard monthly payment, this is the best income-driven plan for you.",
          "eligible_loan_types": "All Direct Loans",
          "loan_forgiveness": "Yes",
          "monthly_payment": "10% of discretionary income; changes with income",
          "pro_1": "Payments are based on income",
          "pro_2": "Good payment plan for PSLF",
          "title": "SAVE (formerly Repaye) Plan",
          "years_to_repay": "20 or 25"
        },
        "sensitive": {
          "con_1": "Not eligible for loan forgiveness",
          "description": "If you only have FFEL loans and are not seeking loan forgiveness, this could be a good option for you. The Income-Based Repayment Plan could also be a good option, but use this <a href=\"/repaying-student-debt/repayment-strategy-finder\" class=\"text-ocean-600\">official calculator</a> to find out.",
          "eligible_loan_types": "FFEL loans",
          "loan_forgiveness": "No",
          "monthly_payment": "Based on annual income and youor lender's formula",
          "pro_1": "FFEL loans are eligible for this plan",
          "title": "Income-Sensitive Repayment Plan",
          "years_to_repay": "10"
        },
        "tab_title": "Income-Driven",
        "undergrad": {
          "description": "If you have Direct Loans used for your own undergraduate education, this plan has the lowest monthly payment of the income-driven repayment plans.",
          "eligible_loan_types": "Direct Loans used for your own undergraduate education",
          "monthly_payment": "5% of discretionary income; changes with income",
          "title": "Undergrad 5% Income-Driven Repayment Plan",
          "years_to_repay": "10 years for original loan balances $12,000 or less and 20 years for balances >$12,000"
        }
      },
      "keep_in_mind": "Keep in mind",
      "loan_forgiveness": "Loan Forgiveness",
      "make_the_switch": {
        "description": "To enable this plan, call your <a class=\"text-ocean-600\" href=\"https://studentaid.gov/manage-loans/repayment/servicers\">federal student loan servicer</a>",
        "title": "Ready to make the switch?"
      },
      "monthly_payment": "Monthly payment",
      "most_people_standard_description": "If you can afford your monthly payment, this is your fastest way to pay off your debt and you’ll pay less in interest as well! You can pay it off even faster by paying more than your minimum monthly payment whenever possible.",
      "most_people_standard_title": "Most people start on the standard repayment plan.",
      "need_more_help": {
        "description": "If you need more help picking the right plan for you, check out the <a class=\"text-ocean-600 font-semibold\" href=\"/repaying-student-debt/repayment-strategy-finder\">Tuition.io Strategy Finder</a>",
        "title": "Need more help?"
      },
      "next_steps": "Next Steps",
      "payment_too_high_description": "Other repayment plans can help lower your monthly payment, or even offer loan forgiveness (more on that next). The drawback is that they have much longer term lengths (around 20-25 years), and so you’ll end up paying a lot more interest.",
      "payment_too_high_title": "If your monthly payment is too high, there are other options.",
      "repayment_plan_types": "Repayment Plan Types",
      "standard": {
        "standard_plan": {
          "description": "After you graduate from college, your federal loans are automatically placed on the Standard Plan. This plan ensures you pay off loans within 10 years or less, so it's great for borrowers who can afford their monthly payment, and want to pay off their loans as quickly as possible.",
          "plan_details": {
            "cons": {
              "con_1": "Highest monthly payment",
              "con_2": "Not compatible with loan forgiveness"
            },
            "eligible_loan_types": "All Federal loans",
            "keep_in_mind": "You could be eligible for income-driven loan forgiveness if you choose a different repayment plan, but it will take a lot longer to pay off since income-driven loan forgiveness takes between 20-25 years of repayment. If you can afford your current monthly payments, stick with the Standard Plan. You'll pay off your debt faster and pay significantly less in interest.",
            "loan_forgiveness": "No",
            "monthly_payment": "Same each month",
            "pros": {
              "pro_1": "Federal loans are automatically placed on this plan 6 monnths after you graduate",
              "pro_2": "Best for people with a steady monthly income and can afford regular monthly payments",
              "pro_3": "You will pay the least amount of interest"
            },
            "years_to_repay": "10, 10-30 for consolidated loans"
          },
          "title": "Standard Plan"
        },
        "tab_title": "Standard"
      },
      "what_are_repayments_a": "Everyone with federal loans is on a repayment plan. There are 8 different repayment plans that you can choose from, depending on your eligibility and payoff goals. These plans are only for paying off your federal loans. For private loans, contact your lender.",
      "what_are_repayments_q": "What are Loan Repayment Plans?",
      "years_to_repay": "Years to repay"
    },
    "types_of_student_loans": {
      "cons": {
        "cons_federal": "Cons of Federal Loans",
        "cons_plus": "Cons of Plus Loans",
        "cons_private": "Cons of Private Loans",
        "dont_have_repayment_plan_flexibility": "Don't have repayment plan flexibility and aren't eligible for federal loan forgiveness programs.",
        "generally_higher_interest_rate": "Generally have the highest interest rates.",
        "higher_interest": "Since federal loans have a fixed interest rate, if you have a good credit score, you could be paying a higher interest rate than you qualify for.",
        "plus_con1": "Generally have a higher interest rate than federal loans for students or used for undergraduate education.",
        "plus_con2": "Parent PLUS loans are the responsibility of the parent, they can't be transferred to the student without privatizing them.",
        "plus_con3": "May have less access to federal repayment plans than federal loans for students or used for undergraduate education.",
        "subsidized_limit": "Subsidized federal loans are limited in how much you can borrow. They are given in increasing amounts until you hit your 3rd year in college. The maximum amount you can receive is $21,000 total for 4 years.",
        "unsubsidized_limit": "Unsubsidized federal loans are somewhat limited in how much you can borrow; depends on how much your college cost and what year you are; the Student Aid Report will tell you your limit.",
        "very_few_options": "Very few options for repayment if affordability becomes difficult"
      },
      "default": "Types Of Student Loans",
      "federal_aid": "FEDERAL AID",
      "plus_loans": "PLUS LOANS",
      "private_loans": "PRIVATE LOANS",
      "pros": {
        "check_or_collateral": "Do not require a credit check or collateral.",
        "consolidation": "Can be consolidated upon graduation.",
        "do_not_accrue": "Subsidized loans do not accrue interest while actively enrolled in school.",
        "generally_lower_interest": "Generally have a lower interest rate than private student loans.",
        "lower_interest": "Have lower interest rates than private loans.",
        "pros_federal": "Pros of Federal Loans",
        "pros_plus": "Pros of Plus Loans",
        "pros_private": "Pros of Private Loans",
        "pros_private_text": "Federal student loans have a maximum limit. Private student loans allow you to access to more money than you can get through federal loans.",
        "qualify_for_loan_forgiveness": "Can qualify for federal student loan forgiveness programs.",
        "repayment_options": "Have favorable repayment options after graduation.",
        "repayment_options_more_favorable_than": "Have repayment options that are more favorable than private student loans, though they may be less favorable than other federal loans."
      }
    }
  },
  "read_security_button": {
    "about_ccpa_content": "The California Consumer Privacy Act (CCPA) is a state law that went into effect on January 1, 2020. This law provides California residents (consumers) more control over their data and requires companies to be more transparent with what data they are collecting and how they are using that data.",
    "about_ccpa_header": "About the California Consumer Privacy Act (CCPA)",
    "aes_256": "Tuition encrypts your documents and all information stored in our databases at rest. The data is encrypted using AES-256.",
    "amazon_links": "<a href=\"https://aws.amazon.com/privacy/\">AWS Privacy</a> <br /> <a href=\"https://aws.amazon.com/compliance/data-privacy-faq/?nc=sn&amp;loc=4\">AWS data privacy FAQ</a>",
    "auth_logins": "Tuition is designed to allow access via authenticated logins. In other words, data stored in Tuition are only accessible if you log into the service with another individual that must log into the service. Tuition employs an Activity Log that you can use to review:",
    "aws_host": "Tuition hosts your data using services provided by Amazon Web Services (AWS).",
    "aws_secure": "Amazon Web Services are trusted and relied upon all over the world to provide highly secure and scalable infrastructure.",
    "aws_storage": "Your data and metadata are always stored using highly redundant replicated storage provided by Amazon Web Services (AWS). Multiple copies of metadata and data are stored in multiple geographical locations and backed up regularly to ensure availability.",
    "ccpa_compliance": "CCPA Compliance",
    "ccpa_penalties": "Under the CCPA, penalties for non-compliance can include fines of up to $2,500 per violation, and not more than $7,500 for each intentional violation. A business has 30 days to respond to a written notice of a violation claim, and is given the chance to remedy the violation before fines are imposed.",
    "ccpa_requires": "CCPA Requires…",
    "ccpa_rights_header": "What Rights do Consumers Have Under the CCPA?",
    "compliance": "Compliance",
    "confidential_and_sensitive": "Tuition classifies the information you store in Tuition into two categories: confidential data and sensitive data.",
    "confidential_data": "Confidential Data",
    "confidential_data_includes": "Confidential data includes the contents of bank account number, and password hashes. Confidential information is accessible by a limited number of Tuition employees; however, Tuition has processes and technologies which forbid access to that data without your express permission. Staff with this level of access are screened and trained on Tuition’s security controls designed to protect your privacy. Auditing mechanisms are in place to detect any violation of this policy.",
    "contact_for_more_insight": "While we are not a CCPA compliance consulting firm, we are happy to assist you in getting pointed in the right direction. Feel free to contact us at security@tuition.io for more insight.",
    "customer_info_compliance": "At Tuition.io, we know that many businesses face compliance pressure when managing sensitive customer information.",
    "data_at_rest": "Your Data is Secure While at Rest",
    "data_in_transit": "Your Data is Secure While in Transit",
    "data_securely_backed": "Your Data is Securely Backed Up",
    "data_stored": "How Your Data is Stored",
    "delete_information": "The right to have their information deleted (with some exceptions).",
    "does_ccpa_apply": "Does the CCPA Apply to My Business?",
    "does_ccpa_apply_content": "Generally, a consumer under the CCPA means a natural person who is a California resident. The rights afforded under the CCPA apply to all consumers in this context. Therefore, any business who collects and/or processes information of California residents, whether these residents are your customers, prospects, employees, or otherwise, may be subject to the CCPA. For more details about who the CCPA impacts, read this article.",
    "encrypted": "All interactions with Tuition occur over an encrypted channel. We employ SSL to protect your passwords and interactions with Tuition from eavesdropping.",
    "five_new_rights": "The CCPA provides consumers with five new rights regarding their personal information:",
    "full_doc_audit": "Full Document & Workflow Audit Under the CCPA, consumers have the right to request information on your data collection, processing, and usage procedures. Fully documenting how data is processed and transferred and for what reasons you have to do so will help you respond to these requests and ensure your procedures meet compliance requirements. Document who has access to the data at each stage of processing and transfer.",
    "impact_assessment": "Impact Assessment: Conduct assessments for personal data that is high risk to individuals.",
    "in_summary": "In Summary",
    "incorporate_tio": "By working within this rigid set of technical and process controls, we believe you can incorporate Tuition into a CCPA compliant solution.",
    "iso_certification": "Tuition achieved ISO 27001 certification starting 2018. International Organization for Standardization (ISO) is an internationally recognized best practice framework that specifies the requirements for establishing, implementing, maintaining and continually improving an Information Security Management System (ISMS). ISMS is a systematic approach to managing sensitive company information including people, processes and IT systems.",
    "iso_standard": "Tuition uses the ISO Standard as an actionable framework to provide a robust security process. This standard is designed to protect sensitive information; however, Tuition employs this framework as a tool across all confidential information – including your documents. This framework provides us a security process that incorporates prevention, detection, and appropriate response to security incidents.",
    "keep_reviewing": "Keep Reviewing: Keep checking the confidentiality, availability & resilience of your systems.",
    "learn_more": "Learn more about Tuition’s solutions for:",
    "limit_access": "Limit Access: Only authorized individuals should be able to access data.",
    "limit_data": "Limit Data: Only collect what is necessary.",
    "limit_processing": "Limit Processing: Only process data for the purpose that it was collected for.",
    "list_of_users": "List of users",
    "no_retaliation": "The right to not be discriminated against because they have exercised any of these rights.",
    "privacy_by_design_includes": "The CCPA wants you to think about privacy and data protection from the beginning, not as a bolted-on after-thought. Documenting your workflows is the first step to build privacy into your everyday business operations. Choose technology that supports streamlined, secure workflows for your business and create internal controls and processes to maintain the utmost security posture. This is commonly known as Privacy by Design, and includes:",
    "privacy_policy": "We’ve updated our Privacy Policy which describes in clear, concise language how we collect, use and disclose your personal information, and what rights you have with respect to the use of your information.",
    "protecting_digital_assets": "At Tuition, we take the responsibility of protecting your personal sensitive data very seriously. We’ve engineered the Tuition service from the ground up to protect your valuable digital assets.",
    "quickly_respond": "When you use Tuition as a payment vendor, you can quickly respond to requests for data access.",
    "record_keeping": "Record Keeping: Note processing, data categories, erasure time, and storage locations.",
    "request_data_usage": "The right to request information on your business’ data collection, processing, and usage as it applies to them specifically. This includes what categories of information businesses have collected and if the information was disclosed or sold to third parties.",
    "request_information": "The right to request a copy of any information businesses have collected about them during the previous 12 months.",
    "right_to_be_forgotten": "Right to be Forgotten The right to have their information deleted (with some exceptions).",
    "right_to_copy": "Right to a Copy The right to request a copy of any information businesses have collected about them during the previous 12 months.",
    "searchable_data": "Your data stored in Tuition are easily searchable, and based on the user’s permission level in Tuition, can be retreived.",
    "security_compliance": "Security Compliance",
    "security_first": "Tuition is built with a security-first mindset, and we never compromise. No decision is made without a conversation around security and we’re committed to our disciplined approach to protect your documents. We continually evaluate and seek to improve our security technology and procedures and our team works hard to ensure that Tuition’s single platform is the most secure way to confidently store your data.",
    "sensitive_data": "Sensitive Data",
    "third_parties": "The right to request that their information not be sold to third parties.",
    "tio_and_ccpa": "How does Tuition support you in complying with CCPA?",
    "tio_process_controls": "Tuition’s service provides several technical and process controls that create a foundation to comply with the highest regulatory or industry requirements.",
    "tio_responds": "Tuition Responds…",
    "tio_security_measures": "As your trusted financial management provider, Tuition provides industry standard security measures such as encryption, authentication, access controls, and auditing to support your CCPA requirements.",
    "visit_security_overview": "For more information about Tuition’s security practices, visit Security Overview from our website",
    "what_has_permission": "What has been granted permissions to access your data?",
    "what_is_sensitive": "Information not deemed confidential is considered sensitive. Sensitive information includes your email address, account name, and other metadata. For this reason, we recommend that you never include confidential information (such as social security numbers, credit card numbers, etc.). Sensitive information may be used by Tuition employees to troubleshoot problems, resolve account management issues, and support marketing efforts. Our staff is trained on the need to protect sensitive information.",
    "what_you_dont_know": "What You Don’t Know CAN Hurt You",
    "who_has_accessed": "Who has actually accessed or changed?"
  },
  "recommendations": {
    "add_an_account": "Add An Account",
    "begin_repayment_plan_pslf": "You will need to begin a qualifying repayment plan to make progress toward PSLF.",
    "change_plan": "Change Repayment Plan",
    "change_repayment_plan_idr": "You will need to change your repayment plan to make progress toward income-driven loan forgiveness.",
    "change_repayment_plan_pslf": "Your current repayment plan (graduated, standard, extended or none) is not a qualifying repayment plan. You will need to change your repayment plan to make qualifying payments for PSLF.",
    "consolidate_idr": "Please consolidate your loans if you have FFEL and/or Parent Plus loans.",
    "consolidate_loans": "Consolidate Loans",
    "default": "Recommendations",
    "need_recertify_income": "You will need to recertify your income each year.",
    "none": "You have no recommendations at this time.",
    "please_add_accounts": "Please add accounts for us to provide details on loan types and repayment plan.",
    "recertify_income": "Recertify Income",
    "required": "You should consolidate your loans by 6/30/2024 to ensure non-qualifying loans are eligible for PSLF and to maximize your qualifying payment count for these loans.",
    "start_qualifying_payment_plan": "Start a Qualifying Repayment Plan",
    "update_repayment_plan": "Update Repayment Plan"
  },
  "recommendations_estimator": {
    "based_on_the_info_1": "based on the ",
    "based_on_the_info_2": " you have provided, switching to the highlighted plan results in:",
    "best_plan": "Best plan",
    "current_plan": "Current plan",
    "estimated_amount_forgiven": "Estimated amount forgiven",
    "estimated_amount_forgiven_includes_interest": "*includes accumulated interest",
    "estimated_total_interest_paid": "Estimated total interest paid",
    "estimated_total_to_pay": "Estimated total to pay",
    "forgiveness_estimator": "Forgiveness Estimator",
    "forgiveness_summary": "Forgiveness Summary",
    "go_to_dashboard": "Go To Dashboard",
    "ideal_plan": "Ideal Plan",
    "information": "information",
    "loan_forgiveness_card": "Loan <br/>Forgiveness",
    "monthly_payment": "Monthly payment",
    "monthly_payment_and_forgiveness_results": "Monthly Payment and Forgiveness Estimator Comparison Results",
    "monthly_payment_card": "Monthly <br/>Payment",
    "months": "months",
    "next_steps": "Next steps",
    "paye_idlf": "PAYE+IDLF",
    "savings": "(savings of {text} per month)",
    "step_by_step_instructions": "Step-by-step instructions",
    "top_strategy": "Top Strategy",
    "years_left_to_repay": "Years left to repay",
    "your_current_plan": "Your Current Plan",
    "your_income_driven_repayment_option": "Your Income-Driven Repayment Option"
  },
  "recommendations_tab": {
    "about_consolidation": "About Consolidation and PSLF limited waiver",
    "about_consolidation_abridged": "About Consolidation",
    "change_repayment_type": {
      "a_1": "Under the PSLF limited waiver any payments you've made toward your student loans while working full-time for a qualifying employer may be counted toward the required 120 through 6/30/2024. But only payments made under an income-driven repayment plan will be counted as qualifying payments toward PSLF after that date.",
      "about_switching": "About switching repayment plans",
      "default": "Change Repayment Type",
      "q_1": "What can I do?",
      "q_2": "How do I switch to an income-driven repayment plan?",
      "q_2_a_1": "Submit the <a href=\"https://studentaid.gov/idr/\" target=\"_blank\" rel=\"noopener\">Income-Driven Repayment Plan Request Form</a>.",
      "q_2_a_2": "Your servicer will automatically update your payment amount, but it can take some time. You can check on the status of your application by contacting your servicer.",
      "q_2_a_3": "Income-driven repayment plans need to be updated annually so be sure to <a href=\"https://studentaid.gov/idr\" target=\"_blank\" rel=\"noopener\">update your income and family size</a> each year."
    },
    "consolidate_how": {
      "header": "How do I consolidate my loans?",
      "point_1": "Go to <a href=\"https://studentaid.gov/\" target=\"_blank\" rel=\"noopener\">studentaid.gov</a> to complete the <a href=\"https://studentaid.gov/\" target=\"_blank\" rel=\"noopener\">Federal Direct Consolidation Loan Application</a> and Promissory Note.",
      "point_2": "Choose the student loans you want to consolidate & indicate if you're interested in PSLF",
      "point_2_opt2": "Choose the student loans you want to consolidate.",
      "point_3": "Choose your repayment plan as part of your application.",
      "point_4": "Sign and accept the terms of your Direct Consolidation Loan."
    },
    "consolidate_loans": "Consolidate Loans",
    "consolidation_deadline": "If you have certain types of loans, <strong>you must apply for a direct consolidation prior to 6/30/2024</strong>",
    "default": "Recommendations",
    "diff_loans_payments": "You have federal loans from different periods of time with different numbers of qualifying payments.",
    "ffelp": "FFELP:",
    "ffelp_blurb": "Sometimes called FFEL or Federal Family Education Loan",
    "loan_types_header": "Here are the loan types that must be consolidated to have qualifying payments counted:",
    "max_counts_if": "Consolidation will allow for the maximum qualifying payment counts on the new consolidation loan if:",
    "perkins": "Perkins Loans:",
    "perkins_blurb": "Keep in mind this will result in loss of Perkins cancellation benefits",
    "ppl": "Parent Plus Loans:",
    "ppl_and_undergrad": "You have Parent Plus Loans and loans for your undergraduate education.",
    "ppl_blurb": "Past payments will not be counted, but future payments can be.",
    "schedule_coach": "Our student loan coaches can help. Schedule time with a loan coach to learn about your consolidation options.",
    "still_have_questions": "Still have questions?"
  },
  "refinancing": {
    "default": "Refinancing",
    "learn_more": "Learn more about refinancing"
  },
  "register": {
    "email_sent_modal_body": "We sent you a verification email. Click the link in the email to complete your registration and get started with Tuition.io.",
    "email_sent_modal_header": "Verification Email Sent"
  },
  "reminder": "Reminder",
  "repayment_options": {
    "default": "Repayment Options",
    "lendkey": "lendkey",
    "lendkey_guide": "Lendkey Guide"
  },
  "reporting": {
    "default": "Tuition Assistance Reports"
  },
  "reports": {
    "all_reports_link": "All Reports",
    "no_reports": "No reports are currently available",
    "titles": {
      "agent": "Agent Portal",
      "graph_age_band": "Graph - Age Band",
      "graph_group": "Graph - Group",
      "main_contribution": "Contribution",
      "main_wellness": "Wellness",
      "monthly_stats": "Monthly Statistics",
      "summary_group": "Summary Group",
      "untitled": "Untitled Report",
      "user_engagement": "Customer Engagement History"
    }
  },
  "required_label": "<span>{label}</span> <span class=\"text-red-700\">*</span>",
  "results": "Results",
  "risks": "Risks",
  "role_select": {
    "prompt": "Which account do you want to log into?"
  },
  "save": "Save",
  "save_for_later": "Save For Later",
  "search": "Search",
  "security": "Security",
  "september": "September",
  "sidebar": {
    "admin_employees": "Employees Admin",
    "admin_pslf": "PSLF Admin",
    "admin_tuition_assistance": "Assistance Admin",
    "eligibility_files": "Eligibility Files",
    "payments": "Payments",
    "powered_by": "education assistance powered by",
    "pslf_dashboard": "PSLF Dashboard",
    "pslf_documents": "My Forms & Documents",
    "pslf_questions": "What Is Loan Forgiveness?",
    "scholarships": "Scholarships",
    "tuition_assistance": "Tuition Assistance",
    "tuition_reimbursement": "Tuition Reimbursement",
    "unknown_user_menu_type": "[Unknown user menu type]"
  },
  "slr": {
    "account_receiving_contributions": "Account Receiving Contributions",
    "account_receiving_contributions_sub_header": "This account is currently set to receive contributions from your employer",
    "attach_statement": "Attach Statement",
    "change": "Change",
    "change_contributions": "Change Contributions",
    "continue_to_activity": "Confirm Account",
    "details_btn": "Plan Policy Details",
    "employer_contributions": {
      "annual_projection": "Annual Projection",
      "last": "Last",
      "next": "Next",
      "title": "Employer Contributions",
      "total_contributions": "{total} Contributions"
    },
    "error": {
      "accounts_unpayable": "There is a problem with the student loan account you have added, or you do not currently have a student loan account added. Please ensure you have linked a student loan account which complies with your employer's policy to receive contributions.<br/><br/>Contact <a href=\"mailto:support@tuition.io\" class=\"text-ocean-600 hover:text-ocean-800 underline\">support@tuition.io</a> if you continue to receive this message after attempting to link your account.",
      "default": "Our apologies - we have experienced an unknown error.<br/>If you continue to recieve this message, email <a href=\"mailto:support@tuition.io\" class=\"text-ocean-600 hover:text-ocean-800 underline\">support@tuition.io</a>",
      "exceeded_limit": "The benefit limit set by your employer has been reached.  If you believe this is incorrect, please email <a href=\"mailto:support@tuition.io\" class=\"text-ocean-600 hover:text-ocean-800 underline\">support@tuition.io</a> for assistance.",
      "needs_attention": "Needs Attention",
      "no_address": "There is an issue with your loan account information which needs attention. In order to receive contributions from your employer, you must upload an attachment of your student loan billing statement which shows your full name, the full student loan account number, and the payment address for this loan.<br/><br/><p class=\"text-center italic\">Please note, you only need to upload your statement once.</p>",
      "no_transactions": "Your employer's policy requires you to make your own regular contributions to receive regular contributions from your employer, but we have not detected a payment by you in your loan account in the last period. Please ensure you make your own payments in each pay period in order to receive benefits.<br/><br/><strong>If you believe you are receiving this message in error, please attach your most recent student loan billing statement so that we can further assist.</strong><br/><br/><p class=\"text-center italic\">Please note, you only need to upload your statement once.</p>",
      "terms_not_accepted": "To receive contribution benefits from your employer, you must accept the Terms & Conditions. Please <a href=\"../login\" class=\"text-ocean-600 hover:text-ocean-800 underline\">login again</a> and accept the Terms & Conditions when prompted to complete this step."
    },
    "in_progress": "In Progress",
    "issue_present": "Issue Present",
    "link_account": "Add Account",
    "payment_sent": "Payment Sent",
    "pending": "Pending",
    "receiving_contributions": "Receiving Contributions From Employer",
    "slr_page_header": "Student Loan Repayment",
    "support_modal": {
      "account_number": "The full student loan account number",
      "address": "The payment address for this loan",
      "attach_file": "Attach File",
      "attach_statement": "Attach Statement",
      "full_name": "Full Name",
      "instructions": "Please attach your most recent student loan billing statement in PDF format which shows your:"
    },
    "table": {
      "account": "Account",
      "benefit_cycle": "Benefit Cycle",
      "header": "Contribution History",
      "no_data": "There is no data to display",
      "paid": "Payment Sent",
      "sent": "Sent"
    },
    "total": "Total"
  },
  "start_date": "Start Date",
  "start_date_eligibility": {
    "errorHeader": "Ineligible {startEndSubmission}",
    "errorText": "According to your employer’s policy, this is not eligible for reimbursement.",
    "instruction": "Please enter your {startEndSubmission}. The system will determine your eligibility according to your company policy.",
    "submitError": "Per your employer’s policy, you are not eligible to submit an application for Tuition Assistance. Please check with your employer for further details."
  },
  "status": "Status",
  "strategy_finder": {
    "after_oct_1_2007": "After October 1, 2007",
    "at_least_ten": "I plan on staying in public service for at least 10 years.",
    "before_oct_1_2007": "Before October 1, 2007",
    "before_proceeding": "Before proceeding to the Strategy Finder",
    "check_applicable_employment_types": "What is your employment type? Check all that apply.",
    "complete": "Completing the short questionnaire below will help us provide the best repayment option for you.",
    "continue_to_sf": "Continue to Strategy Finder",
    "currently_working_toward": "Are you currently working towards loan forgiveness?",
    "details_blurb": "Our monthly payments and total payoff may change due to your personal details.",
    "details_to_calculate_payments": "Please enter your details to calculate estimated payments.",
    "family_size": "Family Size",
    "family_size_tooltip": "Your family size includes you, your spouse (if applicable), and your total number of dependents (if applicable).",
    "forgiveness_eligibility": "Some loan forgiveness plans have employer eligibility requirements.",
    "gov_blurb": "The US Department of Education (ED) announced a one time account adjustment that will help borrowers get closer to public service loan forgiveness. Note: you must consolidate FFEL loans before us 12/31/23 to receive the one time account adjustment.",
    "gov_how_long": "How long do you plan on working for a government / tribal organization / non-profit organization?",
    "gov_how_many_months": "Since October 1, 2007, about how many months have you worked for a government/tribal/nonprofit organization while making student loan payments?",
    "gov_pub_tribal_nonp": "Government / Public School / Tribal Organization or Non-Profit",
    "how_many_payments": "About how many qualifying payments have you made?",
    "idr": "Income driven loan forgiveness",
    "if_public_school": "If your school is a public school, ALSO select the 'government ... non-profit organization' option",
    "intro_explanation": "Let’s find the best repayment strategy for you! We’ll ask you a few questions so we can ensure you’re on the right repayment plan for your loans. You could be eligible for <span class=\"{color}\">loan forgiveness</span> or you might be able to <span class=\"{color}\">lower your monthly payment</span>.",
    "lower_monthly": "To have a lower monthly payment now, but longer repayment term",
    "lower_monthly_blurb": "We know it can be difficult to afford your monthly payment, and we may be able to find you a lower payment.",
    "months_of_qualifying_payments": "Months of qualifying payments",
    "not_interested": "No, and I’m not interested",
    "not_yet": "Not yet, but I would like to learn more about loan forgiveness",
    "other_or_private": "Other/Private Sector",
    "payments_since_94": "Since July 1, 1994, approximately how many months have you made payments on your current student loans?",
    "payoff_goal_blurb": "We know your financial picture is more than just your student loan debt, so letting us know your goal helps us choose the best options for you.",
    "payoff_quickly": "To pay off as quickly as possible",
    "please_complete": "Please complete all required fields before submitting.",
    "pslf_requires": "PSLF requires you to stay in public service for 10 years.",
    "recommendation_history": "Recommendation History",
    "state_of_residence": "State of residence",
    "strategy_finder_results": "Strategy Finder Results",
    "teacher_five_years": "I plan on staying a teacher for at least five consecutive years",
    "teacher_five_years_unlikely": "I probably won't be a teacher for at least five consecutive years.",
    "teacher_forgiveness_rec": "Teacher loan forgiveness requires you to be a teacher for five consecutive years.",
    "teacher_how_long": "How long do you plan on being a teacher?",
    "teacher_low_income": "Teacher in a low income school",
    "teachers_loan_forgiveness": "Teacher Loan Forgiveness",
    "ten_years_unlikely": "I probably won’t stay in public service for at least 10 years",
    "we_will_not_be_able": "We will not be able to provide accurate recommendations since you have not added your accounts. Please return to the dashboard and add accounts.",
    "when_first_loan": "When was the first time you took out a federal student loan?",
    "which_program": "Which loan forgiveness program are you working towards?",
    "your_payment_and_sf_input": "Your Monthly Payment and Strategy Finder Input",
    "your_payoff_goal": "What is your payoff goal?"
  },
  "submit": "Submit",
  "svg": {
    "alternate_flow": "A futuristic robot showing you a review.",
    "bullseye": "People holding large coins surround a bullseye with an arrow.",
    "calculator_illustration": "A person reaches for a button on a calculator twice their height",
    "coffee_college": "Steam rising from a cup of coffee next to a graduation cap with tassel",
    "coin_folder": "A person opening a folder with coins coming out",
    "coming_soon": "A person pasting a billboard that reads 'Coming Soon' onto a computer monitor",
    "crystal_ball": "A person looks into a crystal ball to see what their finances will be",
    "decision_making": "Two people collaborating on a digital interface, with checkmarks and an ‘X’ symbol representing task completion and decision-making.",
    "dept_of_ed": "A person holding a letter of forgiveness from the Department of Education",
    "enrollment_complete": "Celebratory hat with confetti.",
    "family": "A parent in a suit and tie stands behind a child at a desk",
    "five_two_nine_piggy": "A figure sits atop a stack of gold coins next to a large piggy bank",
    "growth": "An illustration of a bar chart and foliage",
    "infographic_screen": "A person looking at a large screen with infographics",
    "mail_sent": "Envelopes flying through the air.",
    "marketing_strategy": "One person holds a magnifying glass up to chalkboard-sized browser display; another reaches over top from behind with a bullseye",
    "mentoring": "Two figures converse over a background of options and a magnifying glass.",
    "message": "No unread messages at this time.",
    "no_unread_message": "You have no unread messages.",
    "online_library": "Inside a colorful bubble, a long-haired figure reaches to lift a book from a shelf",
    "planning": "An illustration of two people using a clock and calculator for planning",
    "questions": "A person in a sport coat and tie surrounded by question marks holds their hand to their chin",
    "secure_your_future": "A person sits on the floor with coins floating overhead.",
    "social_media_marketing": "A woman surrounded by question marks holds a laptop in front of her and a phone to her ear",
    "startup": "As a rocket takes off behind them, a tall figure holds a controller and looks over at someone sitting at a table with a laptop",
    "student_loan_glossary": "A magnifying glass tilts toward two interlocking gears with a lightbulb above them",
    "target": "A group of people surround a target; two are holding coins; another has an arrow in the bullseye of the target",
    "unread_message": "You have unread messages.",
    "woman_on_laptop_working": "A person sits next to a potted plant with a laptop in the their lap",
    "working": "A person sits at a desk with a cup of coffee, a computer and a potted plant."
  },
  "syf": {
    "abbreviation": "SYF",
    "admin": {
      "open_document": "Open document in new window",
      "payments": {
        "review": {
          "form": {
            "submit": "Submit"
          },
          "title": "Secure 2.0 Payment Review"
        },
        "review_transactions": "Review {count, plural, =0 {no transactions} =1 {1 transaction} other {# transactions}}"
      }
    },
    "dashboard": {
      "email": {
        "add_email": "Add Email",
        "content": "You are required to provide your personal email address on file up to date for communication and security purposes. If you fail to provide a personal email address, you will not be receiving benefits from your employer once terminated/ending of your employment with your employer.",
        "header": "Personal Email"
      },
      "insights": {
        "estimated_monthly_payment": "Expected Monthly Loan Payment",
        "header": "My Insights",
        "section": {
          "one": {
            "changes_will_impact": "Editing your estimated monthly payment or annual income will impact the insights below",
            "content_at_max": "With your current income and expected monthly loan payment amount, you are already on track for receiving the maximum employer match to your retirement savings account.",
            "content_below_max": "In addition to the Secure Your Future match, you can maximize your employer's contribution to the retirement plan by deferring {deferment_amount} of your 401(k) eligible income.",
            "discover": "Discover insights on ways to maximize your employers retirement contribution.",
            "header": "401(k) Plan Deferral",
            "missing_both": "Add your income and monthly payment to unlock your 401(k) deferral insight",
            "read_more": "See My Insights"
          },
          "two": {
            "content": "Explore more affordable student loan payments and learn if loan forgiveness is an option for you.",
            "header": "Consider Other Repayment Options",
            "read_more": "Read More"
          }
        }
      },
      "loan_accounts": {
        "account_col_header": "Student Loan Account Name",
        "confirmation_alert": {
          "unverify": {
            "content": "You are choosing to remove your student loan payments from qualifying toward an employer match. Once confirmed, payments associated with this account will no longer be counted towards and employer match.",
            "header": "Exclude student loan payments towards match payments"
          },
          "verify": {
            "content": "You are choosing to opt in to using payments associated with this account to qualify toward an employer match. Please mark the checkbox below to confirm you are the borrower for the student loan(s).",
            "header": "Include student loan payments towards match payments"
          }
        },
        "confirmation_alert_content": "You are choosing to opt in to using payments associated with this account to qualify toward an employer match. Please mark the checkbox below to confirm you are the borrower for the student loan(s).",
        "confirmation_alert_header": "Include student loan payments towards match payments",
        "header": "My Loan Accounts",
        "main_content": "Student loan payments made by you qualify for an employer match into your retirement savings account. If you select \"Yes\" for \"Include Payments\", it means that you are the borrower for the student loan.",
        "verified_col_header": "Include Payments"
      },
      "match": {
        "section": {
          "two": {
            "header": "My Loan Payments",
            "subheader": "You will be able to add payments starting 01/01/2024 when your benefit begins."
          }
        },
        "summary": {
          "certify_link_text": "Certify Payments",
          "certify_payments": {
            "header": "Certify Payments",
            "statement": "I confirm I made these qualifying loan payments to my student loan accounts",
            "subheader": "Select the loan payments you would like to certify by checking the box(s). Certification is required to receive a retirement savings match.",
            "table": {
              "date": "Date Payment Was Made",
              "select": "Select",
              "servicer": "Loan Servicer"
            }
          },
          "deadline_label": "Payment Certification Deadline",
          "explanation": {
            "label": "Explain this to me",
            "section": {
              "one": {
                "content": "Student loan accounts in your name that you have made payments to during the course of the year are eligible to be matched is part of the Secure Your Future benefit.",
                "title": "What are loan payments I have certified?"
              },
              "three": {
                "content": "Payments made to your student loan account by others including any employer contributions or transactions that refinance your student loans.",
                "title": "What are loan payments that are not eligible?"
              },
              "two": {
                "content": "Secure 2.0 requires that employees certify all student loan payments made during the year. If you have student loan payments that require certification, they are noted here and will not be matched until they are certified.",
                "title": "What are loan payments I have not certified?"
              }
            }
          },
          "table": {
            "amount_header": "Amount",
            "certified_label": "Loan payments I have certified",
            "count_header": "Count",
            "qualified_label": "Loan payments I have not certified",
            "unqualified_label": "Loan payments that are not eligible"
          },
          "title": "My Match Summary"
        }
      },
      "match_and_loan_payment_details": "My match summary and loan payment details",
      "payments": {
        "add_link_prefix": "Not seeing payments you have made?",
        "add_link_text": "Click here.",
        "header": "My Loan Payments",
        "qualified": {
          "empty": "No eligible payments currently",
          "header": "Eligible Loan Payments",
          "status": {
            "certified": "Payment Certified",
            "pending": "Payment Pending Certification"
          },
          "table": {
            "payment_date_header": "Payment Date",
            "payment_header": "Loan Payment",
            "servicer_header": "Servicer",
            "status_header": "Status"
          }
        },
        "unqualified": {
          "empty": "No inelgibile payments currently",
          "header": "Ineligible Loan Payments",
          "table": {
            "payment_date_header": "Payment Date",
            "payment_header": "Loan Payment",
            "servicer_header": "Servicer"
          }
        },
        "unverified": {
          "empty": "No unverified payments currently",
          "header": "Unverified Loan Payments",
          "table": {
            "creation_date_header": "Submitted",
            "payment_date_header": "Payment Date",
            "payment_header": "Loan Payment",
            "reason_header": "Reason",
            "servicer_header": "Servicer",
            "status_header": "Status"
          }
        }
      }
    },
    "default": "Secure Your Future",
    "enrollment": {
      "complete": "Complete",
      "continue_to_enrollment": "Continue to Enrollment",
      "enroll": "Enroll",
      "incomplete": "Incomplete",
      "review": {
        "benefit_details": "The following are your benefit details. Your employer will:",
        "benefit_enrollment_review": "Benefit Enrollment Review",
        "whats_next": "What's Next?",
        "whats_next_body": "Tuition.io will send you an email reminding you to add your student loan accounts and/or upload your student loans statements with the Secure Your Future benefit, which is required to receive a company matching contribution into your 401(k) plan account."
      },
      "submitted": {
        "enrollment_complete": "Enrollment Complete",
        "what_happens_now": "What happens now? You can expect the following:",
        "you_are_now_enrolled": "You are now enrolled in Secure your Future, a Secure 2.0 benefit"
      }
    },
    "footer": {
      "mohela": "If you are having trouble with Mohela loans, <a href=\"https://www.mohela.com/system-transition\" class=\"text-ocean-600 underline\">click here</a> to learn more.",
      "not_able_to_find_your_servicer": "Not able to find your service?",
      "skip_this_step_for_now": "Skip This Step For Now",
      "tech_support": {
        "adding_my_student_loans": "Adding My Student Loans",
        "answer_one": "We recommend starting with the loan that has the highest interest rate. You'll be able to add all of your loans later.",
        "answer_three": "The National Student Loan Data Systems (NSLDS) is the U.S. Department of Education's central database for federal student aid. This is an alternative approach to understanding who your loan servicers are. Find out who your federal loan account services are by creating an account here.",
        "answer_two": "If your servicer is not on the list, email us at <a href=\"mailto:support@tuition.io\" class=\"text-ocean-600\">support@tuition.io</a> or call us at <span class=\"text-ocean-600\">+1 (855) 353-9395</span>.",
        "default": "Tech Support",
        "question_one": "Have more than one student loan?",
        "question_three": "Not sure how to find your federal loan?",
        "question_two": "What if my loan service provider isn't on the list?",
        "still_have_questions": "Still have questions?"
      }
    },
    "insights": {
      "four_oh_one_k": {
        "heading": "401(k) Plan Deferral",
        "insight": {
          "heading": "Insight",
          "one": "Based on your <b>{salary} income</b> your maximum available 401(k) employer match is <b>{match} annually ({match_statement})</b>",
          "two": "To receive your employer's maximum match, you will need to <b>contribute at least {monthly} per month of your income</b> to the retirement savings plan.",
          "two_no_action": "You do not have to defer any money from your salary to receive the full match from your employer."
        },
        "match": {
          "heading": "Here is how you can unlock your maximum retirement match",
          "one": "Make your <b>{monthly} monthly</b> student loan payment <b>&rarr;</b> Unlocks <b>{annually}</b> annually",
          "three": "Together these steps will unlock the <b>{maximum} maximum employer match to your retirement savings account.</b>",
          "two": "Contribute at least <b>{monthly} per month ({annually} annually)</b> of your income to your 401K <b>&rarr;</b> Unlocks <b>{annual_unlock}</b> annually",
          "two_no_action": "You do not have to defer any money from your salary to receive the full match from your employer."
        }
      },
      "idr": {
        "advantage": {
          "button": "GO TO IDR",
          "heading": "Take advantage of federal student loan programs designed for affordability",
          "label": "Our IDR tool can help you decide your best option.",
          "one": "Income-driven repayment plans can lower your student loan payment to give you additional cash flow on a monthly basis.",
          "three": "Keep in mind lowering your student loan payment also lowers your retirement match from Secure Your Future. If you decide to switch to an income-driven repayment plan you may wish to consider increasing your income deferral for retirement savings to make up for this loss.",
          "two": "Some borrowers can qualify for payments as low as $0/month and get student loan forgiveness after 20-25 years."
        },
        "explore": {
          "heading": "Explore your options",
          "one": "Do you need more affordable student loan payments?",
          "two": "Are you interested in exploring loan forgiveness options?"
        },
        "heading": "Other student loan repayment options you may wish to consider"
      },
      "pslf": {
        "best_options": {
          "action": "Action required for PSLF eligibility.",
          "button": "GO TO PSLF",
          "four": "Keep in mind lowering your student loan payment also lowers your retirement match from Secure Your Future. If you decide to switch to an income-driven repayment plan you may wish to consider contributing some of your student loan payment savings toward retirement savings to make up for this loss.",
          "heading": "Determine if Public Service Loan Forgiveness is the best option for you",
          "label": "Based on the data provided, it does not appear that you have submitted a PSLF form. Click \"GO TO PSLF\" below to determine additional actions required to achieve PSLF loan forgiveness.",
          "one": "Working at a non-profit organization like your employer is one step toward qualifying for forgiveness under PSLF.",
          "three": "You can eliminate (tax free) your federal student loan debt in 10 years with forgiveness under PSLF.",
          "two": "Only payments under income-driven repayment plans count toward PSLF, they’re typically the most affordable repayment option giving you additional cash flow on a monthly basis."
        },
        "explore": {
          "heading": "Explore your options",
          "one": "Public Service Loan Forgiveness (PSLF) can <b>lower your monthly student loan payments, giving you additional cash flow.</b>",
          "two": "PSLF forgives your remaining student loan balance tax free after 10 years of public service work."
        },
        "heading": "Other student loan repayment options you may wish to consider"
      }
    },
    "match_plan_code": "Code",
    "match_plan_description": "Description",
    "match_plan_name": "Name",
    "match_plans": "Match Plans",
    "new_plan": "New Plan",
    "payment": {
      "field": {
        "actions": "Actions",
        "financial_institution": "Loan Servicer",
        "match_assets": "Statement(s)",
        "notes": "Notes",
        "notes_placeholder": "Reason for action...",
        "notes_required": "* A note is required",
        "partners": "Partners",
        "person": "Employee",
        "reviewed_transactions": "Reviewed Transactions",
        "servicer_required": "* Servicer is required",
        "transaction_amount": "Amount ($)",
        "transaction_date": "Payment Date",
        "transaction_type": "Payment Type",
        "verify": {
          "false": "Reject",
          "true": "Approve"
        }
      },
      "preview": "Preview Asset"
    },
    "payments": {
      "missing": {
        "cancel": "Cancel",
        "header": "Add Missing Payments",
        "options": {
          "add_payment_detail": "In the event that you cannot connect to your accounts, please use this method.",
          "add_payment_disclaimer": "This requires longer processing time. Also, will require you to return every month to update manually.",
          "add_payment_label": "Add missing payments manually",
          "link_account_annotation": "Preferred Method",
          "link_account_detail": "Seamless process where student loan payments display on your dashboard.",
          "link_account_label": "Link your accounts"
        },
        "subheader": "Please select a method of adding your payments",
        "submit": "Continue"
      },
      "new": {
        "form": {
          "cancel": "Cancel",
          "payments": {
            "add_new": "Add another loan payment",
            "amount_label": "Payment Amount ($)",
            "date_label": "Payment Date",
            "section_header": "Loan Payments"
          },
          "statements": {
            "hint": "Please attach a statement from your loan servicer that shows you have made these payments.",
            "section_header": "Upload Statements"
          },
          "submit": "Submit"
        },
        "header": "Add Payments",
        "linked_info": "Be advised that automatically processed payments may take up to a week to be reflected in the dashboard. If your payment is older than 7 days and still isn't reflected, manually enter it below.",
        "relink_anchor_text": "Click here",
        "relink_info": "to relink your loan account to add payments automatically through your servicer.",
        "relink_prefix": "There was a problem linking your loan account.",
        "subheader": "Please upload statements that show your payments made in the benefit year you are trying to get your match for. Documents will be reviewed once uploaded. Upon clicking Submit, the information will be routed to your approver and you will receive notification once payments have been approved to be qualified payments for contributions",
        "unlinked_anchor_text": "Click here",
        "unlinked_info": "to link your loan account and add payments automatically through your servicer."
      }
    },
    "plan_details": "Plan Details",
    "plan_form": {
      "benefitStartDate": "Benefit Start Date",
      "benefitStartIsRetroactive": "Benefit Start Is Retroactive",
      "benefitWaitingPeriod": "Benefit Waiting Period",
      "code": "Plan Code",
      "description": "Description",
      "faqs_form": {
        "add": "Add FAQ",
        "back": "Back",
        "header": "Plan FAQs",
        "submit": "Save"
      },
      "faqs_form_link": "Edit plan FAQs",
      "fileDateBuffer": "File Date Buffer",
      "matchFrequencyDescription": "Match Frequency Description",
      "matchPercentage": "Match Percentage",
      "matchStatement": "Match Statement",
      "maxMatchCap": "Max Match Cap",
      "maxMatchPercentage": "Max Match Percentage",
      "minimumThresholdPercentage": "Minimum Threshold Percentage",
      "periodBuffer": "Period Buffer",
      "periodCadence": "Period Cadence",
      "planName": "Plan Name",
      "qualifyingIncome": "Qualifying Income",
      "requiresEmployeeCertification": "Requires Employee Certification",
      "validations": {
        "duration_format_error": "Value must be a valid ISO 8601 duration"
      },
      "verifyAccountStatement": "Certify Payments"
    },
    "qualifying_income": {
      "pretax_annual": "Estimated Annual Income (Pretax)",
      "pretax_quarterly": "Estimated Quarterly Income (Pretax)",
      "taxed_annual": "Estimated Annual Income (After tax)",
      "taxed_quarterly": "Estimated Quarterly Income (After tax)",
      "unknown": "Estimated Income"
    },
    "shared": {
      "match_plan": {
        "default_verify_payment_statement": "I confirm that this payment is made by me.",
        "default_verify_payments_statement": "I confirm that these payments are made by me.",
        "default_verify_statement": "I confirm that I am the borrower for these student loans. Payments are made by me to this account."
      }
    }
  },
  "tas": {
    "add_education_drawer": {
      "add_education_information": "Add Education Information",
      "add_education_label": "Conference/ Certification/ Membership/ Book/ Healthy Steps Course Name (List all that are applicable).",
      "education_information": "Education Information",
      "fill_out_education_below": "Fill out the information below.",
      "name_of_reimbursement": "Name of Requested Reimbursement Item",
      "reason_label": "What is the enrollment objective for this expense? Please provide a detailed explanation of why you require the books (if applicable).",
      "required_fields": "Required Fields",
      "start_date_label": "Certification Completion Date / Membership Start Date/ Conference Date / Book Purchase Date"
    },
    "add_scholarships_drawer": {
      "add_another_scholarship": "Add Another {label}",
      "add_scholarship": "Add {label}",
      "add_scholarships": "Add {label}",
      "fill_out_scholarship_below": "Fill out any {label} information below.",
      "no_scholarships_added": "No {label} Added",
      "no_scholarships_added_info": "You do not currently have any {label} applied to this application.",
      "scholarship_amount": "{label} Amount",
      "scholarship_information": "{label} Information",
      "scholarship_name": "{label} Name"
    },
    "application": {
      "delete_modal": {
        "attention": "Attention",
        "content": "Are you sure you want to delete this application?",
        "prepaid_warning": "This application has been paid and cannot be deleted. Please contact your program administrator for assistance.",
        "title": "Delete Application"
      },
      "grade_point_average": "Grade Point Average",
      "id_no": "ID# xx",
      "requested_changes": "{name} has requested changes to your application.",
      "submit_evidence_for_review": "Submit Evidence for Review",
      "type_two": {
        "missing_requirements": {
          "conditions_confirmation": "Please confirm you have read and accepted the Terms and Conditions of the Tuition Assitance Program.",
          "documents_attachments": "Attachments",
          "documents_education": "Education",
          "documents_required": "Please include the following items as required by your program administrator",
          "reimbursement_confirmation": "Please confirm your enrollment in Tuition Reimbursement.",
          "title": "Missing Requirements"
        },
        "new": {
          "add_scholarships": "Add Scholarships",
          "application": "Application",
          "attachment_description": "Upload documents as requested by your program administrator.",
          "confirm_application_delete": "Are you sure you want to delete this application?",
          "confirm_delete_expense": "Are you sure you want to delete the expense for",
          "confirm_scholarship_delete": "Are you sure you want to delete this scholarship?",
          "delete_application": "Delete Application",
          "delete_course": "Delete Course",
          "delete_scholarship": "Delete Scholarship",
          "drop_files": "Drop files",
          "edit_scholarship": "Edit Scholarship",
          "education": "Education",
          "expense_type_description": "Add an expense for reimbursement. All expenses in one application need to have the same start and end date. Expenses with different start and end dates need to be submitted in separate applications.",
          "expense_type_reminder": "All expenses in one application need to have the same start and end date.",
          "finish_later": "Finish Later",
          "name": "Application Name",
          "required_items": "Required Items",
          "scholarship": "Scholarship",
          "scholarships": "Scholarships"
        }
      },
      "untitled_application": "Untitled Application"
    },
    "applications": {
      "alert": {
        "COURSES_APPROVED": {
          "body": "Application approval is complete",
          "title": "Courses Approved"
        },
        "EVIDENCE_APPROVED": {
          "body": "Application is now pending payment",
          "title": "Documentation Approved"
        },
        "FULFILLED": {
          "body": "Application is now complete",
          "title": "Approved"
        },
        "PAID_IN_FULL": {
          "body": "Application was approved and reimbursed for the amount of {amount}",
          "title": "Fully Reimbursed"
        },
        "PENDING_COURSES_APPROVAL": {
          "body": "Review in process",
          "title": "In Review"
        },
        "PENDING_EVIDENCE_APPROVAL": {
          "body": "Documentation review in process",
          "title": "In Review"
        },
        "REFUND_REQUESTED": {
          "body": "Application has an outstanding balance of {amount}",
          "title": "In Repayment"
        }
      },
      "amount": "Amount",
      "applicant": "Applicant",
      "application_name": "Application Name",
      "attachments": "Attachments",
      "default": "Application",
      "dependent": "Dependent Name",
      "details": "Details",
      "education": "Education",
      "start_date": "Start Date",
      "status": "Status",
      "submission_date": "Submission Date"
    },
    "benefits_summary": {
      "add_result": "Add / Edit Result",
      "add_result_simple": "+Result",
      "assistance_limit": "Assistance Limit",
      "attachments": "Attachments",
      "helper_text": "Please review that everything is correct before submitting.",
      "requested_amount": "Requested Amount",
      "required_items": "Required Items",
      "scholarships": "Scholarships",
      "submit_application": "Submit Application",
      "submit_evidence": "Submit Evidence",
      "title": "Benefits Summary",
      "total_request": "Total Request"
    },
    "dashboard": {
      "available_benefits": "Available Education Benefits"
    },
    "default": "Tuition Assistance",
    "history": {
      "default": "History",
      "past_programs": "Past Programs",
      "payment_details": "Payment Details",
      "requested_amount": "Requested Amount",
      "title": "Application History"
    },
    "new": {
      "education": "Education",
      "expense_type": "Expense Type",
      "scholarships": {
        "default": "Scholarships",
        "optional": "(Optional)",
        "please_enter_any_scholarships": "Please enter any {label} you have received for this expense type."
      }
    },
    "program": {
      "apply_for_courses": "Apply for Courses",
      "approval": "Program Approval",
      "confirm_program_delete": "Are you sure you want to delete this program?",
      "course_application_description": "A course application is a formal request to enroll in a specific educational program. It typically involves submitting required documents and information form provided by the educational institution or course provider.",
      "course_application_process": "Course Application Process",
      "courses": "Courses",
      "delete_program": "Delete Program",
      "details": "Details",
      "education_assistance": "Education Assistance - Degrees or Coursework",
      "employee": "Employee",
      "estimated_program_begin_date": "Estimated Program Begin Date",
      "estimated_program_end_date": "Estimated Program End Date",
      "history": "History",
      "institution_name": "Institution Name",
      "new_application": "New Application",
      "pending_program_approval": "Pending Program Approval",
      "pending_program_approval_description": "Your program is pending approval. Once approved, you can add courses.",
      "program": "Program",
      "program_approval_details": "Program Approval Details",
      "program_specialization": "Program Specialization",
      "required_items": "Required Items",
      "start_date_not_set": "Start Date Not Set",
      "status": "Status",
      "submission_date": "Submission Date"
    },
    "terms_and_conditions": "Terms & Conditions",
    "terms_you_will_agree_to": "The <span class=\"tio-anchor\">Terms and Conditions</span> you will need to agree to later in this process."
  },
  "tasks": "Tasks",
  "ten_twenty_cancellation": {
    "am_i_eligible": "Am I eligible?",
    "biden_announcement": "On August 24th, 2022, President Biden announced significant Federal student loan changes. We are currently updating our site, so some of the information may not reflect these changes.",
    "borrower_eligibility": "Borrower Eligibility",
    "cancellation_app": "If you have loans that are not held by the Department of Education (commonly FFEL loans or Perkins Loans), and applied for a Direct Consolidation loan before 9/29/22, complete the cancellation application as soon as it's available.",
    "cannot_cancel": "If you have loans that aren’t held by the Department of Education (FFEL loans & all Perkins Loans) and did not apply for a direct consolidation loan prior to 9/29/22 you are unfortunately not eligible for cancellation at this time.",
    "click": "Click",
    "debt_relief_app_link": "<a href=\"https://studentaid.gov/debt-relief/application\" target=\"_blank\">&nbsp;here&nbsp;</a>",
    "default": "$10k - $20k Student Loan Cancellation",
    "dept_ed_guidance": "Stay up to date with the latest Department of Education Guidance",
    "direct_consolidation": "If you applied for a Direct Consolidation Loan prior to Sept. 29, 2022, you are eligible for one-time debt relief through the Direct Loan program.",
    "eligible_loan_types": "Eligibile Loan Types",
    "income_app": "The Department of Education recommends all borrowers complete an application to demonstrate your income. This application has not been released by the Department of Education at this time and is expected to be released in Early October.",
    "max_forgiveness": "Max Forgiveness",
    "next_steps": "Next Steps",
    "no_pell": "$10,000 if you’ve never received a Pell grant.",
    "no_pell_detail": "Forgives up to $10,000 for individuals making less than $125,000 per year or households making less than $250,000 per year if the borrower has never received a Pell grant.",
    "not_fed_maybe_state": "The canceled loan amount is not federally taxable as income but may be subject to state income taxes.",
    "not_held_by_ed": "As of Sept. 29, 2022, borrowers with federal student loans not held by ED cannot obtain one-time debt relief by consolidating those loans into Direct Loans.",
    "one_time_cancellation_link": "<a href=\"https://studentaid.gov/debt-relief-announcement/one-time-cancellation\">&nbsp;here.</a>",
    "only_fed_loans": "Only federally held loans are eligible, that means all Direct Loans and very few FFEL loans.",
    "plan_details": "Plan Details",
    "tax_information": "Tax Information",
    "time_frame": "Loan cancellation is expected to take 4-6 weeks after you've submitted an application.",
    "to_apply": "to apply for Federal Student Loan Debt Relief.",
    "who_qualifies": "Individual borrowers earning less than $125,000/year and households earning less than $250,000 per year may qualify.",
    "with_pell": "$20,000 if you’ve received a Pell grant.",
    "with_pell_detail": "Forgives up to $20,000 for individuals making less than $125,000 per year or households making less than $250,000 per year if the borrower has received a Pell grant."
  },
  "tuition_assistance": {
    "additional_information": "Additional Information",
    "admin": {
      "payments": {
        "cancel": "Cancel Payment",
        "settle": "Settle Payment"
      },
      "visit_profile_to_release": "The employee is currently held and cannot progress with any of their applications. To release the employee, please go to the employee profile page."
    },
    "alert": {
      "application_ineligible": "This application is ineligible for approval:",
      "application_ineligible_reason": "The application is ineligible due to start or end date criteria.",
      "employee_held_pt_1": "The employee currently has applications in repayment:",
      "employee_held_pt_2": "Please refrain from approving new applications and payment submissions"
    },
    "annual_benefit": "Annual Benefit",
    "answer": "Answer:",
    "application_approval": "Application Approval",
    "application_details": {
      "add_a_custom_note": "Add A Custom Note To The Employee",
      "amount_requested_in_this_app": "Amount requested in this application",
      "app_balance_multiplier": "Application Specific Balance Multiplier",
      "application_id": "Application ID:",
      "application_info": "Application Information",
      "approval_queue_status": "Approval Queue Status",
      "approval_summary": "Request Summary",
      "approve": "Approve",
      "approve_reject_application": "Approve/Reject Application",
      "approver_instructions": "Approver Instructions",
      "are_you_sure": "Are you sure you would like to reject this application?",
      "assistance_summary": "Assistance Summary",
      "balance_multiplier": "Current Balance Multiplier",
      "benefit_paid_out": "Benefit paid out so far this year",
      "company_name": "Company Name",
      "courses_total": "Courses Total",
      "default": "Application Details",
      "employee_id": "Employee ID",
      "employee_inactive": "This employee has been de-activated, became inactive, or is currently held with an application in repayment. Please check company policy to determine next step.",
      "employee_information": "Employee Information",
      "employment_type": "Employment Type",
      "exempt": "Exempt",
      "frequently_asked_questions": "Frequently Asked Questions",
      "fte": "Full Time Employee",
      "go_to_approve": "Go to Approve",
      "in_repayment": "In Repayment",
      "instruction": "Instruction",
      "maximum_annual_benefit": "Maximum Annual Benefit",
      "maximum_annual_benefit_for_this_program": "Maximum Annual Benefit for this program",
      "non_exempt": "Non-Exempt",
      "not_ready_for_payment": "Not Ready for Payment",
      "out_of_sequence_approver_warning": "The approval being performed is out of sequence in regards to approver sequence. Do you want to continue?",
      "overview": "Overview",
      "partial_reimbursement_instruction": "If you need to request partial repayment, first select 'approve' and click submit. Once the application has been approved, you can request repayment.",
      "perdiem": "Per Diem Employee",
      "please_keep_in_mind": "The employee has an earlier application still subject to repayment. Please ensure approval of this additional application is consistent with company policies or preferences.",
      "policy_override": "Policy Override",
      "prepaid_application_rejection": "Since this is a pre-paid application, the employee will automatically be placed in a repayment status, and a hold will be applied to prevent future applications.",
      "prn": "Part Time Nurse",
      "program_info": "Program Information",
      "pte": "Part Time Employee",
      "ready_for_payment": "Ready for Payment",
      "regular": "Regular Employee",
      "reimbursement_calculation_by_credit_description": "Program Rate $ x No. of Credits = Total",
      "reimbursement_calculation_by_credit_formula": "Program Rate {rateInDollars} x {noOfCredits} = {totalInDollars}",
      "reimbursement_calculation_by_gpa_description": "3.5 - 4.0 GPA = $3000 </br> 2.75 - 3.49 GPA = $2250 </br> 2.5 - 2.74 GPA = $750 </br> <2.5 GPA = $0",
      "reimbursement_calculation_by_gpa_formula": "The lesser amount between requested amount of {requestedTotal} and amount for the <strong>{gpa}</strong> GPA will be reimbursed",
      "reimbursement_calculation_by_percent_description": "{percent}% reimbursement",
      "reimbursement_calculation_by_percent_formula": "{percent}% reimbursement of {originalTotalInDollars} = {totalInDollars}",
      "reject": "Reject",
      "reject_application": "Reject Application",
      "rejecting_prepaid_initiates": "Rejecting a prepaid application initiates the repayment process. The employee will be placed on hold.",
      "remaining_annual_benefit": "Remaining Annual Benefit",
      "repayment_amount": "Repayment Amount",
      "request_change": "Request Changes",
      "request_reimbursement": "Request Reimbursement",
      "requested_reimbursement": "Requested Reimbursement",
      "rescind": {
        "body": "Are you sure you would like to undo the last approver action?",
        "button": "Undo Last Approver Action",
        "error": "We’re sorry, but we cannot process your request at this time. Please note that only the most recent approver is able to rescind the last approval.",
        "footnote": "Only the most recent approver is able to rescind the last approval."
      },
      "role": "Role",
      "scholarships_received": "Scholarships Received",
      "seas": "Seasonal Employee",
      "some_time": "Sometime",
      "submit_on_behalf_of_employee": "Submit On Behalf Of Employee",
      "total": "Total",
      "view_application_attachments": "View application attachments",
      "who_has_approved": "Who has approved",
      "who_is_next": "Who is next",
      "would_you_like_to_reopen_this_application": "Would you like to reopen this application?",
      "your_maximum_annual_benefit": "Your maximum annual benefit is"
    },
    "application_name": "Application Name",
    "application_start_date_eligibility_warnings": {
      "dashboard_description": "This program has a {days}-day waiting period after your employment start date before you become eligible. The date entered falls within this waiting period and is not eligible.",
      "dashboard_title": "Unfortunately, you are not eligible to enroll in this program."
    },
    "application_type": "Application Type",
    "applications": {
      "application_listings": "Application Listings",
      "course_applications": "Course Applications",
      "default": "Applications",
      "employee": "Employee",
      "employee_name": "Employee Name",
      "history": {
        "ABANDONED": "Application deleted{name}",
        "COURSES_APPROVED": "Courses approved{name}",
        "COURSES_IN_PROGRESS": "Courses in progress",
        "COURSES_NOT_APPROVED": "Courses not approved{name}",
        "COURSES_REJECTED": "Coursed rejected{name}",
        "CREATED": "Application created{name}",
        "EVIDENCE_APPROVED": "Evidence approved{name}",
        "EVIDENCE_NOT_APPROVED": "Evidence not approved{name}",
        "EVIDENCE_REJECTED": "Evidence rejected{name}",
        "FULFILLED": "Application requirements fulfilled",
        "INFO_REQUESTED": "More information requested{name}",
        "PAYMENT": "Payment of {amount}{name}",
        "PAYMENT_AMOUNT_UPDATED": "Payment amount updated to {amount}{name}",
        "PAYMENT_PENDING": "Payment of {amount} pending",
        "PENDING_COURSES_APPROVAL": "Application submitted for course approval{name}",
        "PENDING_EVIDENCE_APPROVAL": "Application submitted for evidence approval{name}",
        "REJECTED_PER_POLICY": "Rejected per policy",
        "REPAYMENT": "Repayment of {amount}{name}",
        "REPAYMENT_AMOUNT_UPDATED": "Repayment amount updated{name}",
        "REPAYMENT_CANCELLED": "Repayment cancelled{name}",
        "REPAYMENT_FORGIVEN": "Repayment of {amount} forgiven{name}",
        "REPAYMENT_REQUEST": "Repayment request of {amount}{name}",
        "RESCIND": "Approval reversed{name}",
        "approval": "Approved Total",
        "approved_total_set": "Approved total set to {amount}{name}",
        "approved_total_updated": "Approved total updated from {from} to {to}{name}",
        "default": "Application updated{name}",
        "payments": {
          "PAYMENT": "payment",
          "PAYMENT_AMOUNT_UPDATED": "payment amount updated",
          "PAYMENT_PENDING": "payment pending",
          "REPAYMENT": "repayment",
          "REPAYMENT_AMOUNT_UPDATED": "repayment amount updated",
          "REPAYMENT_CANCELLED": "repayment cancelled",
          "REPAYMENT_FORGIVEN": "repayment forgiven",
          "REPAYMENT_REQUEST": "requested for repayment"
        }
      },
      "last_action_by": "Last Action By",
      "partner": "Partner",
      "partner_name": "Partner Name",
      "payment_filter_label": "Payment State",
      "school_institution": "School/Institution",
      "state_filter_label": "Application State"
    },
    "approval_queue": {
      "reassign": "Reassign",
      "roles": {
        "TAS": {
          "Approver": {
            "ADMIN_APPROVER": "Admin Approver",
            "APPROVER": "Approver",
            "CUSTOM_APPROVER": "Custom Approver",
            "CUSTOM_INDIVIDUAL_APPROVER": "Custom Individual Approver",
            "DEPARTMENT_HEAD": "Department Head",
            "FALLBACK": "Temporary Approver",
            "FINANCE_APPROVER": "Finance Approver",
            "HYPERVISOR": "Supervisor's Supervisor",
            "PPP_FINANCE_APPROVER": "PPP Finance Approver",
            "SUPERVISOR": "Supervisor",
            "TAP_FINANCE_APPROVER": "TAP Finance Approver",
            "TIO_APPROVER": "Tuition.io Approver"
          }
        }
      },
      "select_replacement_approver": "Select Replacement Approver"
    },
    "click_here": "Click here",
    "click_here_to_view_employee_pt2": "to view all employee information",
    "click_here_to_view_messages_pt2": "to view messages",
    "completed": "Completed",
    "dashboard": {
      "active_programs": "Active",
      "annual_benefit": "Annual Benefit",
      "approval_submitted_on": "Approval Submitted On",
      "approved_pending_payment_total": "Approved - Pending Payments",
      "certification": "Certification",
      "completed": "Completed",
      "course_applications": "Course Applications",
      "fulltime_employees": "Full-time employees:",
      "go_to_applications": "Go to applications",
      "go_to_reports": "Go to reports",
      "graduate": "Graduate",
      "in_progress": "In Progress",
      "my_payment_activity": "My Payment Activity",
      "no_active_programs": "Currently, no active programs. Click View & Apply below to get started.",
      "no_eligible_programs": "No eligible programs at this time",
      "paid": "Paid",
      "parttime_employees": "Part-time employees:",
      "past_programs": "My Past Programs",
      "payment_activity": {
        "annual_usage": "Current",
        "dollar": "$",
        "filter_all_records_by_year": "Filter All Records By Year",
        "lifetime_usage": "Lifetime",
        "no_records_found": "No records found",
        "note": "Includes paid amounts and approved, pending payments",
        "payment_details": "Payment Details",
        "payments": "Payment Summary",
        "pill_label": {
          "approved_for_courses": "Requested Amount Approved",
          "fully_paid": "Fully Paid",
          "in_repayment": "In Repayment",
          "in_transition": "In Transition",
          "partially_paid": "Partially Paid",
          "pending": "Pending Payment"
        },
        "total": "Total Paid",
        "total_payments": "Total Payments"
      },
      "payment_details": {
        "application_name": "Application",
        "payment_amount": "Amount",
        "payment_date": "Date",
        "program_name": "Program Name",
        "title": "Paid"
      },
      "pending": "Pending",
      "pending_payment_details": {
        "application_name": "Application",
        "expected_amount": "Amount",
        "expected_tio_payment_date": "Expected Tio Payment Processing Date",
        "title": "Upcoming"
      },
      "program_closed_on": "Program Closed On",
      "program_end_date": "Program End Date",
      "program_start_date": "Program Start Date",
      "programs_i_can_apply": "Programs I Can Apply To",
      "requested": "Requested",
      "specialized": "Specialized",
      "state": "State",
      "usage_to_date": "Usage to Date",
      "year_to_date_payment_total": "Year to date"
    },
    "default": "Tuition Assistance",
    "dependent_program_warngings": {
      "dashboard_description": "The age limit for a {relationship} is {limit}. Please check with your employer in regards to the details of the policy.",
      "dashboard_title": "Unfortunately, your dependent {name} is not eligible to enroll in this program."
    },
    "details": "Details",
    "faq": "Frequently Asked Questions",
    "get_started": "Get Started",
    "held_participant_warnings": {
      "dashboard_description": "We are disabling enrollment to certain programs per your employer's policy. Please check with your employer in regards to the details of the policy.",
      "dashboard_title": "Unfortunately, you have application(s) in repayment."
    },
    "id": "ID #: ",
    "in_progress": "In Progress",
    "inactive_participant_warnings": {
      "dashboard_description": "You are no longer active in the system. For any assistance, please contact your employer to confirm eligibility to receive Tuition Assistance Benefits.",
      "dashboard_title": "Unfortunately, you can no longer submit new applications."
    },
    "is_single_application_program_disclaimer": "Only 1 active course application is allowed. Please create a new Program to add new courses.",
    "launched": "Launched",
    "limits_summary": {
      "benefit_paid_and_approved": "Overall Benefit Paid and Approved",
      "benefit_remaining": "Benefit Remaining For This Program",
      "explain_limit": "Explain Why Limit Has Maxed Out",
      "program_limit": "Program Limit",
      "requested_amount": "Requested Amount",
      "scholarships": "Scholarships",
      "total_request": "Total Request"
    },
    "lpn": {
      "accessing_your_discount_is_easy": "Accessing Your Discount is Easy",
      "banner_header": "New Tuition Discounts Available To You",
      "devry": {
        "default": "DeVry University",
        "item_1": "10% discount on all courses",
        "item_2": "The application fee will be waived"
      },
      "subheader": "You are now eligible for tuition discounts at the following schools:",
      "uagc": {
        "default": "University of Arizona Global Campus (UAGC)",
        "item_1": "20% discount on PhD degree courses",
        "item_2": "11% discount on Master’s degree courses",
        "item_3": "11% discount on Undergraduate degree courses"
      },
      "uopx": {
        "default": "University of Phoenix",
        "item_1": "Your 6th course is free after completing 5 courses within a 365-day period"
      },
      "when_enrolling_for_your_next_course": "When enrolling for your next course, simply specify your employer on the school’s website or when you register in person. If you qualify for other tuition discounts at these schools, the school will apply the larger discount available to you. No action is required in your Tuition.io account."
    },
    "mentoring": {
      "answer_coach_questions": "Answer a few questions so our coaches can prepare and help you better ahead of time.",
      "app_or_tech_questions": "Have questions about an application you already submitted or need technical support?",
      "contact_us": "Contact us through email, phone, or live chat.",
      "default": "Mentoring",
      "how_can_mentoring_help": "How can mentoring help you?",
      "mentoring_blurb": "If you are interested in advancing your education and using your employer’s tuition assistance program to help pay for some or all of the cost, our mentors are here to help! We have a team of individuals who can help you understand your employer’s policy and find the best options for your goals. Our mentors can help you understand the basics of paying for college and how to best leverage your employer benefits to minimize out of pocket costs.",
      "question_1": "1. What would you like to speak with your mentor about?",
      "question_2": "2. Do you have any previous Degree or Credits in the same area of Study?",
      "question_3": "3. What is your preferred learning format?",
      "question_4": "4. Have you taken student loans out previously? And what type?",
      "question_5": "5. What type of education are you pursuing?",
      "question_6": "6. Are you currently enrolled in an education program?",
      "question_7": "7. Have you contacted an Admissions or Financial aid counselor at your selected institution?",
      "question_8": "8. How do you want to contact a mentor? (email or schedule a phone call)",
      "schedule_phone_call": "Take me to schedule a phone call when I’m done",
      "send_me_an_email": "Send me an email",
      "speak_with_mentor": "Speak with a mentor via email or phone",
      "submit_success": "Your form has been submitted!"
    },
    "messages": {
      "date": "Date",
      "default": "Messages",
      "message": "message",
      "no_messages": "No Messages have been sent yet",
      "reviewer": "Reviewer",
      "send_a_message_admin": "Send a message to the application employee",
      "send_a_message_employee": "Send a message to the application reviewer",
      "submit_error": "Error sending message"
    },
    "migrated": "Migrated",
    "more_info": "more info",
    "no_programs_launched": "No Programs Launched",
    "no_response_provided": "No response provided",
    "not_applicable": "N/A",
    "not_provided": "Not Provided",
    "payments": "Payments",
    "pending": "Pending",
    "pending_program_approval": "The Program needs to be approved before you can add courses. Once the Program is approved, the Add Courses Button should be enabled and you can proceed.",
    "preapproval_app": {
      "application_id": "Application ID",
      "application_review": "Application Review",
      "default": "Pre-Approval Application",
      "degree": "Degree",
      "email_hint": "We recommend using an email you check routinely",
      "employee_email": "Employee Email",
      "employee_fullname": "Employee Full Name",
      "employee_id": "Employee ID",
      "employee_info": "Employee Information",
      "featured_schools": "Featured Schools",
      "payroll_id": "Payroll ID",
      "program_begin_date": "Program Begin Date",
      "program_end_date": "Program End Date",
      "program_hint": "Please enter your estimated begin and end dates for the program.",
      "program_info": "Program Information",
      "review_and_sign": "Review and sign agreement to submit your application.",
      "school_institution": "School/Institution",
      "subtitle_step1": "Please review the information below and make changes as appropriate.",
      "subtitle_step2": "Please enter your program information below",
      "subtitle_step3": "Please review your application to confirm the details are accurate before submitting."
    },
    "program_details": {
      "application_details": "Application Details",
      "application_history": {
        "default": "Application History",
        "name_and_role": "Name & Role",
        "notes": "Notes",
        "role": "Role",
        "state": "State",
        "view_less": "View Less",
        "view_more": "View More",
        "when": "When"
      },
      "application_information": "Application Information",
      "applications": "Applications",
      "apply_for_courses": "Apply For Courses",
      "cancel_app": {
        "body": "Once you confirm your request to delete this application, it cannot be undone.",
        "delete_application": "Delete Application",
        "delete_course": "Delete Course Application",
        "delete_program": "Delete Program Application",
        "header": "Are you sure you would like to delete this application?"
      },
      "courses": {
        "add_a_scholarship": "Add A Scholarship",
        "add_course": "Add Course",
        "add_grades": "Add Grades",
        "application_review": "Application Review",
        "attention": "Attention",
        "attention_required": "Attention Required",
        "course_begin_date": "Course Begin Date",
        "course_books": "Course Books",
        "course_credit": "Course Credit",
        "course_credits": "Course Credits",
        "course_description": "Course Description",
        "course_details": "Course Details",
        "course_duration_alert": "All courses in one application will have the same course start and course end date.",
        "course_end_date": "Course End Date",
        "course_expenses_breakdown": "Course Expenses Breakdown",
        "course_information": "Course Information",
        "course_labs": "Course Labs",
        "course_name": "Course Name",
        "course_number": "Course Number",
        "course_software": "Course Software",
        "course_total": "Course Total",
        "course_tuition": "Course Tuition",
        "courses_and_scholarships": "Courses and Scholarships",
        "courses_application": "Courses Application",
        "default": "Courses",
        "document_type": "Document Type",
        "edit_grades": "Edit Grades",
        "edit_scholarships": "Edit Scholarships",
        "estimated_cost": "Estimated Cost",
        "files_should_be_in_pdf_format_only": "Files should be in PDF format only",
        "fill_in_required_fields": "Fill in the required fields for this course to submit this application",
        "held_participant_warning": "You have an active repayment. Once the repayment request amount has been paid back to your employer you will be able to submit this application. You may start and save an application meanwhile.",
        "maximum_annual_benefit": "Maximum Annual Benefit",
        "my_courses": "My Courses",
        "please_add_courses": "Please add courses that you will be taking during this duration.",
        "please_add_grades_and_attachments": "Please add grades and attachments for this course",
        "please_add_your_grades_and_receipts": "Please add your grades and receipts by clicking on the courses below. Once grades have been added you will be able to submit this application to receive reimbursement by clicking 'submit for review' below",
        "please_edit_courses": "Please edit courses that will be taken during this duration.",
        "please_ensure_your_application": "Please ensure your application is accurate before submitting",
        "please_enter_any_scholarships": "Please enter any scholarships you might have received during the time of this application",
        "please_enter_begin_and_end": "Please enter begin and end date for your courses.",
        "please_enter_begin_and_end_option_two": "Please enter begin and end date for the courses.",
        "please_enter_grades_if_applicable": "Please enter grades if applicable (if not applicable, please enter N/A) and upload any supporting documentation. Click 'submit for review' for the final review process",
        "please_upload_these_documents": "Please upload these documents as required by your program administrator:",
        "requested_annual_benefit": "Requested Annual Benefit",
        "requested_total": "Requested Total",
        "scholarship_amount": "Scholarship Amount",
        "scholarship_name": "Scholarship Name",
        "scholarships_added": "Scholarships Added",
        "semester_code": "Semester Code",
        "validation": {
          "course_date_minimum_eligibility": "This program has a {days}-day waiting period after the employment start date before you become eligible. Date must be after {date}.",
          "defaults": {
            "begin_date": "Date must be after January 1, 2000."
          }
        },
        "view_attachments": "View attachments",
        "view_course_details_and_attachments": "View course details and attachments",
        "you_can_upload_multiple_attachments": "You can upload multiple attachments",
        "your_requested_annual_benefit": "Your requested annual benefit is above your maximum annual benefit"
      },
      "courses_added": "Courses Added",
      "create_new_program_instance": "Create New Instance",
      "default": "Program Details",
      "held_participant_warning": "You have an active repayment. Once the repayment request amount has been paid back to your employer you will be able to submit an application.",
      "including_any_scholarships": "(including any scholarships)",
      "mark_program_complete": {
        "body": "Once you confirm your request to Mark Program Complete, the program will be closed as complete. This means you will not be able to continue with updating the program.",
        "default": "Mark Complete",
        "header": "Are you sure you would like to mark this program complete?",
        "held_participant": {
          "body": "There are one or more applications that are currently in repayment. Once repayment has been completed, you can mark the program complete.",
          "header": "We are unable to mark your program as complete at this time."
        }
      },
      "maximum_annual_benefit": "Maximum Annual Benefit",
      "program_benefits": "Program Benefits",
      "program_info": {
        "click_here_pt_1": "Click here",
        "click_here_pt_2": "for program overview",
        "default": "Program Information",
        "view_details_and_attachments": "View details and attachments"
      },
      "remaining_benefit": "Remaining Benefit",
      "start_application": "Start Application",
      "status": {
        "approved": "Approved On",
        "approved_total": "Approved Total",
        "courses_begin_date": "Courses Begin Date",
        "courses_end_date": "Courses End Date",
        "created": "Created On",
        "not_provided": "Not Provided",
        "paid_date": "Paid Date",
        "paid_total": "Paid Total",
        "pre-approved": "Pre-Approved On",
        "rejected": "Rejected On",
        "submit_for_payment": "Submit For Payment",
        "submit_for_review": "Submit For Review",
        "submitted": "Submitted On",
        "updated_on": "Updated On"
      },
      "suspended_program_disclosure": "This is an outdated program. Please continue to complete existing applications, but do not apply for new applications in this program.",
      "what_is_the_process": "What is the Process?",
      "withdraw_program": {
        "body": "Once you confirm your request to withdraw, the program will be withdrawn. This means you will not be able to continue with updating the program.",
        "default": "Withdraw",
        "header": "Are you sure you would like to withdraw from this program?",
        "held_participant": {
          "body": "There are one or more applications that are currently in repayment. Once repayment has been completed, you can withdraw from the program.",
          "header": "We cannot withdraw your program at this time."
        }
      },
      "your_estimated_annual_usage": "Your estimated annual usage is",
      "your_received_annual_benefit": "Your received annual benefit is"
    },
    "program_eligibility_warnings": {
      "dashboard_description": "Your employer's policy requires employment with the company for {time} days before you are eligible for Tuition Assistance. Please come back <span class=\"font-semibold\">{date}</span> when you are eligible.",
      "dashboard_title": "Unfortunately, you are not eligible to enroll in this program."
    },
    "program_exclusivity_warnings": {
      "dashboard_description": "We are disabling enrollment to certain programs per your employer's policy. Please check with your employer in regards to the details of the policy.",
      "dashboard_title": "Per your employer's policy, you can only enroll in certain programs concurrently."
    },
    "program_instances": {
      "default": "Program Instances",
      "history": {
        "ABANDONED": "Program deleted{name}",
        "COMPLETED": "Program completed{name}",
        "COMPLETION_APPROVED": "Program completion approved{name}",
        "COMPLETION_NOT_APPROVED": "Program completion not approved{name}",
        "CREATED": "Program created{name}",
        "PENDING_COMPLETION_APPROVAL": "Program submitted for completion approval{name}",
        "PENDING_PROGRAM_APPROVAL": "Program submitted for approval{name}",
        "PENDING_WITHDRAWAL_APPROVAL": "Program submitted for withdrawal approval{name}",
        "PRIMED": "Program approved{name}",
        "PROGRAM_APPROVED": "Program approved{name}",
        "PROGRAM_NOT_APPROVED": "Program not approved{name}",
        "WITHDRAWAL_APPROVED": "Program withdrawal approved{name}",
        "WITHDRAWAL_NOT_APPROVED": "Program withdrawal not approved{name}",
        "WITHDRAWN": "Program withdrawn{name}",
        "header": "Program History"
      },
      "instance_id": "Instance ID",
      "program_applications": "Program Applications",
      "program_instance_listings": "Program Instance Listings",
      "state_filter_label": "Program Instance State"
    },
    "program_steps": {
      "application_process": "Application Process",
      "complete": "Complete",
      "complete_application": "Complete Application",
      "complete_courses": "Complete Courses",
      "evidence_approval": "Evidence Approval",
      "final_reimbursement": "Final Reimbursement",
      "get_courses_approval": "Get Courses Approval",
      "get_program_approval": "Get Program Approval",
      "prepayment": "Prepayment",
      "start_application": "Start Application",
      "submit_for_evidence_approval": "Submit For Evidence Approval",
      "submit_grades": "Submit Grades"
    },
    "programs": "Programs",
    "question": "Question:",
    "reopen_application": "Reopen Application",
    "request_repayment": "Request Repayment",
    "submitted": {
      "application_submitted": "Application Submitted",
      "courses_in_your_app": "Courses in your application are",
      "evidence_submitted": "Evidence Submitted",
      "go_to_dashboard": "Go to Dashboard",
      "once_your_application_is_accepted": "Once your application is accepted, your next step will be to add grades and receipts",
      "scholarships_in_your_app": "Scholarships in your application are",
      "submit_another_application": "Submit Another Application",
      "we_will_notify_you": "We will notify you once your employer has reviewed your application",
      "what_happens_now": "What happens now? You can expect the following:",
      "you_can_now_begin_your_courses": "You can now begin your course(s). After course(s) are complete, please upload your grades and submit for approval",
      "you_can_review_your_application": "You can review your application at any time from your dashboard",
      "your_application_may_have_multiple_reviewers": "Your application may have multiple reviewers",
      "your_application_name": "Your application name is",
      "your_application_will_be_reviewed": "Your application will be reviewed by your employer",
      "your_degree_is": "Your degree is",
      "your_evidence_will_be_reviewed": "Your evidence will be reviewed by your employer",
      "your_next_step": "Your next step is to start a course(s) application",
      "your_program_begin_date": "Your program begin date is",
      "your_program_end_date": "Your program end date is",
      "your_program_name": "Your program name is"
    },
    "to_view_program_details": "to view program details.",
    "view": "View",
    "view_and_apply": "View & Apply",
    "view_details": "View details",
    "you_already_have_an_active_program": "*You already have a program instance.",
    "your_approver_has_requested": "Your approver has asked for the following modification to your application:"
  },
  "tuition_io_lowercase": "tuition.io",
  "upload": "Upload",
  "upload_documents": "UPLOAD DOCUMENTS",
  "upload_requirements": "Files must be attached as either PDF or a JPG file format.",
  "user-roles": {
    "account_owner": "Account Owner",
    "delete_role_confirm": "Are you sure you want to delete this role?",
    "employee_admin": "Administrator",
    "family_child": "Family Member",
    "family_grand_child": "Family Member",
    "family_member": "Family Member",
    "family_parent": "Family Member",
    "family_sibling": "Family Member",
    "family_spouse": "Family Member",
    "guest_lead": "Guest User",
    "participant": "Employee",
    "pslf_admin": "PSLF Admin",
    "tas": {
      "admin": {
        "superuser": "TAS Super Admin"
      },
      "approver": {
        "approver": "TAS Approver",
        "supervisor": "Supervisor",
        "tio_approver": "T.io Approver"
      }
    },
    "tio_account_manager": "Account Manager",
    "tio_admin": "T.io Administrator"
  },
  "versions": {
    "changed_by": "Changed By",
    "changed_item": "Changed Item",
    "date_time_change": "Date/Time of Change",
    "employee_version_history": "Employee Version History",
    "new_value": "New Value",
    "no_history_available": "No History Available",
    "previous_value": "Previous Value"
  },
  "view": "View",
  "warning_body": "In order to take advantage of the student loan projection payoff calculator you must <a href={hrefLink} class=\"{classText}\">+ Add your loans.</a> This will ensure that the correct loan data is reflected in your Tuition.io account. Please take a moment to add your loans to your Tuition.io account to ensure your information is up to date.",
  "wellness": {
    "consolidation_FFEL_consolidation": "FFEL Consolidation Loans and Direct Consolidation Loans (only under certain conditions)",
    "consolidation_additional_considerations": "Additional considerations",
    "consolidation_description": "Consolidating your student loans allows you to combine multiple federal student loans into one loan with one monthly payment and one interest rate. If you’re considering consolidating your current federal student loans you will need to apply for a Direct Consolidation Loan.",
    "consolidation_direct_subsidized_loans": "Direct Subsidized Loans",
    "consolidation_direct_unsubsidized_loans": "Direct Unsubsidized Loans",
    "consolidation_direct_unsubsidized_plus_loans": "Direct Unsubsidized PLUS Loans",
    "consolidation_federal_perkins": "Federal Perkins Loans",
    "consolidation_health_education_assistance": "Health Education Assistance Loans",
    "consolidation_health_professions": "Health Professions Student Loans",
    "consolidation_loans_for_disadantaged": "Loans for Disadvantaged Students",
    "consolidation_nurse_faculty": "Nurse Faculty Loans",
    "consolidation_nursing_student": "Nursing Student Loans",
    "consolidation_plus_loans_FFEL": "PLUS loans from the Federal Family Education Loan (FFEL) Program",
    "consolidation_refinancing_alternative": "Refinancing as an alternative",
    "consolidation_refinancing_good_alternative": "Refinancing is an alternative",
    "consolidation_refinancing_good_alternative_description": "Refinancing is an option to consider if you have good to excellent credit and a good debt-to-income ratio. You can refinance both federal and private student loans and can choose which loans you want to refinance.",
    "consolidation_refinancing_good_alternative_description_keep_in_mind": "Keep in mind that all refinanced loans are private and lose all federal borrower protections and benefits, including eligibility for federal loan forgiveness programs.",
    "consolidation_refinancing_or_consolidation": "How is consolidation different from refinancing?",
    "consolidation_risks": "What are the risks of student loan consolidation?",
    "consolidation_risks_description": "In some cases, you could lose certain benefits associated with your current loans including your interest rate discount or cancellation benefits of Perkins loans.",
    "consolidation_supplemental_loans": "Supplemental Loans for Students",
    "consolidation_vs_refinancing": "Consolidation vs Refinancing",
    "consolidation_what_benefits": "What are the benefits of student loan consolidation?",
    "consolidation_what_benefits_consolidation_not_decrease": "Keep in mind that consolidating your loans will not decrease: the principal of debt you owe, your interest rate (refinancing may allow you), or the amount of money you will pay back.\n",
    "consolidation_what_benefits_description": "Consolidation creates a simplified monthly payment to one servicer, with one payment, and one interest rate. Any variable interest rate loans will be switched to one fixed interest rate. You may be able to access new repayment plans and loan forgiveness options by converting FFEL loans to Direct Loans.",
    "consolidation_which_eligible": "Which student loans are eligible for consolidation?",
    "consolidation_who_shouldnt": "Who shouldn't consolidate their student loans?",
    "consolidation_who_shouldnt_description": "<li><b>Prior to 6/30/2024</b> borrowers with FFEL loans should consolidate those loans to receive one time account adjustments and maximize progress toward loan forgiveness.\n<li>If you have Perkins Loans you will lose specific Perkins Cancellation benefits so weigh the loss of those with any benefit gained via consolidation to make the best decision.\n<li><b>Prior to 6/30/2024</b>, borrowers with direct loans that have different amounts of time in retirement can get the maximum number of payments credited if they apply for a Direct Consolidation Loan.\n",
    "fed_reserve_acknowledgement_1": "<b>Note for examiners and other employees with supervision and regulation responsibilities:</b> By using the loan refinancing services offered through the Program you hereby reaffirm your obligations under the Federal Reserve’s Code of Conduct. If you are a credentialed examiner, you agree that you will not accept a loan in violation of Code of Conduct Appendix B, Part I, section 1. If you have supervision and regulation responsibilities, you agree that you will not accept a loan in violation of Code of Conduct Appendix B, Part II, Section 1.",
    "fed_reserve_acknowledgement_2": "If you have a federal student loan, it is highly recommended that you first speak with a Tuition.io student loan coach prior to refinancing, as there are certain protections that may be lost. To ensure you are fully informed of all the implications associated with refinancing your federal student loan, you may schedule an appointment with a student loan coach. Click on “Repaying Student Debt” from the navigation menu on the left, then click on “Student Loan Coaches” at the top of the list.",
    "refinancing_applying_lendkey": "Applying takes a few minutes with our partner at LendKey. To get started, gather a government issued ID, 2 recent paystubs or last year’s W9 form, and the most recent loan statement for any loans you might want to refinance.",
    "refinancing_back_to_school": "Do you plan on going back to school?",
    "refinancing_back_to_school_description": "If you go back to school, you will be able to defer federal loans.",
    "refinancing_benefits": "What are the benefits of refinancing?",
    "refinancing_benefits_description": "Refinancing your loans will give you a lower interest rate and more flexible repayment terms (5-20 years). Since you will pay less interest, you will save money and pay off your debt faster.",
    "refinancing_check_out_marketplace": "Check your new rate in 2 minutes with our partner",
    "refinancing_click_and_type_your_name": "Click and type your name after reading your 2-3 page loan agreement and you’ll be all set with your new, lower rate student loan!",
    "refinancing_description": "Refinancing is the process of creating a new loan to pay off existing student loans. The goal of refinancing is to get better loan repayment terms, typically a lower interest rate, and to simplify repayment by having only one loan instead of multiple loans. Both federal and private student loans are eligible for refinancing.",
    "refinancing_do_recommend": "Refinancing could be a great option for you.",
    "refinancing_do_recommend_description": "You can explore multiple refinancing options with our partner <a href=\"{link}\" target=\"_blank\">{link}</a>",
    "refinancing_do_recommend_description_without_lendkey": "We recommend exploring multiple refinancing options.",
    "refinancing_dont_recommend": "We don’t recommend refinancing.",
    "refinancing_dont_recommend_description": "It may not help you achieve your repayment goals. Explore other repayment and loan forgiveness options using the",
    "refinancing_download_guide": "<a class=\"font-semibold\" href=\"{link}\" target=\"_blank\" download>Download</a> the LendKey Ultimate Guide to Student Loan Refinancing for more information.",
    "refinancing_eligible_loan_forgiveness": "Do you work at a qualifying non-profit company and still want to be eligible for public service loan forgiveness?",
    "refinancing_eligible_loan_forgiveness_description": "Refinancing will make you ineligible to receive public service loan forgiveness.",
    "refinancing_else_to_know": "What else do I need to know?",
    "refinancing_else_to_know_description": "Ask the new loan provider if loan forgiveness upon death or permanent disability is offered. You’ll only need it if you don’t have enough life or disability insurance to cover the amount of the student loan.",
    "refinancing_else_to_know_description_payment_flexibility": "Ask about the payment flexibility options. Some companies have a fixed payment and fixed term that you cannot change, while other companies allow you to pause payments or offer periods of forbearance.",
    "refinancing_good_credit_score": "Is your credit score higher than 640?",
    "refinancing_good_credit_score_description": "Most refinancing lenders require a good credit care unless you have a co-signer.",
    "refinancing_have_federal_loans_trouble": "Do you have federal student loans, an income lower than $40,000 and have trouble making your monthly payments?",
    "refinancing_have_federal_loans_trouble_description": "If yes, you should explore income-driven plans rather than refinancing.",
    "refinancing_how_to_apply": "How to Apply",
    "refinancing_interest_be_lower": "Will your refinanced interest rate be lower than your current interest rate?",
    "refinancing_interest_be_lower_description": "If the refinanced interest rate is higher than your current interest rate, you won’t be saving any money.",
    "refinancing_interest_rate_comfortable": "Is your interest rate lower than 4% and are you very comfortable making your monthly payments?",
    "refinancing_interest_rate_comfortable_description": "If yes, we suggest making larger payments each month towards your loans with the highest interest rates. You will pay them off faster and save on interest.",
    "refinancing_lendkey_offer_best": "Once you select the loan offer that is best for your budget, you’ll be asked to upload the documents you gathered above. These documents will be reviewed and verified by a loan specialist in about 1-2 business days and you’ll get an email with a link to sign your loan agreement via DocuSign (a digital signature service).",
    "refinancing_loan_balance_at_least": "Is your loan balance at least $5,000?",
    "refinancing_loan_balance_at_least_description": "Refinancing companies usually won’t refinance loan amounts smaller than this.",
    "refinancing_not_for_profit": "At LendKey, you’ll fill out one form to see what rates you qualify for in about 2 minutes. The rates are gathered by LendKey in a matter of seconds from their network of hundreds of lenders, including non-for-profit credit unions and community banks.",
    "refinancing_other_considerations": "Other Considerations",
    "refinancing_refinance_request": "Refinance Request",
    "refinancing_should_i": "Should I Refinance?",
    "refinancing_stable_income": "Do you have a stable income?",
    "refinancing_stable_income_description": "If you refinance federal loans, you’ll lose access to some repayment options such as income-based repayment and protections in death or disability.",
    "repayment_options_need_more_help_description_link": "Tuition.io Strategy Finder.",
    "subsidized_consolidation_federal_stafford": "Subsidized Federal Stafford Loans",
    "unsubsidized_consolidation_federal_stafford": "Unsubsidized Federal Stafford Loans",
    "what_is_consolidation": "What is Consolidation?",
    "what_is_refinancing": "What is Refinancing?"
  },
  "yes": "Yes"
}]];